/*
 * OyeGifts Delivery Widget — clean full JavaScript
 *
 * Keeps delivery data/slot/date/serviceability/cart/add-on behavior in JavaScript.
 * All presentation styles live in the companion CSS file; no runtime style patches.
 *
 * 24 Sep 2026 update: FNP-style location autocomplete. Suggestions are independent
 * of serviceability; JSON/serviceability is checked only after the user selects
 * a location. Google + fallback suggestions run in parallel and tolerate minor typos.
 */

!function() {
    "use strict";
    var nativeAlert = window.alert, savedDeliveryFields = [], bypassActive = !1, savedProductFormValidation = null;
    function normalize(value) {
        return String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
    }
    function canUseLocationOnlyBypass() {
        try {
            return "function" == typeof window.__ogCanProceedWithoutDeliverySelection && !!window.__ogCanProceedWithoutDeliverySelection();
        } catch (e) {
            return !1;
        }
    }
    function openAddonForLocationOnly() {
        try {
            if ("function" == typeof window.__ogTriggerAddonNextStep) return !!window.__ogTriggerAddonNextStep();
        } catch (e) {}
        var form = document.querySelector('form[action*="/cart/add"]');
        try {
            if (form && window.OGAddonPopup && "function" == typeof window.OGAddonPopup.open) return window.OGAddonPopup.open(form), !0;
        } catch (e) {}
        return !1;
    }
    function getBuyNowTrigger(target) {
        if (!target || !target.closest) return null;
        var explicitTrigger = target.closest('.shopify-payment-button__button, [data-buy-now], [data-og-buy-now], .buy-now, .buy-now-button, button[class*="buy-now"], a[class*="buy-now"], [class*="buy_now"], [id*="buy-now"], [id*="buy_now"]');
        if (explicitTrigger) return explicitTrigger;
        var trigger = target.closest('button, input[type="submit"], a, [role="button"]');
        if (!trigger) return null;
        var label = normalize(trigger.value || trigger.textContent || trigger.getAttribute("aria-label") || "");
        return /\bbuy\s*(now|it\s*now)\b/.test(label) ? trigger : null;
    }
    function isRakhiProduct() {
        var productTitle = "", titleNode = document.querySelector("h1.product__title, h1.product-title, [data-product-title], .product-title h1");
        titleNode && (productTitle = titleNode.textContent || "");
        var source = [ window.location.pathname || "", window.location.href || "", document.title || "", productTitle ].join(" ");
        return /rakhi/i.test(source);
    }
    function canBypassDeliveryValidation() {
        return function() {
            if (!isRakhiProduct()) return !1;
            var message = document.getElementById("ogInlineMessage"), text = normalize(message && message.textContent || "");
            return !!isUnavailable() || text.indexOf("please enter the receiver's exact 6-digit pincode") > -1 || text.indexOf("please enter or select an exact 6-digit pincode") > -1 || text.indexOf("pincode not found") > -1 || text.indexOf("city not found") > -1 || text.indexOf("location not found") > -1 || text.indexOf("not serviceable") > -1 || text.indexOf("not available for this location") > -1;
        }();
    }
    function isUnavailable() {
        var input = document.getElementById("ogInlineLocationInput"), message = document.getElementById("ogInlineMessage");
        if (!input || !message || !String(input.value || "").trim()) return !1;
        var text = normalize(message.textContent || "");
        return text.indexOf("delivery is not available") > -1 || text.indexOf("this product cannot be delivered") > -1 || text.indexOf("location not found") > -1;
    }
    function saveField(field) {
        savedDeliveryFields.some(function(item) {
            return item.field === field;
        }) || savedDeliveryFields.push({
            field: field,
            disabled: !!field.disabled,
            required: !!field.required,
            requiredAttr: field.getAttribute("required"),
            ariaRequired: field.getAttribute("aria-required"),
            dataRequired: field.getAttribute("data-required"),
            className: field.className,
            value: field.value
        });
    }
    var lastRakhiBuyTrigger = null, rakhiBuyRetryCount = 0;
    function upsertBypassProperty(form, propertyName, value) {
        if (!form) return null;
        var node = function(form, propertyName) {
            if (!form) return null;
            var fullName = "properties[" + propertyName + "]", found = null;
            return form.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]').forEach(function(node) {
                found || node.name !== fullName || (found = node);
            }), found;
        }(form, propertyName);
        node || ((node = document.createElement("input")).type = "hidden", node.name = "properties[" + propertyName + "]", 
        node.setAttribute("data-og-rakhi-bypass-created", "true"), form.appendChild(node)), 
        node.disabled = !1, node.required = !1, node.removeAttribute("required"), node.removeAttribute("aria-required"), 
        node.removeAttribute("data-required"), node.value = String(null == value ? "" : value);
        try {
            node.setCustomValidity("");
        } catch (e) {}
        return node;
    }
    function setBypassIdValue(id, value) {
        var node = document.getElementById(id);
        if (node) {
            saveField(node), node.disabled = !1, node.required = !1, node.removeAttribute("required"), 
            node.removeAttribute("aria-required"), node.removeAttribute("data-required"), node.value = String(null == value ? "" : value);
            try {
                node.setCustomValidity("");
            } catch (e) {}
        }
    }
    function primeRakhiBypassProperties() {
        if (isRakhiProduct()) {
            var form = document.querySelector('form[action*="/cart/add"]');
            if (form) {
                var locationInput = document.getElementById("ogInlineLocationInput"), rawLocation = String(locationInput && locationInput.value || "").trim(), pinMatch = rawLocation.match(/\b\d{6}\b/), cityValue = rawLocation || "Rakhi Delivery", pinValue = (pinMatch ? pinMatch[0] : "") || "Rakhi";
                setBypassIdValue("ogPropCity", cityValue), setBypassIdValue("ogPropPincode", pinValue), 
                setBypassIdValue("ogPropDate", "Rakhi Delivery"), setBypassIdValue("ogPropType", "Standard Delivery"), 
                setBypassIdValue("ogPropSlot", ""), setBypassIdValue("ogPropChargeSummary", ""), 
                setBypassIdValue("ogPropHiddenType", "rakhi_bypass"), setBypassIdValue("ogPropHiddenCharge", "0"), 
                setBypassIdValue("ogPropHiddenSelected", "1"), upsertBypassProperty(form, "📍 Delivery City", cityValue), 
                upsertBypassProperty(form, "Delivery Pincode", pinValue), upsertBypassProperty(form, "Select Date", "Rakhi Delivery"), 
                upsertBypassProperty(form, "Pick Delivery Type", "Standard Delivery"), upsertBypassProperty(form, "Time Slot", ""), 
                upsertBypassProperty(form, "Delivery Charge", ""), upsertBypassProperty(form, "_og_delivery_type", "rakhi_bypass"), 
                upsertBypassProperty(form, "_og_delivery_total_charge", "0"), upsertBypassProperty(form, "_og_delivery_selected", "1"), 
                upsertBypassProperty(form, "_og_rakhi_location_bypass", "1");
            }
        }
    }
    function enableUnavailableBypass() {
        if (canBypassDeliveryValidation()) {
            var fields, seen;
            bypassActive = !0, primeRakhiBypassProperties(), (fields = [], seen = [], document.querySelectorAll([ "#og-delivery-widget input", "#og-delivery-widget select", "#og-delivery-widget textarea", "#ogPropCity", "#ogPropPincode", "#ogPropDate", "#ogPropType", "#ogPropSlot", "#ogPropChargeSummary", "#ogPropHiddenType", "#ogPropHiddenCharge", "#ogPropHiddenSelected", 'input[name^="properties[📍 Delivery City]"]', 'input[name^="properties[Delivery Pincode]"]', 'input[name^="properties[Select Date]"]', 'input[name^="properties[Pick Delivery Type]"]', 'input[name^="properties[Time Slot]"]', 'input[name^="properties[Delivery Charge]"]', 'input[name^="properties[_og_delivery_"]' ].join(",")).forEach(function(field) {
                !field || seen.indexOf(field) > -1 || "ogInlineLocationInput" !== field.id && (seen.push(field), 
                fields.push(field));
            }), fields).forEach(function(field) {
                saveField(field), field.required = !1, field.removeAttribute("required"), field.removeAttribute("aria-required"), 
                field.removeAttribute("data-required"), field.classList && field.classList.remove("required", "is-required", "field--required", "field-error", "field--error", "error", "invalid", "is-invalid");
                try {
                    field.setCustomValidity("");
                } catch (e) {}
            });
            var form = document.querySelector('form[action*="/cart/add"]');
            form && (savedProductFormValidation || (savedProductFormValidation = {
                form: form,
                hadNoValidateAttr: form.hasAttribute("novalidate"),
                noValidate: !!form.noValidate
            }), form.setAttribute("novalidate", "novalidate"), form.noValidate = !0), removeRequiredMessage();
        }
    }
    function removeRequiredMessage() {
        var phrases = [ "please fill this required option", "please fill required option", "please fill this option" ];
        document.querySelectorAll("body *").forEach(function(node) {
            if (node && !node.children.length) {
                var text = normalize(node.textContent || "");
                if (text && phrases.some(function(phrase) {
                    return text.indexOf(phrase) > -1;
                })) {
                    var wrapper = node.closest('.field-error, .field--error, .error, .errors, [class*="error"]') || node;
                    wrapper.style.display = "none", wrapper.setAttribute("data-og-hidden-required-error", "true");
                }
            }
        });
    }
    function prepareNativeFlow(event) {
        var target;
        canBypassDeliveryValidation() && ((((target = event.target) && target.closest ? target.closest('button[type="submit"], input[type="submit"], button[name="add"], .shopify-payment-button__button, [data-buy-now], [data-add-to-cart], a[class*="buy"], div[class*="buy-now"]') : null) || "submit" === event.type) && enableUnavailableBypass());
    }
    function syncBypassState() {
        canBypassDeliveryValidation() ? enableUnavailableBypass() : function() {
            if (bypassActive) {
                if (savedDeliveryFields.forEach(function(item) {
                    var field = item.field;
                    field && field.isConnected && (field.disabled = item.disabled, field.required = item.required, 
                    null !== item.requiredAttr ? field.setAttribute("required", item.requiredAttr) : field.removeAttribute("required"), 
                    null !== item.ariaRequired ? field.setAttribute("aria-required", item.ariaRequired) : field.removeAttribute("aria-required"), 
                    null !== item.dataRequired ? field.setAttribute("data-required", item.dataRequired) : field.removeAttribute("data-required"), 
                    field.className = item.className, Object.prototype.hasOwnProperty.call(item, "value") && (field.value = item.value));
                }), document.querySelectorAll('[data-og-rakhi-bypass-created="true"]').forEach(function(node) {
                    node && node.parentNode && node.parentNode.removeChild(node);
                }), savedProductFormValidation) {
                    var savedForm = savedProductFormValidation.form;
                    savedForm && savedForm.isConnected && (savedForm.noValidate = savedProductFormValidation.noValidate, 
                    savedProductFormValidation.hadNoValidateAttr ? savedForm.setAttribute("novalidate", "novalidate") : savedForm.removeAttribute("novalidate")), 
                    savedProductFormValidation = null;
                }
                savedDeliveryFields = [], bypassActive = !1;
            }
        }();
    }
    window.__ogUnavailableLocation = isUnavailable, window.__ogCanBypassDeliveryValidation = canBypassDeliveryValidation, 
    window.__ogPrepareUnavailableNativeFlow = enableUnavailableBypass, window.__ogSyncUnavailableBypass = syncBypassState, 
    window.alert = function(message) {
        var text = normalize(message || ""), isDeliveryValidationAlert = text.indexOf("please select pincode") > -1 || text.indexOf("please select date, type, slot first") > -1 || text.indexOf("please select date type slot first") > -1 || text.indexOf("please select pincode, date, type, slot first") > -1 || text.indexOf("please select pincode date type slot first") > -1 || text.indexOf("please enter pincode") > -1 || text.indexOf("please choose delivery") > -1 || text.indexOf("please select slot first") > -1 || text.indexOf("please select time slot") > -1 || text.indexOf("please select date first") > -1 || text.indexOf("please select type first") > -1 || text.indexOf("please select delivery type") > -1;
        if (canUseLocationOnlyBypass() && isDeliveryValidationAlert) return void setTimeout(function() {
            openAddonForLocationOnly();
        }, 0);
        return canBypassDeliveryValidation() && (text.indexOf("please fill required option") > -1 || text.indexOf("please fill this required option") > -1 || text.indexOf("please fill this option") > -1 || text.indexOf("please fill required") > -1 || isDeliveryValidationAlert) ? (enableUnavailableBypass(), 
        primeRakhiBypassProperties(), removeRequiredMessage(), void (lastRakhiBuyTrigger && lastRakhiBuyTrigger.isConnected && rakhiBuyRetryCount < 1 && (rakhiBuyRetryCount += 1, 
        setTimeout(function() {
            try {
                lastRakhiBuyTrigger.click();
            } catch (e) {}
        }, 0)))) : isDeliveryValidationAlert ? (window.__ogPendingDeliveryValidationFocus = !0, 
        void ("function" == typeof window.__ogFocusDeliveryMissingStep && setTimeout(function() {
            try {
                window.__ogFocusDeliveryMissingStep();
            } catch (e) {}
        }, 0))) : nativeAlert.apply(window, arguments);
    }, window.addEventListener("pointerdown", prepareNativeFlow, !0), window.addEventListener("click", prepareNativeFlow, !0), 
    window.addEventListener("click", function(event) {
        var locationOnlyTrigger = canUseLocationOnlyBypass() ? getBuyNowTrigger(event.target) : null;
        if (locationOnlyTrigger) return event.preventDefault(), event.stopPropagation(), 
        "function" == typeof event.stopImmediatePropagation && event.stopImmediatePropagation(), void setTimeout(function() {
            openAddonForLocationOnly();
        }, 0);
        if (canBypassDeliveryValidation()) {
            var trigger = getBuyNowTrigger(event.target);
            trigger && (event && !0 === event.isTrusted && (rakhiBuyRetryCount = 0), lastRakhiBuyTrigger = trigger, 
            enableUnavailableBypass(), primeRakhiBypassProperties(), removeRequiredMessage(), 
            trigger.setAttribute("data-og-rakhi-location-bypass", "1"));
        }
    }, !0), window.addEventListener("submit", prepareNativeFlow, !0), window.addEventListener("invalid", function(event) {
        if (canBypassDeliveryValidation()) {
            var root = document.getElementById("og-delivery-widget");
            root && (root.contains(event.target) || /^ogProp/.test(String(event.target && event.target.id || ""))) && (event.preventDefault(), 
            enableUnavailableBypass());
        }
    }, !0), document.addEventListener("input", function(event) {
        event.target && "ogInlineLocationInput" === event.target.id && setTimeout(syncBypassState, 0);
    }, !0), document.addEventListener("click", function(event) {
        event.target && event.target.closest && event.target.closest("#ogInlineResetBtn") && setTimeout(syncBypassState, 0);
    }, !0);
    var bypassSyncTimer = null, messageObserver = null, observedMessage = null, mountObserver = null;
    function scheduleBypassSync(delay) {
        clearTimeout(bypassSyncTimer), bypassSyncTimer = setTimeout(function() {
            syncBypassState(), canBypassDeliveryValidation() && removeRequiredMessage();
        }, Number(delay || 40));
    }
    function observeUnavailableMessage() {
        var message = document.getElementById("ogInlineMessage");
        return message && message !== observedMessage ? (messageObserver && messageObserver.disconnect(), 
        observedMessage = message, (messageObserver = new MutationObserver(function() {
            scheduleBypassSync(30);
        })).observe(message, {
            childList: !0,
            subtree: !0,
            characterData: !0
        }), scheduleBypassSync(0), !0) : !!message;
    }
    function addedNodeContainsDeliveryWidget(node) {
        return !(!node || 1 !== node.nodeType) && ("og-delivery-widget" === node.id || "ogInlineMessage" === node.id || !(!node.querySelector || !node.querySelector("#og-delivery-widget, #ogInlineMessage")));
    }
    function mountUnavailableObserver() {
        if (!isRakhiProduct()) return;
        observeUnavailableMessage(), document.body && !mountObserver && (mountObserver = new MutationObserver(function(mutations) {
            mutations.some(function(mutation) {
                return Array.prototype.some.call(mutation.addedNodes || [], addedNodeContainsDeliveryWidget);
            }) && observeUnavailableMessage();
        })).observe(document.body, {
            childList: !0,
            subtree: !0
        });
    }
    "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", mountUnavailableObserver, {
        once: !0
    }) : mountUnavailableObserver();
}(), window.initOgGooglePlacesDelivery = function() {
    window.__ogGooglePlacesReady = !0, "function" == typeof window.__initOgDeliveryCore && window.__initOgDeliveryCore();
}, function() {
    "use strict";
    var SELECTION_CACHE_KEY = "og_delivery_selection_v24", DRAFT_LOCATION_CACHE_KEY = "og_delivery_location_draft_v1", SELECTION_COOKIE_KEY = "og_delivery_selection_backup_v14", LEGACY_SELECTION_CACHE_KEYS = [ "og_delivery_selection_v11", "og_delivery_selection_v12", "og_delivery_selection_v13", "og_delivery_selection_v14", "og_delivery_selection_v15", "og_delivery_selection_v16", "og_delivery_selection_v17", "og_delivery_selection_v18", "og_delivery_selection_v19", "og_delivery_selection_v20", "og_delivery_selection_v21", "og_delivery_selection_v22", "og_delivery_selection_v23", "og_delivery_selection_v24" ], LEGACY_SELECTION_COOKIE_KEYS = [ "og_delivery_selection_backup_v3", "og_delivery_selection_backup_v4", "og_delivery_selection_backup_v5", "og_delivery_selection_backup_v6", "og_delivery_selection_backup_v7", "og_delivery_selection_backup_v8", "og_delivery_selection_backup_v9", "og_delivery_selection_backup_v10", "og_delivery_selection_backup_v11", "og_delivery_selection_backup_v12", "og_delivery_selection_backup_v13", "og_delivery_selection_backup_v14" ];
    function pad(n) {
        return String(n).padStart(2, "0");
    }
    function now() {
        return new Date;
    }
    function todayDate() {
        var d = now();
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }
    function ymd(d) {
        return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
    }
    function normalize(v) {
        return String(v || "").toLowerCase().replace(/\s+/g, " ").trim();
    }
    function keyNorm(v) {
        return String(v || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "").trim();
    }
    function escapeHtml(v) {
        return String(v || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    function extractPincode(v) {
        var m = String(v || "").match(/\b([1-9]\d{2})\s?(\d{3})\b/);
        return m ? m[1] + m[2] : "";
    }
    function money(v, currency) {
        var n = Number(v || 0);
        return Number.isFinite(n) || (n = 0), (currency || "₹") + String(n);
    }
    function buildReadableLocation(parts) {
        var out = [];
        return (parts || []).forEach(function(item) {
            (item = String(item || "").trim()) && -1 === out.indexOf(item) && out.push(item);
        }), out.join(", ");
    }
    function buildResolvedLocationLabel(pin, locationLabel, fallbackCity) {
        pin = String(pin || "").trim();
        var label = String(locationLabel || "").trim(), city = String(fallbackCity || "").trim();
        return (label = label.replace(/\b\d{6}\b\s*,?\s*/g, "").replace(/^\s*,\s*|\s*,\s*$/g, "").replace(/\s*,\s*/g, ", ").replace(/\s+/g, " ").trim()) || (label = city), 
        buildReadableLocation([ pin, label ]);
    }
    function buildCanonicalRowLabel(row, pinOverride) {
        row = row || {};
        var pin = String(pinOverride || row.pincode || "").trim(), area = String(row.locality || row.area || "").trim(), city = String(row.city || row.district || "").trim(), stateName = String(row.state || "").trim(), country = String(row.country || "India").trim() || "India";
        area && city && normalize(area) === normalize(city) && (area = ""), city && stateName && normalize(city) === normalize(stateName) && (city = ""), 
        isIndiaCountry(country) || (country = "India");
        var canonical = buildReadableLocation([ /^\d{6}$/.test(pin) ? pin : "", area, city, stateName, country ]);
        return canonical || buildResolvedLocationLabel(pin, row.displayAddress || row.displayMeta || row.rawLocation || "", row.city || "");
    }
    var INDIAN_STATE_NAMES = [ "andhra pradesh", "arunachal pradesh", "assam", "bihar", "chhattisgarh", "goa", "gujarat", "haryana", "himachal pradesh", "jharkhand", "karnataka", "kerala", "madhya pradesh", "maharashtra", "manipur", "meghalaya", "mizoram", "nagaland", "odisha", "punjab", "rajasthan", "sikkim", "tamil nadu", "telangana", "tripura", "uttar pradesh", "uttarakhand", "west bengal", "delhi", "jammu and kashmir", "ladakh", "andaman and nicobar islands", "chandigarh", "dadra and nagar haveli and daman and diu", "daman and diu", "lakshadweep", "puducherry" ];
    function cleanAddressPart(value) {
        return String(value || "").replace(/\b\d{6}\b/g, "").replace(/\s+/g, " ").replace(/^\s*[,-]+\s*|\s*[,-]+\s*$/g, "").trim();
    }
    function isIndiaCountry(value) {
        var n = normalize(value).replace(/[.]/g, "");
        return "india" === n || "ind" === n || "bharat" === n;
    }
    function isIndianState(value) {
        var n = normalize(value).replace(/[.]/g, "");
        return !!n && (INDIAN_STATE_NAMES.indexOf(n) > -1 || INDIAN_STATE_NAMES.some(function(stateName) {
            return n === stateName + " state";
        }));
    }
    function splitAddressParts(value) {
        return String(value || "").replace(/\b\d{6}\b/g, "").split(/[,|;>]+/).map(cleanAddressPart).filter(Boolean);
    }
    function searchableText(row) {
        return normalize([ row.rawLocation, row.displayAddress, row.locality, row.area, row.city, row.district, row.state, row.country, row.pincode ].join(" "));
    }
    function queryTokens(value) {
        return normalize(value).replace(/[^a-z0-9]+/g, " ").split(" ").filter(Boolean);
    }
    function formatMetaDate(d) {
        return d.toLocaleDateString("en-IN", {
            weekday: "short",
            day: "numeric",
            month: "short"
        });
    }
    function formatSelectedDateLabel(d) {
        var t = todayDate(), tm = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1);
        return ymd(d) === ymd(t) ? "Today, " + formatMetaDate(d) : ymd(d) === ymd(tm) ? "Tomorrow, " + formatMetaDate(d) : formatMetaDate(d);
    }
    function fetchJson(url, options) {
        return fetch(url, options || {}).then(function(res) {
            return res.ok ? res.json() : res.text().then(function(txt) {
                throw new Error(txt || "HTTP " + res.status);
            });
        });
    }
    function fetchCart() {
        return fetchJson("/cart.js", {
            credentials: "same-origin",
            cache: "no-store",
            headers: {
                Accept: "application/json"
            }
        });
    }
    function markFeeLinesInDom() {
        document.querySelectorAll([ "[data-cart-item]", ".cart-item", ".drawer__item", ".mini-cart__item", ".ajaxcart__product", ".cart-drawer__item", ".cart__item", '[class*="cart-item"]', '[class*="CartItem"]' ].join(",")).forEach(function(line) {
            if ("true" !== line.getAttribute("data-og-delivery-fee-line")) {
                var text = normalize(line.textContent || "");
                (text.indexOf("delivery fee") > -1 || text.indexOf("shipping fee") > -1 || text.indexOf("_og_delivery_fee") > -1) && (line.setAttribute("data-og-delivery-fee-line", "true"), 
                line.classList.add("og-hide-delivery-fee-line"));
            }
        });
    }
    var feeLineScanTimer = null;
    function scheduleFeeLineScan(delay) {
        clearTimeout(feeLineScanTimer), feeLineScanTimer = setTimeout(markFeeLinesInDom, Number(delay || 100));
    }
    function initOgDelivery() {
        var root = document.getElementById("og-delivery-widget"), config = function() {
            var node = document.getElementById("og-delivery-config");
            if (!node) return console.error("[OG Delivery] Missing #og-delivery-config"), null;
            try {
                return JSON.parse(node.textContent || "{}");
            } catch (e) {
                return console.error("[OG Delivery] Invalid config JSON", e), null;
            }
        }();
        if (root && config && "true" === root.getAttribute("data-og-enabled")) if (root.__ogMounted) "function" == typeof root.__ogSoftRestore && root.__ogSoftRestore(); else {
            root.__ogMounted = !0;
            var currency = config.currencySymbol || "₹", sheetUrl = config.sheetUrl || "", sheetCacheTtlMs = Number(config.sheetCacheTtlMs || 108e5), sheetStaleCacheTtlMs = Number(config.sheetStaleCacheTtlMs || 864e5), deliveryFeeProductId = Number(config.deliveryFeeProductId || 0), feeVariantByAmount = config.feeVariantByAmount || {}, productForm = root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'), els = {
                input: document.getElementById("ogInlineLocationInput"),
                reset: document.getElementById("ogInlineResetBtn"),
                msg: document.getElementById("ogInlineMessage"),
                suggestions: document.getElementById("ogLocationSuggestions"),
                flow: document.getElementById("ogDeliveryFlow"),
                dateOptions: document.getElementById("ogDateOptions"),
                typeOptions: document.getElementById("ogTypeOptions"),
                slotTitle: document.getElementById("ogSlotTitle"),
                slotOptions: document.getElementById("ogSlotOptions"),
                summary: document.getElementById("ogDeliverySummary"),
                selectedLines: document.getElementById("ogSelectedLines"),
                modify: document.getElementById("ogDeliveryModify"),
                calendarPanel: document.getElementById("ogCalendarPanel"),
                calendarOverlay: document.getElementById("ogCalendarOverlay"),
                calendarClose: document.getElementById("ogCalendarClose"),
                calendarPrev: document.getElementById("ogCalendarPrev"),
                calendarNext: document.getElementById("ogCalendarNext"),
                calendarMonthLabel: document.getElementById("ogCalendarMonthLabel"),
                calendarDays: document.getElementById("ogCalendarDays"),
                propCity: document.getElementById("ogPropCity"),
                propPincode: document.getElementById("ogPropPincode"),
                propDate: document.getElementById("ogPropDate"),
                propType: document.getElementById("ogPropType"),
                propSlot: document.getElementById("ogPropSlot"),
                propChargeSummary: document.getElementById("ogPropChargeSummary"),
                propHiddenType: document.getElementById("ogPropHiddenType"),
                propHiddenCharge: document.getElementById("ogPropHiddenCharge"),
                propHiddenSelected: document.getElementById("ogPropHiddenSelected")
            };
            els.input && (els.input.setAttribute("spellcheck", "false"), els.input.setAttribute("autocorrect", "off"), 
            els.input.setAttribute("autocapitalize", "words"), els.input.setAttribute("placeholder", "Enter city, area, state or 6 digit pincode"));
            var base, custom, sheetRows = [], activeSuggestions = [], suggestionTimer = null, suggestionRequestId = 0, googleRequestToken = 0, googleDetailsToken = 0, googleAutocompleteService = null, googlePlacesService = null, googleGeocoder = null, googleSessionToken = null, fallbackRequestToken = 0, fallbackAbortController = null, fallbackResolveToken = 0, photonReversePinCache = {}, postalSearchToken = 0, postalSearchAbortController = null, postalSearchCache = {}, nominatimPincodeCache = {}, locationSuggestionCache = {}, locationSuggestionCacheOrder = [], locationSelectionToken = 0, locationResolving = !1, mobileLocation = {
                sheet: null,
                dialog: null,
                input: null,
                clear: null,
                suggestions: null,
                message: null,
                confirm: null,
                later: null,
                foot: null,
                flowMount: null,
                flowPlaceholder: null,
                open: !1,
                timer: null,
                resolving: !1
            }, locationPinOverrides = (base = {}, custom = config.locationPinOverrides || config.locationPincodeOverrides || {}, 
            Object.keys(custom).forEach(function(key) {
                var pin = String(custom[key] || "").trim();
                /^\d{6}$/.test(pin) && (base[keyNorm(key)] = pin);
            }), base), state = {
                matchedLocation: null,
                selectedDate: "",
                selectedDateLabel: "",
                selectedType: "",
                selectedSlot: null,
                finalCharge: 0,
                finalChargeLabel: "",
                calendarMonth: null
            }, externalPinApplyToken = 0, isEditingDeliverySelection = !1, restoredSelectionLocked = !1, preferredTypeOrder = [ "express", "fixed_time", "morning", "midnight", "free_slot", "standard", "next_day_delivery", "remote_delivery" ], deliveryValidationTimer = null;
            window.__ogFocusDeliveryMissingStep = function() {
                return window.__ogPendingDeliveryValidationFocus = !1, focusFirstMissingDeliveryStep();
            }, window.__ogPendingDeliveryValidationFocus && setTimeout(function() {
                try {
                    window.__ogFocusDeliveryMissingStep();
                } catch (e) {}
            }, 0);
            var nativeFeeSyncTimer = null, cartChargeTimer = null, cartChargeRendering = !1;
            window.__ogRenderCartDeliveryCharges = scheduleCartChargeRender, [ "cart:open", "cart:refresh", "cart:updated", "cart:change", "ajaxCart:updated" ].forEach(function(name) {
                document.addEventListener(name, function() {
                    scheduleCartChargeRender(120);
                }), window.addEventListener(name, function() {
                    scheduleCartChargeRender(120);
                });
            }), document.addEventListener("click", function(event) {
                event.target && event.target.closest && event.target.closest('.header__icon--cart, [data-cart-drawer-trigger], a[href="/cart"], button[name="cart"], [class*="quantity"], [class*="remove"]') && (scheduleCartChargeRender(100), 
                scheduleFeeLineScan(120));
            });
            var cartMutationSelector = '#CartDrawer, cart-drawer, .cart-drawer, [id^="CartDrawerBody-"], [data-cart-item], .cart-item, .drawer__item, .mini-cart__item, .ajaxcart__product, .cart-drawer__item, .cart__item', cartObserverRoot = document.querySelector('#CartDrawer, cart-drawer, .cart-drawer, [id^="CartDrawerBody-"]');
            cartObserverRoot && new MutationObserver(function(mutations) {
                mutations.some(isCartMutation) && (scheduleFeeLineScan(80), scheduleCartChargeRender(140));
            }).observe(cartObserverRoot, {
                childList: !0,
                subtree: !0
            }), scheduleCartChargeRender(350), scheduleFeeLineScan(380);
            var selectionRefreshTimer = null, summaryVerifyTimer = null, mobileObstructionStyles = [];
            root.__ogSoftRestore = function() {
                bootSheetRows().then(function() {
                    restoreSelection() || restoreDraftLocation() || renderAll(), markFeeLinesInDom();
                });
            }, bootSheetRows().then(function() {
                bindEvents(), restoreSelection() || restoreDraftLocation() || renderAll(), toggleReset(), markFeeLinesInDom(), 
                function() {
                    if (!selectionRefreshTimer) {
                        var interval = Number(config.selectionRefreshIntervalMs || 9e5);
                        (!Number.isFinite(interval) || interval < 6e4) && (interval = 9e5), selectionRefreshTimer = window.setInterval(refreshActiveDeliverySelection, interval);
                    }
                }(), root.__ogApplyExternalPincode = applyExternalPincode, root.__ogClearExternalPincode = clearExternalPincode;
                try {
                    window.dispatchEvent(new CustomEvent("og-delivery:ready", {
                        detail: {
                            rootId: "og-delivery-widget"
                        }
                    }));
                } catch (e) {}
            }), scheduleFeeLineScan(120);
        }
        function dispatchProductLocationEvent(name, detail) {
            try {
                window.dispatchEvent(new CustomEvent(name, {
                    detail: Object.assign({
                        source: "og-product-delivery-core"
                    }, detail || {})
                }));
            } catch (e) {}
        }
        function notifyProductLocationSelected() {
            state.matchedLocation && dispatchProductLocationEvent("oyegifts:product-location-selected", {
                pin: String(state.matchedLocation.pincode || "").trim(),
                pincode: String(state.matchedLocation.pincode || "").trim(),
                city: String(state.matchedLocation.city || "").trim(),
                state: String(state.matchedLocation.state || "").trim(),
                area: String(state.matchedLocation.locality || state.matchedLocation.area || "").trim(),
                address: getLocationLabel()
            });
        }
        function isUnavailableLocation() {
            return "function" == typeof window.__ogUnavailableLocation && window.__ogUnavailableLocation();
        }
        function isServiceabilityValidationEnabled() {
            var value = config.validateServiceability;
            if ("boolean" == typeof value) return value;
            var normalized = normalize(value);
            return normalized ? -1 === [ "false", "no", "off", "0" ].indexOf(normalized) : !0;
        }
        function isCurrentLocationNonServiceable() {
            return !!(state.matchedLocation && !1 === state.matchedLocation.isJsonServiceable) || isUnavailableLocation();
        }
        function isJsonMatchedLocation() {
            return !!(state.matchedLocation && !0 === state.matchedLocation.isJsonServiceable);
        }
        function shouldHideDeliveryFlowForLocation() {
            return !!state.matchedLocation && !isJsonMatchedLocation();
        }
        function canProceedWithoutDeliverySelection() {
            return !isServiceabilityValidationEnabled() && !!state.matchedLocation && !isJsonMatchedLocation();
        }
        function getCurrentProductForm() {
            return root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]') || productForm;
        }
        var addonNextStepTriggering = !1;
        function triggerAddonNextStep() {
            var form = getCurrentProductForm();
            if (!form || addonNextStepTriggering) return !1;
            addonNextStepTriggering = !0;
            var release = function(delay) {
                setTimeout(function() {
                    addonNextStepTriggering = !1;
                }, Number(delay || 0));
            };
            try {
                if (window.OGAddonPopup && "function" == typeof window.OGAddonPopup.open) {
                    var result = window.OGAddonPopup.open(form);
                    result && "function" == typeof result.finally ? result.finally(function() {
                        release(120);
                    }) : release(320);
                    return !0;
                }
            } catch (e) {
                addonNextStepTriggering = !1;
            }
            var button = form.querySelector('button[name="add"], .product-form__submit, [data-add-to-cart], [data-product-submit], button[type="submit"], input[type="submit"]');
            if (!button || button.disabled || "true" === button.getAttribute("aria-disabled")) return addonNextStepTriggering = !1, !1;
            setTimeout(function() {
                try {
                    button.click();
                } catch (e) {}
                release(120);
            }, 0);
            return !0;
        }
        window.__ogCanProceedWithoutDeliverySelection = canProceedWithoutDeliverySelection;
        window.__ogTriggerAddonNextStep = triggerAddonNextStep;
        function syncDeliveryFlowVisibility() {
            if (!els.flow) return;
            !function() {
                if (els.flow && els.dateOptions) {
                    for (var section = els.dateOptions; section.parentElement && section.parentElement !== els.flow; ) section = section.parentElement;
                    section && section.parentElement === els.flow && section.setAttribute("data-og-date-section", "true");
                }
            }();
            var jsonMatched = isJsonMatchedLocation(), hideFlow = shouldHideDeliveryFlowForLocation(), typeSection = getDeliverySection(els.typeOptions);
            if (hideFlow) {
                els.flow.hidden = !0;
                els.flow.setAttribute("hidden", "hidden");
                els.flow.style.setProperty("display", "none", "important");
                els.flow.classList.remove("is-location-pending");
                typeSection && (typeSection.hidden = !0);
                els.typeOptions && (els.typeOptions.innerHTML = "");
                els.slotOptions && (els.slotOptions.innerHTML = "");
                els.slotTitle && (els.slotTitle.textContent = "");
                var hiddenSlotPanel = els.slotOptions && els.slotOptions.closest ? els.slotOptions.closest(".og-delivery__slot-panel") : null;
                hiddenSlotPanel && (hiddenSlotPanel.hidden = !0, hiddenSlotPanel.setAttribute("aria-hidden", "true"));
                return;
            }
            els.flow.hidden = !1;
            els.flow.removeAttribute("hidden");
            els.flow.style.removeProperty("display");
            els.flow.classList.toggle("is-location-pending", !jsonMatched);
            typeSection && (typeSection.hidden = !jsonMatched);
            if (!jsonMatched) {
                els.typeOptions && (els.typeOptions.innerHTML = "");
                els.slotOptions && (els.slotOptions.innerHTML = "");
                els.slotTitle && (els.slotTitle.textContent = "");
                var slotPanel = els.slotOptions && els.slotOptions.closest ? els.slotOptions.closest(".og-delivery__slot-panel") : null;
                slotPanel && (slotPanel.hidden = !0, slotPanel.setAttribute("aria-hidden", "true"));
            }
        }
        function getCourierFallbackUrl() {
            return String(config.courierFallbackUrl || "https://shorturl.at/3aNav").trim() || "https://shorturl.at/3aNav";
        }
        function setMobileUnavailableMsg(pin) {
            if (void 0 !== mobileLocation && mobileLocation.message) {
                var cleanPin = /^\d{6}$/.test(String(pin || "").trim()) ? String(pin).trim() : "", destinationText = cleanPin ? "See Available Gifts To " + cleanPin : "See Available Gifts", fallbackUrl = getCourierFallbackUrl();
                mobileLocation.message.className = "og-mobile-location-sheet__message is-unavailable", 
                mobileLocation.message.innerHTML = '<div class="og-unavailable-notice"><span>This product cannot be delivered.</span><a href="' + escapeHtml(fallbackUrl) + '" class="og-unavailable-notice__link">' + escapeHtml(destinationText) + "</a></div>";
            }
        }
        function setUnavailableMsg(pin) {
            if (els.msg) {
                var cleanPin = /^\d{6}$/.test(String(pin || "").trim()) ? String(pin).trim() : "", destinationText = cleanPin ? "See Available Gifts To " + cleanPin : "See Available Gifts", fallbackUrl = getCourierFallbackUrl();
                els.msg.innerHTML = '<div class="og-unavailable-notice"><span>This product cannot be delivered.</span><a href="' + escapeHtml(fallbackUrl) + '" class="og-unavailable-notice__link">' + escapeHtml(destinationText) + "</a></div>", 
                els.msg.className = "og-delivery__inline-message is-unavailable", setMobileUnavailableMsg(cleanPin);
            }
        }
        function setMsg(text, type) {
            els.msg && (els.msg.textContent = text || "", els.msg.className = "og-delivery__inline-message" + (type ? " is-" + type : "")), 
            setMobileLocationMessage(text || "", type || "");
        }
        function setValue(node, value) {
            node && (node.value = value || "");
        }
        function updateFormProperty(name, value) {
            var node = function(name) {
                var form = getCurrentProductForm();
                if (!form) return null;
                var fullName = "properties[" + name + "]", node = form.querySelector('input[name="' + fullName + '"]');
                return node || ((node = document.createElement("input")).type = "hidden", node.name = fullName, 
                form.appendChild(node)), node;
            }(name);
            node && (node.value = value || "");
        }
        function pickFromObject(obj, names) {
            var normalized = {};
            Object.keys(obj || {}).forEach(function(key) {
                normalized[keyNorm(key)] = obj[key];
            });
            for (var i = 0; i < names.length; i++) {
                var val = normalized[keyNorm(names[i])];
                if (null != val && "" !== String(val).trim()) return val;
            }
            return "";
        }
        function transformRows(rows) {
            return (Array.isArray(rows) ? rows : []).map(function(row) {
                var location = String(pickFromObject(row, [ "DeliveryData", "Delivery Data", "Location", "Service Area", "Delivery Location", "Full Address", "Address", "City Pincode" ]) || "").trim(), localityFromCol = cleanAddressPart(pickFromObject(row, [ "Locality", "Local Area", "Area Name", "Neighbourhood", "Neighborhood", "Sublocality", "Sub Locality" ])), areaFromCol = cleanAddressPart(pickFromObject(row, [ "Area", "Delivery Area", "Service Area Name", "Region" ])), cityFromCol = String(pickFromObject(row, [ "City", "Town", "Location City", "City Name" ]) || "").trim(), districtFromCol = cleanAddressPart(pickFromObject(row, [ "District", "City District", "Location District" ])), stateFromCol = cleanAddressPart(pickFromObject(row, [ "State", "State Name", "Province", "Location State" ])), countryFromCol = cleanAddressPart(pickFromObject(row, [ "Country", "Country Name" ])), pin = extractPincode(String(pickFromObject(row, [ "Pincode", "Pin Code", "PinCode", "PIN", "Pin", "Postal Code", "PostalCode", "Postcode", "Postal", "Zip", "Zipcode", "ZIP Code", "Pincode Number", "Pincode No", "Postal Pincode" ]) || "").trim()) || extractPincode(location), addressParts = splitAddressParts(location), state = stateFromCol || addressParts.filter(isIndianState)[0] || "", country = countryFromCol || addressParts.filter(isIndiaCountry)[0] || "India", stateIndex = state ? addressParts.findIndex(function(part) {
                    return normalize(part) === normalize(state);
                }) : -1, city = cityFromCol || districtFromCol || (stateIndex > 0 ? addressParts[stateIndex - 1] : addressParts[0]) || "";
                city = cleanAddressPart(city);
                var locality = localityFromCol || (areaFromCol && normalize(areaFromCol) !== normalize(city) ? areaFromCol : "") || (addressParts.length > 1 && normalize(addressParts[0]) !== normalize(city) ? addressParts[0] : ""), district = districtFromCol || "";
                location || (location = buildReadableLocation([ locality, city, state, country, pin ]));
                var displayAddress = buildReadableLocation([ locality, city, district, state, country ]);
                function p(names) {
                    return function(v) {
                        if (!0 === v) return 1;
                        if (!1 === v || null == v) return 0;
                        var raw = String(v).trim(), compact = raw.replace(/\s+/g, "").toLowerCase();
                        if (/^(yes|y|true|available|serviceable|enabled)$/i.test(raw)) return 1;
                        if (/^(no|n|false|na|n\/a|notavailable|disabled)$/i.test(compact)) return 0;
                        var n = Number(raw.replace(/[₹,\s]/g, ""));
                        return Number.isFinite(n) ? n : 0;
                    }(pickFromObject(row, names));
                }
                displayAddress || (displayAddress = cleanAddressPart(location) || city), city || (city = locality || displayAddress);
                var obj = {
                    rawLocation: location,
                    city: city,
                    locality: locality,
                    area: areaFromCol || locality,
                    district: district,
                    state: state,
                    country: country,
                    pincode: pin,
                    displayAddress: displayAddress,
                    displayMeta: displayAddress,
                    isJsonServiceable: !0,
                    morning: p([ "Morning Delivery", "Morning" ]),
                    morningCharge: p([ "Morning Charge", "Morning Delivery Charge", "Morning Price" ]),
                    express: p([ "Express Delivery", "Express" ]),
                    expressCharge: p([ "Express Charge", "Express Delivery Charge", "Express Price" ]),
                    standard: p([ "Standard Delivery", "Standard" ]),
                    standardCharge: p([ "Standard Charge", "Standard Delivery Charge", "Standard Price" ]),
                    fixedTime: p([ "Fixed Time Delivery", "Fixed Time", "Fixed" ]),
                    fixedTimeCharge: p([ "Fixed Time Charge", "Fixed Time Delivery Charge", "Fixed Price" ]),
                    midnight: p([ "Midnight Delivery", "Midnight" ]),
                    midnightCharge: p([ "Midnight Charge", "Midnight Delivery Charge", "Midnight Price" ]),
                    freeSlot: p([ "Free Slot", "FreeSlot", "Free" ]),
                    nextDay: p([ "Next Day Delivery", "Next Day", "NextDay" ]),
                    nextDayCharge: p([ "Next Day Charge", "Next Day Delivery Charge", "NextDay Charge", "Next Day Price" ]),
                    remoteDelivery: p([ "Remote Delivery", "Remote" ]),
                    remoteCharge: p([ "Remote Charge", "Remote Area Charge", "Remote Delivery Charge", "Remote Price" ])
                };
                return obj.express > 1 && !obj.expressCharge && (obj.expressCharge = obj.express), 
                obj.morning > 1 && !obj.morningCharge && (obj.morningCharge = obj.morning), obj.standard > 1 && !obj.standardCharge && (obj.standardCharge = obj.standard), 
                obj.fixedTime > 1 && !obj.fixedTimeCharge && (obj.fixedTimeCharge = obj.fixedTime), 
                obj.midnight > 1 && !obj.midnightCharge && (obj.midnightCharge = obj.midnight), 
                obj.nextDay > 1 && !obj.nextDayCharge && (obj.nextDayCharge = obj.nextDay), obj.remoteDelivery > 1 && !obj.remoteCharge && (obj.remoteCharge = obj.remoteDelivery), 
                obj.searchText = searchableText(obj), obj;
            }).filter(function(row) {
                return row.city || row.pincode;
            });
        }
        function readSheetCache(key, ttl) {
            try {
                var raw = sessionStorage.getItem(key) || localStorage.getItem(key);
                if (!raw) return null;
                var parsed = JSON.parse(raw);
                return parsed && Array.isArray(parsed.rows) ? Date.now() - Number(parsed.ts || 0) > ttl ? null : parsed.rows : null;
            } catch (e) {
                return null;
            }
        }
        function fetchSheetRows(forceRefresh) {
            if (!sheetUrl) return Promise.resolve([]);
            var requestUrl = sheetUrl;
            return forceRefresh && (requestUrl += (requestUrl.indexOf("?") > -1 ? "&" : "?") + "_og_refresh=" + Date.now()), 
            fetchJson(requestUrl, {
                cache: forceRefresh ? "reload" : "default",
                headers: {
                    Accept: "application/json"
                }
            }).then(function(json) {
                var rows = Array.isArray(json) ? json : json && (json.rows || json.data || json.values) || [];
                return rows = transformRows(rows), sheetRows = rows, function(rows) {
                    var payload = JSON.stringify({
                        ts: Date.now(),
                        rows: rows
                    });
                    try {
                        sessionStorage.setItem("og_delivery_sheet_cache_v17", payload);
                    } catch (e) {}
                    try {
                        localStorage.setItem("og_delivery_sheet_cache_v17", payload);
                    } catch (e) {}
                    try {
                        sessionStorage.setItem("og_delivery_sheet_stale_v17", payload);
                    } catch (e) {}
                    try {
                        localStorage.setItem("og_delivery_sheet_stale_v17", payload);
                    } catch (e) {}
                }(rows), rows;
            });
        }
        function bootSheetRows() {
            var fresh = readSheetCache("og_delivery_sheet_cache_v17", sheetCacheTtlMs);
            if (fresh && fresh.length) return sheetRows = fresh, Promise.resolve(fresh);
            var stale = readSheetCache("og_delivery_sheet_stale_v17", sheetStaleCacheTtlMs);
            return stale && stale.length ? (sheetRows = stale, fetchSheetRows(!0).catch(function(err) {
                console.warn("[OG Delivery] Background JSON refresh failed", err);
            }), Promise.resolve(stale)) : fetchSheetRows(!1).catch(function(err) {
                return console.error("[OG Delivery] Sheet fetch failed", err), setMsg("Delivery data loading failed. Please try again.", "error"), 
                [];
            });
        }
        function findByPincode(pin) {
            if (!(pin = extractPincode(pin) || String(pin || "").replace(/\s+/g, "").trim())) return null;
            for (var i = 0; i < sheetRows.length; i++) {
                if ((extractPincode(sheetRows[i].pincode) || String(sheetRows[i].pincode || "").replace(/\s+/g, "").trim()) === pin) return sheetRows[i];
            }
            return null;
        }
        function buildExternalLocationRow(pin, parsed, label) {
            parsed = parsed || {}, pin = String(pin || "").trim();
            var parts = splitAddressParts(label = String(label || parsed.label || "").trim()).filter(function(part) {
                return !/^\d{6}$/.test(part) && !isIndiaCountry(part);
            }), stateName = cleanAddressPart(parsed.state || parts.filter(isIndianState)[0] || ""), city = cleanAddressPart(parsed.city || parsed.district || ""), locality = cleanAddressPart(parsed.locality || parsed.area || "");
            city || parts.some(function(part) {
                return !isIndianState(part) && normalize(part) !== normalize(locality) && (city = cleanAddressPart(part), 
                !0);
            }), !locality && parts.length && normalize(parts[0]) !== normalize(city) && (locality = cleanAddressPart(parts[0])), 
            locality && normalize(locality) === normalize(city) && (locality = "");
            var displayAddress = buildReadableLocation([ locality, city, stateName, "India" ]) || cleanAddressPart(label) || "India", row = {
                rawLocation: label || displayAddress,
                city: city,
                locality: locality,
                area: locality,
                district: parsed.district || "",
                state: stateName,
                country: "India",
                pincode: pin,
                displayAddress: displayAddress,
                displayMeta: displayAddress,
                isJsonServiceable: !1,
                morning: 0,
                morningCharge: 0,
                express: 0,
                expressCharge: 0,
                standard: 0,
                standardCharge: 0,
                fixedTime: 0,
                fixedTimeCharge: 0,
                midnight: 0,
                midnightCharge: 0,
                freeSlot: 0,
                nextDay: 0,
                nextDayCharge: 0,
                remoteDelivery: 0,
                remoteCharge: 0
            };
            return row.searchText = searchableText(row), row;
        }
        function getMinSelectableDate(match) {
            var row, d = todayDate();
            return (now().getHours() >= Number(config.cutoffHour || 20) || (!(row = match) || !(Number(row.morning || 0) || Number(row.express || 0) || Number(row.standard || 0) || Number(row.fixedTime || 0) || Number(row.midnight || 0) || Number(row.freeSlot || 0)))) && d.setDate(d.getDate() + 1), 
            d;
        }
        function getMaxSelectableDate() {
            var d = todayDate();
            return d.setDate(d.getDate() + Number(config.defaultDateWindowDays || 90)), d;
        }
        function isDateDisabled(dateObj) {
            var key = ymd(dateObj), min = getMinSelectableDate(state.matchedLocation), max = getMaxSelectableDate(), only = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()), minOnly = new Date(min.getFullYear(), min.getMonth(), min.getDate()), maxOnly = new Date(max.getFullYear(), max.getMonth(), max.getDate());
            return only < minOnly || (only > maxOnly || !!(config.specialDates && Array.isArray(config.specialDates.disabled) && config.specialDates.disabled.indexOf(key) > -1));
        }
        function getLocationLabel() {
            return state.matchedLocation && (state.matchedLocation.selectedDisplayLabel || buildResolvedLocationLabel(state.matchedLocation.pincode, state.matchedLocation.displayAddress || state.matchedLocation.displayMeta || state.matchedLocation.rawLocation, state.matchedLocation.city)) || "";
        }
        function getTypeCfg(typeKey) {
            return config.deliveryTypes && config.deliveryTypes[typeKey] ? config.deliveryTypes[typeKey] : null;
        }
        function typeCharge(typeKey, row) {
            row = row || state.matchedLocation || {};
            var cfg = getTypeCfg(typeKey), cfgCharge = cfg ? Number(cfg.defaultCharge || 0) : 0;
            return "standard" === typeKey ? Number(row.standardCharge || cfgCharge || 0) : "express" === typeKey ? Number(row.expressCharge || cfgCharge || 0) : "morning" === typeKey ? Number(row.morningCharge || cfgCharge || 0) : "fixed_time" === typeKey ? Number(row.fixedTimeCharge || cfgCharge || 0) : "midnight" === typeKey ? Number(row.midnightCharge || cfgCharge || 0) : "free_slot" === typeKey ? 0 : "next_day_delivery" === typeKey ? Number(row.nextDayCharge || cfgCharge || 0) : "remote_delivery" === typeKey ? Number(row.remoteCharge || cfgCharge || 0) : cfgCharge;
        }
        function allowedTypeKeysFromRow(row, selectedDate) {
            if (!row) return [];
            var out = [], isToday = selectedDate === ymd(todayDate()), specialMeta = getSpecialDateMeta(selectedDate || "");
            return Number(row.morning || 0) > 0 && out.push("morning"), Number(row.express || 0) > 0 && out.push("express"), 
            Number(row.standard || 0) > 0 && out.push("standard"), Number(row.fixedTime || 0) > 0 && out.push("fixed_time"), 
            Number(row.midnight || 0) > 0 && out.push("midnight"), Number(row.freeSlot || 0) > 0 && out.push("free_slot"), 
            !isToday && Number(row.nextDay || 0) > 0 && out.push("next_day_delivery"), !isToday && (Number(row.remoteDelivery || 0) > 0 || Number(row.remoteCharge || 0) > 0) && out.push("remote_delivery"), 
            out.filter(function(v, i, arr) {
                return !(arr.indexOf(v) !== i || !getTypeCfg(v)) && !(specialMeta && Array.isArray(specialMeta.allowedTypes) && specialMeta.allowedTypes.length && -1 === specialMeta.allowedTypes.indexOf(v));
            });
        }
        function getSpecialDateMeta(dateKey) {
            var configuredRule = config.specialDates && config.specialDates.limited && config.specialDates.limited[dateKey] ? config.specialDates.limited[dateKey] : null, enforcedRule = {
                "2026-08-27": {
                    allowedTypes: [ "standard", "midnight" ],
                    standardLastOrderHour: 20
                },
                "2026-08-28": {
                    allowedTypes: [ "standard", "midnight" ],
                    standardLastOrderHour: 20
                }
            }[dateKey] || null;
            return configuredRule || enforcedRule ? Object.assign({}, configuredRule || {}, enforcedRule || {}) : null;
        }
        function getFilteredSlotsForType(typeKey, selectedDate) {
            var cfg = getTypeCfg(typeKey);
            if (!cfg || !Array.isArray(cfg.slots)) return [];
            var slots = cfg.slots.map(function(slot) {
                return {
                    label: slot.label,
                    startHour: Number(slot.startHour || 0),
                    startMinute: Number(slot.startMinute || 0),
                    endHour: Number(slot.endHour || slot.startHour || 0),
                    endMinute: Number(slot.endMinute || slot.startMinute || 0),
                    extraCharge: Number(slot.extraCharge || 0)
                };
            }), meta = getSpecialDateMeta(selectedDate || "");
            if (meta && Array.isArray(meta.allowedSlots) && meta.allowedSlots.length && (slots = slots.filter(function(slot) {
                return meta.allowedSlots.indexOf(slot.label) > -1;
            })), selectedDate !== ymd(todayDate())) return slots;
            var currentMinutes = 60 * now().getHours() + now().getMinutes(), oneHourCutoffMinutes = currentMinutes + 60;
            return slots = slots.filter(function(slot) {
                return 60 * Number(slot.startHour || 0) + Number(slot.startMinute || 0) > oneHourCutoffMinutes;
            }), "standard" === typeKey && meta && Number.isFinite(Number(meta.standardLastOrderHour)) ? currentMinutes < 60 * Number(meta.standardLastOrderHour) + Number(meta.standardLastOrderMinute || 0) ? slots : [] : slots;
        }
        function availableTypesForLocation(match, selectedDate) {
            return match && selectedDate ? allowedTypeKeysFromRow(match, selectedDate).map(function(key) {
                var cfg = getTypeCfg(key), slots = getFilteredSlotsForType(key, selectedDate);
                return cfg && slots.length ? {
                    key: key,
                    label: cfg.label,
                    charge: typeCharge(key, match)
                } : null;
            }).filter(Boolean) : [];
        }
        function getTypeOrderIndex(typeKey) {
            var index = preferredTypeOrder.indexOf(typeKey);
            return -1 === index ? 999 : index;
        }
        function makeDateFromKey(dateKey) {
            var parts = String(dateKey || "").split("-");
            if (3 !== parts.length) return null;
            var year = Number(parts[0]), month = Number(parts[1]) - 1, day = Number(parts[2]);
            return Number.isFinite(year) && Number.isFinite(month) && Number.isFinite(day) ? new Date(year, month, day) : null;
        }
        function getSlotStartTimestamp(dateKey, slot) {
            var date = makeDateFromKey(dateKey);
            return date && slot ? (date.setHours(Number(slot.startHour || 0), Number(slot.startMinute || 0), 0, 0), 
            date.getTime()) : 0;
        }
        function getAvailableSlotCandidates(match, dateKey) {
            if (!match || !dateKey) return [];
            var date = makeDateFromKey(dateKey);
            return !date || isDateDisabled(date) ? [] : allowedTypeKeysFromRow(match, dateKey).reduce(function(out, typeKey) {
                return getFilteredSlotsForType(typeKey, dateKey).forEach(function(slot) {
                    var expiry = getSelectionExpiry(dateKey, slot);
                    !expiry || Date.now() >= expiry || out.push({
                        typeKey: typeKey,
                        slot: slot,
                        start: getSlotStartTimestamp(dateKey, slot),
                        typeOrder: getTypeOrderIndex(typeKey)
                    });
                }), out;
            }, []);
        }
        function getReplacementDeliveryCandidate(match, oldDateKey) {
            if (!match) return null;
            var today = todayDate(), todayKey = ymd(today), startDate = makeDateFromKey(oldDateKey);
            (!startDate || startDate < today) && (startDate = today);
            for (var maxDate = getMaxSelectableDate(), cursor = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()); cursor <= maxDate; ) {
                var dateKey = ymd(cursor), candidates = getAvailableSlotCandidates(match, dateKey);
                if (candidates.length) return dateKey === todayKey ? candidates.sort(function(a, b) {
                    return a.start - b.start || a.typeOrder - b.typeOrder;
                }) : candidates.sort(function(a, b) {
                    return b.start - a.start || a.typeOrder - b.typeOrder;
                }), {
                    dateKey: dateKey,
                    slot: candidates[0].slot,
                    typeKey: candidates[0].typeKey
                };
                cursor.setDate(cursor.getDate() + 1);
            }
            return null;
        }
        function calculateCharges() {
            var cfg = getTypeCfg(state.selectedType), base = cfg ? typeCharge(state.selectedType, state.matchedLocation) : 0, extra = Number(state.selectedSlot && state.selectedSlot.extraCharge || 0);
            state.finalCharge = Number(base || 0) + Number(extra || 0), state.finalChargeLabel = cfg ? cfg.label + " " + money(state.finalCharge || 0, currency) : "";
        }
        function isReady() {
            return !!(state.matchedLocation && state.selectedDate && state.selectedType && state.selectedSlot);
        }
        function clearDeliveryValidation() {
            clearTimeout(deliveryValidationTimer), root.classList.remove("og-delivery--missing-location"), 
            els.input && (els.input.removeAttribute("aria-invalid"), els.input.classList.remove("is-og-required-shake")), 
            root.querySelectorAll(".og-delivery__validation-hint").forEach(function(node) {
                node && node.parentNode && node.parentNode.removeChild(node);
            }), root.querySelectorAll(".is-og-missing-step,.is-og-missing-input").forEach(function(node) {
                node.classList.remove("is-og-missing-step", "is-og-missing-input");
            });
        }
        function getDeliverySection(node) {
            return node && node.closest ? node.closest(".og-delivery__section") : null;
        }
        function focusFirstMissingDeliveryStep() {
            if (isJsonMatchedLocation() && !isReady()) { selectDateValue('calendar'); return true; }
            clearDeliveryValidation();
            var locationSection = root.querySelector(".og-delivery__section--location"), dateSection = getDeliverySection(els.dateOptions), typeSection = getDeliverySection(els.typeOptions), target = null, focusNode = null, message = "";
            if (state.matchedLocation) if (state.selectedDate) if (state.selectedType) {
                if (state.selectedSlot) return !1;
                isMobileLocationModalEnabled() && !mobileLocation.open && openMobileLocationSheet(!1), 
                target = root.querySelector('[data-og-type-wrap="' + state.selectedType + '"]') || typeSection || root;
                var selectedCfg = getTypeCfg(state.selectedType);
                message = "Please choose a time slot" + (selectedCfg && selectedCfg.label ? " for " + selectedCfg.label : "") + ".";
            } else isMobileLocationModalEnabled() && !mobileLocation.open && openMobileLocationSheet(!1), 
            target = typeSection || els.typeOptions || root, message = "Please choose a delivery option."; else isMobileLocationModalEnabled() && !mobileLocation.open && openMobileLocationSheet(!1), 
            target = dateSection || els.dateOptions || root, message = "Please choose a delivery date."; else target = locationSection || root, 
            focusNode = els.input || null, setMsg(message = "Please enter receiver city / area / 6 digit pincode to continue.", "error");
            return target !== locationSection && function(target, message) {
                if (target) {
                    var hint = document.createElement("div");
                    if (hint.className = "og-delivery__validation-hint", hint.setAttribute("role", "alert"), 
                    hint.textContent = message, target.classList && target.classList.contains("og-type-card-wrap")) {
                        var typeButton = target.querySelector(".og-type-card");
                        typeButton && typeButton.parentNode === target ? typeButton.insertAdjacentElement("afterend", hint) : target.insertBefore(hint, target.firstChild);
                    } else {
                        var title = target.querySelector && target.querySelector(".og-delivery__section-title, .og-delivery__label");
                        title ? title.insertAdjacentElement("afterend", hint) : target.insertBefore(hint, target.firstChild);
                    }
                }
            }(target, message), function(target, focusNode) {
                target || (target = root);
                var isLocationTarget = !!(focusNode === els.input || target.classList && target.classList.contains("og-delivery__section--location")), locationBox = null;
                if (isLocationTarget && els.input && (locationBox = els.input.closest(".og-delivery__location-box,.og-delivery__field,.field,.input-wrapper,.form-field") || els.input.parentElement || els.input), 
                isLocationTarget && isMobileLocationModalEnabled()) return openMobileLocationSheet(!0), 
                void setTimeout(function() {
                    state.matchedLocation || shakeMobileLocationInput();
                }, 120);
                target.classList.add("is-og-missing-step"), isLocationTarget && (root.classList.add("og-delivery--missing-location"), 
                locationBox && locationBox.classList && (locationBox.classList.remove("is-og-missing-input"), 
                locationBox.offsetWidth, locationBox.classList.add("is-og-missing-input")), els.input && (els.input.setAttribute("aria-invalid", "true"), 
                els.input.classList.remove("is-og-required-shake"), els.input.offsetWidth, els.input.classList.add("is-og-required-shake")));
                var scrollTarget = isLocationTarget && els.input ? els.input : target;
                try {
                    scrollTarget.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                } catch (e) {
                    scrollTarget.scrollIntoView();
                }
                focusNode && "function" == typeof focusNode.focus && setTimeout(function() {
                    try {
                        focusNode.focus({
                            preventScroll: !0
                        });
                    } catch (err) {
                        try {
                            focusNode.focus();
                        } catch (ignore) {}
                    }
                }, 280), deliveryValidationTimer = setTimeout(function() {
                    target && target.classList && target.classList.remove("is-og-missing-step"), locationBox && locationBox.classList && locationBox.classList.remove("is-og-missing-input"), 
                    root.classList.remove("og-delivery--missing-location"), els.input && (els.input.removeAttribute("aria-invalid"), 
                    els.input.classList.remove("is-og-required-shake"));
                }, 2400);
            }(target, focusNode), !0;
        }
        function applyProperties() {
            calculateCharges();
            var cfg = getTypeCfg(state.selectedType), ready = isReady(), locationOnly = !ready && canProceedWithoutDeliverySelection(), rawLocation = els.input ? String(els.input.value || "").trim() : "", matched = state.matchedLocation || {}, bypassPin = String(matched.pincode || extractPincode(rawLocation) || "").trim(), bypassCity = String(matched.city || rawLocation.replace(/\b\d{6}\b/g, "").replace(/^\s*,\s*|\s*,\s*$/g, "").trim() || rawLocation).trim(), city = ready ? String(matched.city || "") : locationOnly ? bypassCity : "", pin = ready ? String(matched.pincode || "") : locationOnly ? bypassPin : "", date = ready ? String(state.selectedDateLabel || "") : "", type = ready && cfg ? String(cfg.label || "") : "", slot = ready ? String(state.selectedSlot.label || "") : "", charge = ready ? String(state.finalChargeLabel || "") : "", hiddenType = ready ? state.selectedType || "" : locationOnly ? "location_only" : "", hiddenCharge = ready ? String(state.finalCharge || 0) : locationOnly ? "0" : "", hiddenSelected = ready ? "1" : locationOnly ? "1" : "";
            setValue(els.propCity, city), setValue(els.propPincode, pin), setValue(els.propDate, date), 
            setValue(els.propType, type), setValue(els.propSlot, slot), setValue(els.propChargeSummary, charge), 
            setValue(els.propHiddenType, hiddenType), setValue(els.propHiddenCharge, hiddenCharge), 
            setValue(els.propHiddenSelected, hiddenSelected), updateFormProperty("📍 Delivery City", city), 
            updateFormProperty("Delivery Pincode", pin), updateFormProperty("Select Date", date), 
            updateFormProperty("Pick Delivery Type", type), updateFormProperty("Time Slot", slot), 
            updateFormProperty("Delivery Charge", charge), updateFormProperty("_og_delivery_type", hiddenType), 
            updateFormProperty("_og_delivery_total_charge", hiddenCharge), updateFormProperty("_og_delivery_selected", hiddenSelected);
        }
        function getItemDeliveryCharge(item) {
            var props = item && item.properties || {}, amount = Number(props._og_delivery_total_charge || 0);
            (!Number.isFinite(amount) || amount < 0) && (amount = 0);
            var label = String(props["Delivery Charge"] || props["Delivery Fee"] || "").trim();
            if (!amount && label) {
                var match = label.match(/₹\s*([0-9,]+)/);
                match && (amount = Number(String(match[1]).replace(/,/g, "")) || 0);
            }
            return {
                amount: amount,
                label: label
            };
        }
        function syncFeeItemInCart() {
            if (!deliveryFeeProductId) return Promise.resolve();
            var selectedCharge = {
                amount: 0,
                label: ""
            }, feeVariantId = null;
            return fetchCart().then(function(cart) {
                selectedCharge = function(cart) {
                    var best = {
                        amount: 0,
                        label: ""
                    };
                    return (cart.items || []).forEach(function(item) {
                        var props = item.properties || {};
                        if (Number(item.product_id || 0) !== deliveryFeeProductId && "1" !== String(props._og_delivery_fee || "")) {
                            var charge = getItemDeliveryCharge(item);
                            charge.amount > best.amount ? best = charge : !best.label && charge.label && (best.label = charge.label);
                        }
                    }), best;
                }(cart), feeVariantId = function(amount) {
                    if ((amount = Number(amount || 0)) <= 0) return null;
                    var key = String(amount);
                    return Object.prototype.hasOwnProperty.call(feeVariantByAmount, key) ? Number(feeVariantByAmount[key]) : (console.warn("[OG Delivery] Missing fee variant for amount:", key), 
                    null);
                }(selectedCharge.amount);
                var updates = {}, keptCorrectFee = !1;
                return (cart.items || []).forEach(function(item) {
                    var props = item.properties || {};
                    Number(item.product_id || 0) !== deliveryFeeProductId && "1" !== String(props._og_delivery_fee || "") || (feeVariantId && Number(item.variant_id) === Number(feeVariantId) && !keptCorrectFee ? (keptCorrectFee = !0, 
                    1 !== Number(item.quantity || 0) && (updates[item.key] = 1)) : updates[item.key] = 0);
                }), Object.keys(updates).length ? function(updates) {
                    return fetchJson("/cart/update.js", {
                        method: "POST",
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json"
                        },
                        body: JSON.stringify({
                            updates: updates
                        })
                    });
                }(updates).then(function() {
                    return {
                        keptCorrectFee: keptCorrectFee
                    };
                }) : {
                    keptCorrectFee: keptCorrectFee
                };
            }).then(function(result) {
                return !feeVariantId || result.keptCorrectFee ? null : (payload = {
                    id: feeVariantId,
                    quantity: 1,
                    properties: (amount = selectedCharge.amount, label = selectedCharge.label, {
                        _og_delivery_fee: "1",
                        _og_delivery_total_charge: String(Number(amount || 0)),
                        "Delivery Fee": label || "Delivery Charge " + money(amount, currency)
                    })
                }, fetchJson("/cart/add.js", {
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify(payload)
                }));
                var payload, amount, label;
            }).catch(function(err) {
                console.error("[OG Delivery] Fee sync failed", err);
            });
        }
        function scheduleNativeFeeSync(delay) {
            clearTimeout(nativeFeeSyncTimer), nativeFeeSyncTimer = setTimeout(function() {
                syncFeeItemInCart().then(function() {
                    [ "cart:refresh", "cart:build", "cart:updated", "cart:change", "ajaxCart:updated" ].forEach(function(name) {
                        document.dispatchEvent(new CustomEvent(name)), window.dispatchEvent(new CustomEvent(name));
                    }), scheduleFeeLineScan(120), "function" == typeof window.__ogRenderCartDeliveryCharges && window.__ogRenderCartDeliveryCharges(180);
                });
            }, Number(delay || 1400));
        }
        function isDeliveryFeeCartItem(item) {
            var props = item && item.properties || {};
            return !!(Number(item && item.product_id || 0) === deliveryFeeProductId || "1" === String(props._og_delivery_fee || "") || normalize(item && item.product_title || "").indexOf("delivery fee") > -1 || normalize(item && item.title || "").indexOf("delivery fee") > -1);
        }
        function escapeCssValue(value) {
            return value = String(value || ""), window.CSS && "function" == typeof window.CSS.escape ? window.CSS.escape(value) : value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        }
        function renderCartDeliveryCharges() {
            if (!cartChargeRendering) {
                var root = document.querySelector('[id^="CartDrawerBody-"]') || document.getElementById("CartDrawer") || document.querySelector("cart-drawer") || document.querySelector(".cart-drawer") || document.querySelector('[class*="cart-drawer"]') || document.querySelector('[class*="drawer"][class*="cart"]');
                root && (cartChargeRendering = !0, fetchCart().then(function(cart) {
                    root.querySelectorAll(".og-cart-charge-row").forEach(function(node) {
                        node.remove();
                    });
                    var fallback = function(cart) {
                        var result = {
                            amount: 0,
                            label: ""
                        };
                        return (cart.items || []).forEach(function(item) {
                            if (isDeliveryFeeCartItem(item)) {
                                var props = item.properties || {}, amount = Number(props._og_delivery_total_charge || 0);
                                amount || (amount = Number(item.final_line_price || item.line_price || item.final_price || item.price || 0) / 100), 
                                amount > result.amount && (result.amount = amount), result.label || (result.label = String(props["Delivery Fee"] || "").trim());
                            }
                        }), result;
                    }(cart), deliveryItems = function(cart) {
                        return (cart.items || []).filter(function(item) {
                            return !isDeliveryFeeCartItem(item) && function(item) {
                                var props = item && item.properties || {};
                                return !!(props["📍 Delivery City"] || props["Delivery City"] || props["Delivery Pincode"] || props["Select Date"] || props["Pick Delivery Type"] || props["Time Slot"] || props["Delivery Charge"] || props._og_delivery_total_charge || props._og_delivery_selected);
                            }(item);
                        });
                    }(cart);
                    deliveryItems.forEach(function(item) {
                        var cartItem = function(root, item) {
                            if (!root || !item) return null;
                            var variantId = String(item.variant_id || "").trim(), key = String(item.key || "").trim(), handle = String(item.handle || "").trim(), node = null;
                            return variantId && (node = root.querySelector('li.cart-item[data-variant-id="' + escapeCssValue(variantId) + '"], [id^="CartDrawer-Item-"][data-variant-id="' + escapeCssValue(variantId) + '"]')), 
                            !node && key && (node = root.querySelector('[data-key="' + escapeCssValue(key) + '"]')), 
                            !node && handle && (node = root.querySelector('li.cart-item[data-handle="' + escapeCssValue(handle) + '"], [id^="CartDrawer-Item-"][data-handle="' + escapeCssValue(handle) + '"]')), 
                            node;
                        }(root, item);
                        if (cartItem) {
                            var anchor = function(cartItem) {
                                if (!cartItem) return null;
                                var exactTitleBlock = cartItem.querySelector(".cart-item__details .grid.flex-1 > .block");
                                if (exactTitleBlock) return exactTitleBlock;
                                var details = cartItem.querySelector(".cart-item__details") || cartItem.querySelector('[class*="cart-item__details"]');
                                if (!details) return null;
                                var options = details.querySelector(".cart-item__options");
                                return options && options.previousElementSibling ? options.previousElementSibling : details.querySelector('.cart-item__title, [class*="product-title"], [class*="item-title"], a[href*="/products/"], h2, h3, h4') || details.firstElementChild || details;
                            }(cartItem);
                            if (anchor && anchor.parentNode) {
                                var charge = getItemDeliveryCharge(item), amount = Number(charge.amount || 0), label = String(charge.label || "").trim();
                                !amount && fallback.amount && (amount = Number(fallback.amount || 0)), !label && fallback.label && (label = String(fallback.label || "").trim());
                                var value = amount > 0 ? money(amount, currency) : "";
                                if (!value && label) {
                                    var match = label.match(/₹\s*([0-9,]+)/);
                                    value = match ? "₹" + String(match[1]).replace(/,/g, "") : label;
                                }
                                if (value) {
                                    var row = document.createElement("div");
                                    row.className = "og-cart-charge-row", row.setAttribute("data-og-variant-id", String(item.variant_id || "")), 
                                    row.innerHTML = '<span class="og-cart-charge-row__label">Delivery Charge:</span><span class="og-cart-charge-row__value">' + escapeHtml(value) + "</span>", 
                                    anchor.parentNode.insertBefore(row, anchor.nextSibling);
                                }
                            }
                        }
                    });
                }).catch(function(err) {
                    console.error("[OG Delivery] Cart charge display failed", err);
                }).then(function() {
                    cartChargeRendering = !1;
                }));
            }
        }
        function scheduleCartChargeRender(delay) {
            clearTimeout(cartChargeTimer), cartChargeTimer = setTimeout(renderCartDeliveryCharges, Number(delay || 200));
        }
        function isCartMutation(mutation) {
            var changedNodes = Array.prototype.slice.call(mutation.addedNodes || []).concat(Array.prototype.slice.call(mutation.removedNodes || []));
            if (changedNodes.length && changedNodes.every(function(node) {
                return !!(node && 1 === node.nodeType && node.matches && node.matches(".og-cart-charge-row"));
            })) return !1;
            var target = mutation && mutation.target;
            return !!(target && 1 === target.nodeType && target.closest && target.closest(cartMutationSelector)) || Array.prototype.some.call(mutation.addedNodes || [], function(node) {
                return !(!node || 1 !== node.nodeType) && ((!node.matches || !node.matches(".og-cart-charge-row")) && !!(node.matches && node.matches(cartMutationSelector) || node.querySelector && node.querySelector(cartMutationSelector)));
            });
        }
        function writeSelectionCookie(raw) {
            if (raw) try {
                document.cookie = SELECTION_COOKIE_KEY + "=" + encodeURIComponent(raw) + "; path=/; max-age=172800; SameSite=Lax";
            } catch (e) {}
        }
        function readNamedSelectionCookie(key) {
            try {
                for (var prefix = key + "=", parts = String(document.cookie || "").split(";"), i = 0; i < parts.length; i++) {
                    var item = parts[i].trim();
                    if (0 === item.indexOf(prefix)) return decodeURIComponent(item.slice(prefix.length));
                }
            } catch (e) {}
            return "";
        }
        function clearSelectionCache() {
            LEGACY_SELECTION_CACHE_KEYS.concat([ SELECTION_CACHE_KEY ]).forEach(function(key) {
                try {
                    sessionStorage.removeItem(key);
                } catch (e) {}
                try {
                    localStorage.removeItem(key);
                } catch (e) {}
            }), LEGACY_SELECTION_COOKIE_KEYS.concat([ SELECTION_COOKIE_KEY ]).forEach(function(key) {
                try {
                    document.cookie = key + "=; path=/; max-age=0; SameSite=Lax";
                } catch (e) {}
            });
        }
        function clearDraftLocation() {
            try {
                sessionStorage.removeItem(DRAFT_LOCATION_CACHE_KEY);
            } catch (e) {}
            try {
                localStorage.removeItem(DRAFT_LOCATION_CACHE_KEY);
            } catch (e) {}
        }
        function beginLocationEdit() {
            clearSelectionCache();
            clearDraftLocation();
            restoredSelectionLocked = !1;
            isEditingDeliverySelection = !0;
            root.removeAttribute("data-og-restored-lock");
            root.classList.remove("is-summary-mode");
        }
        function saveDraftLocation() {
            if (state.matchedLocation && /^\d{6}$/.test(String(state.matchedLocation.pincode || "").trim())) {
                var payload = JSON.stringify({
                    ts: Date.now(),
                    matchedLocation: state.matchedLocation,
                    selectedDate: state.selectedDate || "",
                    selectedDateLabel: state.selectedDateLabel || "",
                    selectedType: state.selectedType || "",
                    selectedSlot: state.selectedSlot || null
                });
                try {
                    sessionStorage.setItem(DRAFT_LOCATION_CACHE_KEY, payload);
                } catch (e) {}
                try {
                    localStorage.setItem(DRAFT_LOCATION_CACHE_KEY, payload);
                } catch (e) {}
            }
        }
        function readDraftLocation() {
            var raw = "";
            try {
                raw = sessionStorage.getItem(DRAFT_LOCATION_CACHE_KEY) || "";
            } catch (e) {}
            if (!raw) try {
                raw = localStorage.getItem(DRAFT_LOCATION_CACHE_KEY) || "";
            } catch (e) {}
            if (!raw) return null;
            try {
                var parsed = JSON.parse(raw), age = Date.now() - Number(parsed && parsed.ts || 0);
                return parsed && parsed.matchedLocation && age >= 0 && age < 2592e5 ? parsed : (clearDraftLocation(), null);
            } catch (e) {
                clearDraftLocation();
                return null;
            }
        }
        function restoreDraftLocation() {
            var draft = readDraftLocation();
            if (!draft || !draft.matchedLocation) return !1;
            var draftPin = String(draft.matchedLocation.pincode || "").trim();
            if (!/^\d{6}$/.test(draftPin)) return clearDraftLocation(), !1;
            var match = findByPincode(draftPin) || buildExternalLocationRow(draftPin, draft.matchedLocation, draft.matchedLocation.selectedDisplayLabel || "");
            if (!match) return clearDraftLocation(), !1;
            state.matchedLocation = Object.assign({}, match, draft.matchedLocation, {
                pincode: draftPin
            });
            var minDate = getMinSelectableDate(state.matchedLocation), savedDate = String(draft.selectedDate || "").trim(), savedDateObj = savedDate ? makeDateFromKey(savedDate) : null;
            state.selectedDate = savedDateObj && !isDateDisabled(savedDateObj) ? savedDate : ymd(minDate);
            state.selectedDateLabel = state.selectedDate ? formatSelectedDateLabel(makeDateFromKey(state.selectedDate)) : "";
            var available = availableTypesForLocation(state.matchedLocation, state.selectedDate), savedType = String(draft.selectedType || "");
            state.selectedType = available.some(function(item) {
                return item.key === savedType;
            }) ? savedType : "";
            state.selectedSlot = state.selectedType && draft.selectedSlot ? draft.selectedSlot : null;
            state.finalCharge = 0;
            state.finalChargeLabel = "";
            isEditingDeliverySelection = !0;
            restoredSelectionLocked = !1;
            root.removeAttribute("data-og-restored-lock");
            els.input && (els.input.value = getLocationLabel());
            if (!isServiceabilityValidationEnabled() && !isJsonMatchedLocation()) {
                state.selectedDate = "";
                state.selectedDateLabel = "";
                state.selectedType = "";
                state.selectedSlot = null;
                state.finalCharge = 0;
                state.finalChargeLabel = "";
                els.summary && (els.summary.hidden = !0);
                root.classList.remove("is-summary-mode");
                setMsg("Location found!", "success");
            } else if (!1 === state.matchedLocation.isJsonServiceable) {
                state.selectedDate = "";
                state.selectedDateLabel = "";
                state.selectedType = "";
                state.selectedSlot = null;
                els.summary && (els.summary.hidden = !0);
                setUnavailableMsg(draftPin);
            } else setMsg("Location found! We deliver to this area.", "success");
            renderAll();
            applyProperties();
            toggleReset();
            syncDeliveryFlowVisibility();
            mobileLocation.input && (mobileLocation.input.value = getLocationLabel());
            syncMobileSheetState();
            return !0;
        }
        function getSelectionExpiry(selectedDate, selectedSlot) {
            if (!selectedDate || !selectedSlot) return 0;
            var parts = String(selectedDate).split("-");
            if (3 !== parts.length) return 0;
            var year = Number(parts[0]), month = Number(parts[1]) - 1, day = Number(parts[2]);
            if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return 0;
            var startHour = Number(selectedSlot.startHour), startMinute = Number(selectedSlot.startMinute), endHour = Number(selectedSlot.endHour), endMinute = Number(selectedSlot.endMinute);
            Number.isFinite(startHour) || (startHour = 0), Number.isFinite(startMinute) || (startMinute = 0), 
            Number.isFinite(endHour) || (endHour = 23), Number.isFinite(endMinute) || (endMinute = 59);
            var expiry = new Date(year, month, day, endHour, endMinute, 59, 999);
            return 60 * endHour + endMinute <= 60 * startHour + startMinute && expiry.setDate(expiry.getDate() + 1), 
            expiry.getTime();
        }
        function isSavedSelectionValid(parsed) {
            if (!(parsed && parsed.matchedLocation && parsed.selectedDate && parsed.selectedType && parsed.selectedSlot)) return !1;
            var savedPin = String(parsed.matchedLocation.pincode || "").trim();
            if (!/^\d{6}$/.test(savedPin) || !findByPincode(savedPin)) return !1;
            var expiry = Number(parsed.expiresAt || 0);
            return expiry || (expiry = getSelectionExpiry(parsed.selectedDate, parsed.selectedSlot)), 
            !(!expiry || Date.now() >= expiry);
        }
        function saveSelection() {
            if (isReady()) {
                calculateCharges();
                var expiresAt = getSelectionExpiry(state.selectedDate, state.selectedSlot);
                if (expiresAt && !(Date.now() >= expiresAt)) {
                    var payload = JSON.stringify({
                        ts: Date.now(),
                        expiresAt: expiresAt,
                        matchedLocation: state.matchedLocation,
                        selectedDate: state.selectedDate,
                        selectedDateLabel: state.selectedDateLabel,
                        selectedType: state.selectedType,
                        selectedSlot: state.selectedSlot,
                        finalCharge: state.finalCharge
                    });
                    try {
                        sessionStorage.setItem(SELECTION_CACHE_KEY, payload);
                    } catch (e) {}
                    try {
                        localStorage.setItem(SELECTION_CACHE_KEY, payload);
                    } catch (e) {}
                    writeSelectionCookie(payload);
                }
            }
        }
        function collectSelectionCandidates(includeExpired) {
            var candidates = [], seenRaw = {};
            function addRaw(raw) {
                if (raw && !seenRaw[raw]) {
                    seenRaw[raw] = !0;
                    try {
                        candidates.push(JSON.parse(raw));
                    } catch (e) {}
                }
            }
            return [ SELECTION_CACHE_KEY ].concat(LEGACY_SELECTION_CACHE_KEYS).forEach(function(key) {
                try {
                    addRaw(sessionStorage.getItem(key));
                } catch (e) {}
                try {
                    addRaw(localStorage.getItem(key));
                } catch (e) {}
            }), [ SELECTION_COOKIE_KEY ].concat(LEGACY_SELECTION_COOKIE_KEYS).forEach(function(key) {
                addRaw(readNamedSelectionCookie(key));
            }), (candidates = candidates.filter(function(item) {
                return !(!item || !item.matchedLocation);
            })).sort(function(a, b) {
                return Number(b && b.ts || 0) - Number(a && a.ts || 0);
            }), includeExpired || (candidates = candidates.filter(isSavedSelectionValid)), candidates;
        }
        function normalizeCachedSelection(parsed) {
            return parsed && parsed.matchedLocation && (parsed.matchedLocation = function(match) {
                if (!match) return match;
                var label = buildReadableLocation([ match.selectedDisplayLabel, match.locality, match.area, match.city, match.district, match.state, match.country ]), overridePin = getLocationPinOverride(label, match), cachedPin = String(match.pincode || "").trim(), pin = /^\d{6}$/.test(String(overridePin || "").trim()) ? String(overridePin).trim() : cachedPin;
                if (!/^\d{6}$/.test(pin)) return match;
                var current = findByPincode(pin) || buildExternalLocationRow(pin, match, label);
                return Object.assign({}, current, {
                    pincode: pin,
                    selectedDisplayLabel: buildReadableLocation([ pin, match.locality || match.area || current.locality || current.area || "", match.city || current.city || "", match.state || current.state || "", match.country || current.country || "India" ])
                });
            }(parsed.matchedLocation)), parsed;
        }
        function readSelectionCache() {
            var candidates = collectSelectionCandidates(!1);
            if (!candidates.length) return null;
            var parsed = normalizeCachedSelection(candidates[0]);
            try {
                var raw = JSON.stringify(parsed);
                try {
                    sessionStorage.setItem(SELECTION_CACHE_KEY, raw);
                } catch (e) {}
                try {
                    localStorage.setItem(SELECTION_CACHE_KEY, raw);
                } catch (e) {}
                writeSelectionCookie(raw);
            } catch (e) {}
            return parsed;
        }
        function getHeaderLocationPin() {
            var headerPin = function() {
                try {
                    var pin = String(localStorage.getItem("oyegifts_sel_pin") || "").trim(), ts = Number(localStorage.getItem("oyegifts_sel_ts") || 0);
                    return /^[1-9]\d{5}$/.test(pin) ? !ts || Date.now() - ts > 2592e5 ? "" : pin : "";
                } catch (e) {
                    return "";
                }
            }();
            return headerPin;
        }
        function selectionMatchesHeaderPin(selection) {
            var headerPin = getHeaderLocationPin();
            return !!headerPin && String(selection && selection.matchedLocation && selection.matchedLocation.pincode || "").trim() === headerPin;
        }
        function clearSelectedSlotOnly() {
            state.selectedDate = "", state.selectedDateLabel = "", state.selectedType = "", 
            state.selectedSlot = null, state.finalCharge = 0, state.finalChargeLabel = "";
        }
        function restoreExpiredSelection() {
            var candidates, stale = (candidates = collectSelectionCandidates(!0)).length ? normalizeCachedSelection(candidates[0]) : null;
            if (!stale || !stale.matchedLocation) return !1;
            var draft = readDraftLocation(), draftPin = String(draft && draft.matchedLocation && draft.matchedLocation.pincode || "").trim();
            if (/^\d{6}$/.test(draftPin)) {
                if (String(stale.matchedLocation.pincode || "").trim() !== draftPin) return clearSelectionCache(), !1;
            } else {
                if (!getHeaderLocationPin()) return clearSelectionCache(), !1;
                if (!selectionMatchesHeaderPin(stale)) return clearSelectionCache(), !1;
            }
            state.matchedLocation = stale.matchedLocation;
            var replacement = getReplacementDeliveryCandidate(state.matchedLocation, stale.selectedDate || ymd(todayDate()));
            if (replacement) {
                state.selectedDate = replacement.dateKey;
                var replacementDate = makeDateFromKey(replacement.dateKey);
                return state.selectedDateLabel = replacementDate ? formatSelectedDateLabel(replacementDate) : "", 
                state.selectedType = replacement.typeKey, state.selectedSlot = replacement.slot, 
                state.finalCharge = 0, state.finalChargeLabel = "", isEditingDeliverySelection = !1, 
                restoredSelectionLocked = !0, root.setAttribute("data-og-restored-lock", "true"), 
                root.classList.add("is-summary-mode"), els.input && (els.input.value = getLocationLabel()), 
                renderAll(), saveSelection(), setMsg("Your delivery slot was updated to the next available slot.", "success"), 
                !0;
            }
            return clearSelectionCache(), clearSelectedSlotOnly(), isEditingDeliverySelection = !1, 
            restoredSelectionLocked = !1, root.removeAttribute("data-og-restored-lock"), els.input && (els.input.value = getLocationLabel()), 
            renderAll(), setMsg("Your previous delivery slot has ended. Please choose a new slot.", "error"), 
            !0;
        }
        function restoreSelection() {
            var draft = readDraftLocation(), draftPin = String(draft && draft.matchedLocation && draft.matchedLocation.pincode || "").trim();
            var parsed = readSelectionCache();
            if (!getHeaderLocationPin() && !/^\d{6}$/.test(draftPin)) return parsed && clearSelectionCache(), !1;
            /^\d{6}$/.test(draftPin) && parsed && String(parsed.matchedLocation && parsed.matchedLocation.pincode || "").trim() !== draftPin && (clearSelectionCache(), parsed = null);
            return parsed && !/^\d{6}$/.test(draftPin) && !selectionMatchesHeaderPin(parsed) && (clearSelectionCache(), parsed = null), 
            isSavedSelectionValid(parsed) ? (state.matchedLocation = parsed.matchedLocation, 
            state.selectedDate = parsed.selectedDate || "", state.selectedDateLabel = parsed.selectedDateLabel || "", 
            state.selectedType = parsed.selectedType || "", state.selectedSlot = parsed.selectedSlot || null, 
            state.finalCharge = Number(parsed.finalCharge || 0), els.input && (els.input.value = getLocationLabel()), 
            isEditingDeliverySelection = !1, restoredSelectionLocked = !0, root.setAttribute("data-og-restored-lock", "true"), 
            root.classList.add("is-summary-mode"), renderAll(), applyProperties(), toggleReset(), 
            state.matchedLocation && setMsg("Location found! We deliver to this area.", "success"), 
            !0) : restoreExpiredSelection();
        }
        function refreshActiveDeliverySelection() {
            if (!isEditingDeliverySelection && isReady()) {
                var expiry = getSelectionExpiry(state.selectedDate, state.selectedSlot);
                if (expiry && !(Date.now() < expiry)) {
                    var oldDateKey = state.selectedDate, replacement = getReplacementDeliveryCandidate(state.matchedLocation, oldDateKey);
                    if (!replacement) return clearSelectionCache(), clearSelectedSlotOnly(), restoredSelectionLocked = !1, 
                    root.removeAttribute("data-og-restored-lock"), renderAll(), void setMsg("Your previous delivery slot has ended. Please choose a new slot.", "error");
                    state.selectedDate = replacement.dateKey;
                    var replacementDate = makeDateFromKey(replacement.dateKey);
                    state.selectedDateLabel = replacementDate ? formatSelectedDateLabel(replacementDate) : "", 
                    state.selectedType = replacement.typeKey, state.selectedSlot = replacement.slot, 
                    state.finalCharge = 0, state.finalChargeLabel = "", els.input && (els.input.value = getLocationLabel()), 
                    renderAll(), saveSelection(), setMsg("Your delivery slot was updated to the next available slot.", "success");
                }
            }
        }
        function resetAll(options) {
            options = options || {}, locationSelectionToken++, cancelFallbackLookup(), setLocationResolving(!1), 
            externalPinApplyToken++, restoredSelectionLocked = !1, isEditingDeliverySelection = !1, 
            root.removeAttribute("data-og-restored-lock"), root.classList.remove("is-summary-mode"), 
            state.matchedLocation = null, clearSelectedSlotOnly(), clearSuggestionState(), clearDraftLocation(), els.input && (els.input.value = "", 
            els.input.removeAttribute("data-place-id")), mobileLocation.input && (mobileLocation.input.value = ""), 
            mobileLocation.message && setMobileLocationMessage("", ""), els.summary && (els.summary.hidden = !0), 
            els.typeOptions && (els.typeOptions.innerHTML = ""), els.slotOptions && (els.slotOptions.innerHTML = ""), 
            els.slotTitle && (els.slotTitle.textContent = ""), setMsg("", ""), clearSelectionCache(), 
            syncDeliveryFlowVisibility(), renderDateOptions(), applyProperties(), toggleReset(), 
            syncMobileSheetState(), syncFeeItemInCart(), options.silentExternalClear || dispatchProductLocationEvent("oyegifts:product-location-cleared", {
                cleared: !0,
                pin: "",
                pincode: ""
            });
        }
        function toggleReset() {
            els.reset && (els.reset.hidden = !(els.input && els.input.value.trim() || state.matchedLocation));
        }
        var ogPopupFocus = null, ogOldOverflow = null;
        function setCalendarStep(step) {
            var slots = step === 'slots';
            els.calendarPanel.setAttribute('data-og-step', slots ? 'slots' : 'calendar');
            document.getElementById('ogCalendarStep').hidden = slots;
            document.getElementById('ogPopupDeliveryOptions').hidden = !slots;
            document.getElementById('ogCalendarBack').hidden = !slots;
            document.getElementById('ogCalendarTitle').textContent = slots ? 'Choose delivery type & time' : 'Choose delivery date';
            document.getElementById('ogPopupSelectedDate').textContent = slots ? state.selectedDateLabel : '';
            var dialog = els.calendarPanel.querySelector('.og-calendar__dialog');
            if (dialog) dialog.scrollTop = 0;
        }
        function selectDateValue(dateValue) {
            if (!isJsonMatchedLocation()) return;
            if (dateValue === 'calendar') {
                if (mobileLocation.open) closeMobileLocationSheet(false, true);
                ogPopupFocus = document.activeElement;
                restoredSelectionLocked = false;
                root.removeAttribute('data-og-restored-lock');
                isEditingDeliverySelection = true;
                var d = state.selectedDate ? makeDateFromKey(state.selectedDate) : getMinSelectableDate(state.matchedLocation);
                state.calendarMonth = new Date(d.getFullYear(), d.getMonth(), 1);
                renderAll(); renderCalendar(); setCalendarStep('calendar');
                if (!ogOldOverflow) ogOldOverflow = [document.documentElement.style.overflow, document.body.style.overflow];
                document.body.appendChild(els.calendarPanel);
                els.calendarPanel.hidden = false;
                els.calendarPanel.style.removeProperty('display');
                els.calendarPanel.style.removeProperty('visibility');
                if (typeof els.calendarPanel.showModal === 'function' && !els.calendarPanel.open) els.calendarPanel.showModal();
                else els.calendarPanel.setAttribute('open', '');
                document.documentElement.style.overflow = 'hidden';
                document.body.style.overflow = 'hidden';
                els.calendarClose.focus();
                return;
            }
            var d = makeDateFromKey(dateValue);
            if (isDateDisabled(d)) return;
            state.selectedDate = dateValue;
            state.selectedDateLabel = formatSelectedDateLabel(d);
            state.selectedType = ''; state.selectedSlot = null;
            isEditingDeliverySelection = true;
            clearSelectionCache();
            renderAll(); renderCalendar();
            setCalendarStep('slots');
            document.getElementById('ogCalendarBack').focus({preventScroll:true});
        }
        function getUiTypeLabel(typeKey, fallbackLabel) {
            return "free_slot" === typeKey || "standard" === typeKey ? "Standard Delivery" : "fixed_time" === typeKey ? "Fixed Time Delivery" : fallbackLabel || "";
        }
        function renderDateOptions() {
            if (!els.dateOptions) return;
            var disabled = !isJsonMatchedLocation();
            els.dateOptions.innerHTML = '<button type="button" class="og-calendar-trigger" data-og-date="calendar" aria-haspopup="dialog" aria-controls="ogCalendarPanel"' + (disabled ? ' disabled' : '') + '><span aria-hidden="true">▦</span><span>' + escapeHtml(state.selectedDateLabel || 'Choose delivery date & time') + '</span><span aria-hidden="true">›</span></button>';
        }
        function renderTypeOptions() {
            if (!els.typeOptions) return;
            var typeSection = getDeliverySection(els.typeOptions);
            if (!isJsonMatchedLocation() || !state.selectedDate) return els.typeOptions.innerHTML = "", void (typeSection && (typeSection.hidden = !0));
            typeSection && (typeSection.hidden = !1);
            var options = availableTypesForLocation(state.matchedLocation, state.selectedDate), standardKeys = [ "standard", "free_slot" ], selectedStandardKey = standardKeys.indexOf(state.selectedType) > -1 ? state.selectedType : "", preferredStandardKey = selectedStandardKey || (options.some(function(item) { return "free_slot" === item.key; }) ? "free_slot" : "standard"), uiOrder = [ "morning", preferredStandardKey, "express", "fixed_time", "midnight", "remote_delivery", "next_day_delivery" ];
            options = options.filter(function(item) {
                return -1 === standardKeys.indexOf(item.key) || item.key === preferredStandardKey;
            }), options.sort(function(a, b) {
                var ai = uiOrder.indexOf(a.key), bi = uiOrder.indexOf(b.key);
                return -1 === ai && (ai = 999), -1 === bi && (bi = 999), ai - bi;
            });
            if (!options.length) return void (els.typeOptions.innerHTML = '<div class="og-delivery__empty">No delivery type available for this date.</div>');
            els.typeOptions.innerHTML = options.map(function(item) {
                var selected = state.selectedType === item.key, active = selected ? " is-active" : "", amount = Number(item.charge || 0), price = 0 === amount ? "FREE" : money(amount, currency), priceClass = 0 === amount ? " is-free" : "";
                return '<div class="og-type-card-wrap' + active + '" data-og-type-wrap="' + escapeHtml(item.key) + '"><button type="button" class="og-type-card' + active + '" data-og-type="' + escapeHtml(item.key) + '" aria-pressed="' + (selected ? "true" : "false") + '"><span class="og-type-card__body"><span class="og-type-card__title">' + escapeHtml(getUiTypeLabel(item.key, item.label)) + '</span><span class="og-type-card__price' + priceClass + '">' + escapeHtml(price) + '</span></span></button></div>';
            }).join("");
        }
        function renderSlotOptions() {
            if (!els.slotOptions || !els.slotTitle) return;
            var panel = els.slotOptions.closest ? els.slotOptions.closest(".og-delivery__slot-panel") : null;
            if (!isJsonMatchedLocation() || !state.selectedDate) return els.slotTitle.innerHTML = "", els.slotOptions.innerHTML = "", void (panel && (panel.hidden = !0));
            panel && (panel.hidden = !1, panel.setAttribute("aria-hidden", "false"));
            var cfg = getTypeCfg(state.selectedType);
            if (!state.selectedType || !cfg) return els.slotTitle.innerHTML = '<strong>Select Time Slot</strong><small>Choose delivery type first</small>', void (els.slotOptions.innerHTML = "");
            var slots = getFilteredSlotsForType(state.selectedType, state.selectedDate), slotLabel = getUiTypeLabel(state.selectedType, cfg.label);
            els.slotTitle.innerHTML = '<strong>Available Slot for <span>' + escapeHtml(slotLabel) + '</span></strong>';
            if (!slots.length) return void (els.slotOptions.innerHTML = '<div class="og-slot-panel__empty">No time slot is available for this delivery option.</div>');
            els.slotOptions.innerHTML = slots.map(function(slot, index) {
                var active = state.selectedType && state.selectedSlot && state.selectedSlot.label === slot.label ? " is-active" : "";
                return '<button type="button" class="og-slot-card' + active + '" data-og-slot-index="' + index + '" aria-pressed="' + (active ? "true" : "false") + '"><span class="og-slot-card__label">' + escapeHtml(slot.label) + '</span><span class="og-slot-card__radio" aria-hidden="true"><span></span></span></button>';
            }).join("");
        }
        function renderSummary() {
            if (els.summary && els.selectedLines) {
                calculateCharges();
                var cfg = getTypeCfg(state.selectedType), summaryTitle = els.summary.querySelector('.og-delivery__selected-main > strong');
                summaryTitle && (summaryTitle.textContent = '');
                if (isReady() && cfg) {
                    els.selectedLines.innerHTML = '<div class="og-delivery__selected-item"><span class="og-delivery__selected-token" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"></rect><path d="M8 3v4M16 3v4M3 10h18"></path></svg></span><span class="og-delivery__selected-text">' + escapeHtml(state.selectedDateLabel || '') + '</span></div><div class="og-delivery__selected-divider" aria-hidden="true"></div><div class="og-delivery__selected-item"><span class="og-delivery__selected-token" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20c7 0 13-6 13-13-7 0-13 6-13 13Z"></path><path d="M5 19c3-4 6-7 11-10"></path></svg></span><span class="og-delivery__selected-copy"><span class="og-delivery__selected-text">' + escapeHtml(getUiTypeLabel(state.selectedType, cfg.label)) + '</span><span class="og-delivery__selected-charge">' + escapeHtml(state.finalCharge > 0 ? money(state.finalCharge, String(config.currencySymbol || "₹")) : "FREE") + '</span></span></div><div class="og-delivery__selected-divider" aria-hidden="true"></div><div class="og-delivery__selected-item"><span class="og-delivery__selected-token" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg></span><span class="og-delivery__selected-text">' + escapeHtml(state.selectedSlot.label || '') + '</span></div>', els.summary.hidden = !1;
                } else els.summary.hidden = !0;
            }
        }
        function revealSummaryForVerification() {
            mobileLocation.open && isReady() && els.summary && (summaryVerifyTimer && (clearTimeout(summaryVerifyTimer), 
            summaryVerifyTimer = null), els.summary.classList.remove("is-og-verify-pulse"), 
            window.requestAnimationFrame(function() {
                window.requestAnimationFrame(function() {
                    if (mobileLocation.open && isReady() && els.summary) {
                        els.summary.classList.add("is-og-verify-pulse");
                        try {
                            els.summary.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        } catch (e) {
                            mobileLocation.body && (mobileLocation.body.scrollTop = els.summary.offsetTop || 0);
                        }
                        summaryVerifyTimer = window.setTimeout(function() {
                            els.summary && els.summary.classList.remove("is-og-verify-pulse"), summaryVerifyTimer = null;
                        }, 850);
                    }
                });
            }));
        }
        function renderAll() {
            state.matchedLocation && saveDraftLocation();
            restoredSelectionLocked && !isEditingDeliverySelection && (els.input && (els.input.value = getLocationLabel()), 
            root.setAttribute("data-og-restored-lock", "true"));
            syncDeliveryFlowVisibility();
            renderDateOptions();
            renderTypeOptions();
            renderSlotOptions();
            renderSummary();
            if (els.calendarPanel) {
                var popupOptions = document.getElementById('ogPopupDeliveryOptions');
                if (popupOptions) popupOptions.hidden = els.calendarPanel.getAttribute('data-og-step') !== 'slots';
            }
            applyProperties();
            toggleReset();
            var summaryMode = isReady() && !isEditingDeliverySelection || restoredSelectionLocked && "true" === root.getAttribute("data-og-restored-lock");
            root.classList.toggle("is-summary-mode", summaryMode);
            !state.matchedLocation && els.typeOptions && (els.typeOptions.innerHTML = "");
            els.summary && (els.summary.hidden = !summaryMode);
            syncDeliveryFlowVisibility();
            mobileLocation.open && (attachMobileDeliveryFlow(), syncMobileSheetState(), isReady() && !isEditingDeliverySelection && els.summary && mobileLocation.dialog && mobileLocation.dialog.contains(els.summary) && setTimeout(function() {
                try {
                    els.summary.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                } catch (e) {}
            }, 60));
            "function" == typeof window.__ogSyncUnavailableBypass && setTimeout(window.__ogSyncUnavailableBypass, 0);
        }
        function renderCalendar() {
            if (els.calendarDays && els.calendarMonthLabel) {
                var base = state.calendarMonth || new Date(todayDate().getFullYear(), todayDate().getMonth(), 1), year = base.getFullYear(), month = base.getMonth(), firstDay = new Date(year, month, 1), lastDay = new Date(year, month + 1, 0), todayKey = ymd(todayDate()), selectedKey = state.selectedDate || "";
                els.calendarMonthLabel.textContent = base.toLocaleDateString("en-IN", {
                    month: "long",
                    year: "numeric"
                });
                var minDate = getMinSelectableDate(state.matchedLocation), minMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1), thisMonth = new Date(year, month, 1);
                els.calendarPrev && (els.calendarPrev.disabled = thisMonth <= minMonth);
                var maxDate = getMaxSelectableDate();
                els.calendarNext && (els.calendarNext.disabled = thisMonth >= new Date(maxDate.getFullYear(), maxDate.getMonth(), 1));
                for (var html = "", i = 0; i < firstDay.getDay(); i++) html += '<button type="button" class="og-calendar__day is-empty" tabindex="-1" aria-hidden="true"></button>';
                for (var day = 1; day <= lastDay.getDate(); day++) {
                    var dateObj = new Date(year, month, day), dateKey = ymd(dateObj), disabled = isDateDisabled(dateObj), cls = "og-calendar__day";
                    disabled && (cls += " is-disabled"), dateKey === todayKey && (cls += " is-today"), 
                    dateKey === selectedKey && (cls += " is-selected"), html += '<button type="button" class="' + cls + '" data-og-calendar-date="' + dateKey + '" aria-label="' + escapeHtml(dateObj.toLocaleDateString('en-IN', {day:'numeric',month:'long',year:'numeric'})) + '" aria-pressed="' + (dateKey === selectedKey) + '"' + (dateKey === todayKey ? ' aria-current="date"' : '') + (disabled ? ' disabled aria-disabled="true"' : "") + ">" + day + "</button>";
                }
                for (var totalCells = firstDay.getDay() + lastDay.getDate(), remaining = totalCells % 7 == 0 ? 0 : 7 - totalCells % 7, j = 0; j < remaining; j++) html += '<button type="button" class="og-calendar__day is-empty" tabindex="-1" aria-hidden="true"></button>';
                els.calendarDays.innerHTML = html;
            }
        }
        function closeCalendar() {
            if (!els.calendarPanel || els.calendarPanel.hidden) return;
            if (typeof els.calendarPanel.close === 'function' && els.calendarPanel.open) els.calendarPanel.close();
            els.calendarPanel.removeAttribute('open');
            els.calendarPanel.hidden = true;
            if (ogOldOverflow) {
                document.documentElement.style.overflow = ogOldOverflow[0];
                document.body.style.overflow = ogOldOverflow[1];
                ogOldOverflow = null;
            }
            isEditingDeliverySelection = false;
            renderAll();
            var focus = isReady() ? els.modify : els.dateOptions && els.dateOptions.querySelector('button');
            if (focus && !focus.disabled) focus.focus({preventScroll:true});
        }
        function isPincodePrefixQuery(input) {
            return /^\d{3,6}$/.test(String(input || "").replace(/\s+/g, ""));
        }
        function normalizePincodeValue(value) {
            var raw = String(value || "").trim(), pin = extractPincode(raw);
            if (/^\d{6}$/.test(pin)) return pin;
            var digits = raw.replace(/\D/g, "");
            return /^\d{6}$/.test(digits) ? digits : "";
        }
        function locationEditDistance(a, b) {
            a = String(a || ""), b = String(b || "");
            if (a === b) return 0;
            if (!a.length) return b.length;
            if (!b.length) return a.length;
            if (a.length > 64 || b.length > 64) return Math.max(a.length, b.length);
            for (var previous = [], current = [], j = 0; j <= b.length; j++) previous[j] = j;
            for (var i = 1; i <= a.length; i++) {
                current[0] = i;
                for (var k = 1; k <= b.length; k++) current[k] = Math.min(current[k - 1] + 1, previous[k] + 1, previous[k - 1] + (a.charAt(i - 1) === b.charAt(k - 1) ? 0 : 1));
                var swap = previous;
                previous = current;
                current = swap;
            }
            return previous[b.length];
        }
        function looseLocationSimilarity(value, query) {
            var valueKey = keyNorm(value), queryKey = keyNorm(query);
            if (!valueKey || !queryKey || queryKey.length < 5) return 0;
            if (valueKey === queryKey) return 1;
            if (0 === valueKey.indexOf(queryKey) || 0 === queryKey.indexOf(valueKey)) return .96;
            var maxLen = Math.max(valueKey.length, queryKey.length);
            if (!maxLen || Math.abs(valueKey.length - queryKey.length) > Math.max(4, Math.floor(maxLen * .35))) return 0;
            return 1 - locationEditDistance(valueKey, queryKey) / maxLen;
        }
        function strictLocationFieldScore(value, query, baseWeight) {
            var valueNorm = normalize(value), queryNorm = normalize(query);
            if (!valueNorm || !queryNorm) return -1;
            var valueKey = keyNorm(valueNorm), queryKey = keyNorm(queryNorm);
            if (!queryKey) return -1;
            if (valueNorm === queryNorm) return baseWeight + 500;
            if (valueKey === queryKey) return baseWeight + 470;
            if (0 === valueNorm.indexOf(queryNorm)) return baseWeight + 380;
            if (0 === valueKey.indexOf(queryKey)) return baseWeight + 350;
            if (valueNorm.split(/[^a-z0-9]+/).some(function(word) {
                return word && 0 === word.indexOf(queryNorm);
            })) return baseWeight + 260;
            if (queryNorm.length >= 4 && valueNorm.indexOf(queryNorm) > -1) return baseWeight + 120;
            var similarity = looseLocationSimilarity(valueNorm, queryNorm);
            return similarity >= .9 ? baseWeight + 210 : similarity >= .82 ? baseWeight + 120 : -1;
        }
        function locationRowTokenScore(row, query) {
            row = row || {};
            var queryNorm = normalize(query), tokens = queryNorm.split(/[^a-z0-9]+/).filter(function(token) {
                return token.length > 1;
            });
            if (tokens.length < 2) return -1;
            var rowText = normalize([ row.locality, row.area, row.city, row.district, row.state, row.country, row.rawLocation ].filter(Boolean).join(" ")), rowKey = keyNorm(rowText);
            return rowText && tokens.every(function(token) {
                var tokenKey = keyNorm(token);
                return rowText.indexOf(token) > -1 || tokenKey && rowKey.indexOf(tokenKey) > -1;
            }) ? 3600 + 100 * Math.min(tokens.length, 6) : -1;
        }
        function bestAreaForSuggestion(row, input) {
            row = row || {};
            var q = String(input || "").trim(), candidates = [ row.locality, row.area ].concat(splitAddressParts(row.rawLocation || "")), best = "", bestScore = -1;
            return candidates.forEach(function(candidate) {
                if ((candidate = cleanAddressPart(candidate)) && !isIndiaCountry(candidate) && !isIndianState(candidate) && !/^\d{6}$/.test(candidate) && normalize(candidate) !== normalize(row.city || "") && normalize(candidate) !== normalize(row.district || "")) {
                    var score = strictLocationFieldScore(candidate, q, 1e3);
                    score > bestScore && (bestScore = score, best = candidate);
                }
            }), best || cleanAddressPart(row.locality || row.area || "");
        }
        function buildTextLocationDropdownLabel(locality, city, stateName, country, input) {
            locality = cleanAddressPart(locality || ""), city = cleanAddressPart(city || ""), 
            stateName = cleanAddressPart(stateName || ""), isIndiaCountry(country = String(country || "India").trim() || "India") || (country = "India"), 
            locality && city && normalize(locality) === normalize(city) && (locality = ""), 
            city && stateName && normalize(city) === normalize(stateName) && (city = "");
            var localityScore = strictLocationFieldScore(locality, input, 5e3), cityScore = strictLocationFieldScore(city, input, 4300), stateScore = strictLocationFieldScore(stateName, input, 2500);
            return buildReadableLocation(localityScore >= 0 && localityScore >= cityScore && localityScore >= stateScore ? [ locality, city, stateName, country ] : cityScore >= 0 && cityScore >= stateScore ? [ city, stateName, country ] : stateScore >= 0 ? [ stateName, country ] : [ locality, city, stateName, country ]);
        }
        function buildPincodeDropdownLabel(pin, city, stateName) {
            return pin = String(pin || "").trim(), city = cleanAddressPart(city || ""), stateName = cleanAddressPart(stateName || ""), 
            city && stateName && normalize(city) === normalize(stateName) && (stateName = ""), 
            buildReadableLocation([ /^\d{6}$/.test(pin) ? pin : "", city, stateName ]);
        }
        function getLocationPinOverride(label, item) {
            for (var values = [ label, (item = item || {}).locality, item.area, item.dropdownLabel, item.displayLabel, item.selectedLabel, item.title, item.raw ], city = cleanAddressPart(item.city || item.district || ""), stateName = cleanAddressPart(item.state || ""), i = 0; i < values.length; i++) {
                var raw = String(values[i] || "").replace(/\b\d{6}\b/g, "").trim();
                if (raw) {
                    var parts = splitAddressParts(raw), checks = [ raw ];
                    parts.length && checks.push(parts[0]), parts.length && city && checks.push(parts[0] + " " + city), 
                    parts.length && city && stateName && checks.push(parts[0] + " " + city + " " + stateName);
                    for (var j = 0; j < checks.length; j++) {
                        var key = keyNorm(checks[j]);
                        if (key && locationPinOverrides[key]) return locationPinOverrides[key];
                    }
                }
            }
            return "";
        }
        function getSheetSuggestions(input) {
            var q = String(input || "").trim();
            if (!q || q.length < 3) return [];
            var pinQuery = isPincodePrefixQuery(q), pinInput = q.replace(/\s+/g, ""), ranked = [], seen = {};
            return sheetRows.forEach(function(row, rowIndex) {
                var score = function(row, input) {
                    var q = String(input || "").trim();
                    if (!q) return -1;
                    var pinQuery = isPincodePrefixQuery(q), pinInput = q.replace(/\s+/g, "");
                    if (pinQuery) {
                        var pin = normalizePincodeValue(row.pincode);
                        return /^\d{6}$/.test(pin) && 0 === pin.indexOf(pinInput) ? 1e4 + 100 * pinInput.length : -1;
                    }
                    var score = -1;
                    return [ {
                        value: row.locality,
                        weight: 5e3
                    }, {
                        value: row.area,
                        weight: 4900
                    }, {
                        value: row.city,
                        weight: 4300
                    }, {
                        value: row.district,
                        weight: 3900
                    }, {
                        value: row.state,
                        weight: 2500
                    } ].forEach(function(field) {
                        score = Math.max(score, strictLocationFieldScore(field.value, q, field.weight));
                    }), score = Math.max(score, locationRowTokenScore(row, q)), score;
                }(row, q);
                if (!(score < 0)) {
                    var city = String(row.city || row.district || "").trim(), pin = normalizePincodeValue(row.pincode), raw = String(row.rawLocation || "").trim(), locality = bestAreaForSuggestion(row, q), stateName = String(row.state || "").trim(), country = String(row.country || "India").trim() || "India", selectedLabel = function(row, pinOverride, input) {
                        row = row || {};
                        var pin = normalizePincodeValue(pinOverride || row.pincode), area = bestAreaForSuggestion(row, input), city = cleanAddressPart(row.city || row.district || ""), stateName = cleanAddressPart(row.state || ""), country = String(row.country || "India").trim() || "India";
                        return area && city && normalize(area) === normalize(city) && (area = ""), city && stateName && normalize(city) === normalize(stateName) && (city = ""), 
                        isIndiaCountry(country) || (country = "India"), buildReadableLocation([ /^\d{6}$/.test(pin) ? pin : "", area, city, stateName, country ]) || buildCanonicalRowLabel(row, pin);
                    }(row, pin, q), dropdownLabel = pinQuery ? buildPincodeDropdownLabel(pin, city, stateName) : buildTextLocationDropdownLabel(locality, city, stateName, country, q);
                    if (dropdownLabel) {
                        var key = normalize(dropdownLabel);
                        key && !seen[key] && (seen[key] = !0, ranked.push({
                            source: "sheet",
                            score: score,
                            rowIndex: rowIndex,
                            title: dropdownLabel,
                            displayLabel: dropdownLabel,
                            dropdownLabel: dropdownLabel,
                            selectedLabel: selectedLabel || buildCanonicalRowLabel(row, pin),
                            city: city,
                            locality: locality,
                            state: stateName,
                            country: country,
                            pincode: pin,
                            isPincodeQuery: !!pinQuery,
                            raw: raw,
                            row: row
                        }));
                    }
                }
            }), ranked.sort(function(a, b) {
                if (b.score !== a.score) return b.score - a.score;
                if (pinQuery) {
                    var aExact = a.pincode === pinInput ? 1 : 0, bExact = b.pincode === pinInput ? 1 : 0;
                    if (bExact !== aExact) return bExact - aExact;
                    var aPin = /^\d{6}$/.test(a.pincode) ? Number(a.pincode) : 999999, bPin = /^\d{6}$/.test(b.pincode) ? Number(b.pincode) : 999999;
                    if (aPin !== bPin) return aPin - bPin;
                }
                return a.rowIndex - b.rowIndex;
            }), ranked.slice(0, 8).map(function(item) {
                return delete item.score, delete item.rowIndex, item;
            });
        }
        function cleanSuggestionLabel(item) {
            if (!item) return "";
            var direct = String(item.displayLabel || item.selectedLabel || "").trim();
            if (direct) return direct;
            var pin = String(item.pincode || extractPincode(item.meta || "") || extractPincode(item.title || "") || "").trim(), locality = String(item.locality || item.area || "").trim(), city = String(item.city || item.district || "").trim(), stateName = String(item.state || "").trim(), country = String(item.country || "India").trim() || "India", structured = buildReadableLocation([ /^\d{6}$/.test(pin) ? pin : "", locality, city, stateName, country ]);
            if (structured) return structured;
            var label = String(item.title || item.meta || "").trim();
            return label = label.replace(/\s*,\s*/g, ", ").replace(/,{2,}/g, ",").replace(/^\s*,\s*|\s*,\s*$/g, "").replace(/\s+/g, " ").trim(), 
            pin && -1 === label.indexOf(pin) && (label = buildReadableLocation([ pin, label ])), 
            label && !/(^|,\s*)india$/i.test(label) && (label += ", India"), label;
        }
        function getSuggestionDropdownLabel(item, currentInput) {
            return item ? isPincodePrefixQuery(currentInput) ? buildPincodeDropdownLabel(item.pincode || extractPincode(item.selectedLabel || item.title || ""), item.city || item.district || "", item.state || "") || String(item.dropdownLabel || item.displayLabel || item.title || "").trim() : buildTextLocationDropdownLabel(item.locality || item.area || "", item.city || item.district || "", item.state || "", item.country || "India", currentInput) || String(item.dropdownLabel || item.displayLabel || item.title || "").replace(/\b\d{6}\b\s*,?\s*/g, "").trim() : "";
        }
        function renderSuggestions(items) {
            if (!items || !items.length) return els.suggestions && (els.suggestions.innerHTML = "", 
            els.suggestions.hidden = !0), activeSuggestions = [], void renderMobileLocationSuggestions([]);
            var currentInput = els.input ? String(els.input.value || "").trim() : "", html = (activeSuggestions = items.slice(0, 8)).map(function(item, index) {
                var label = getSuggestionDropdownLabel(item, currentInput);
                return '<button type="button" class="og-delivery__suggestion" data-og-suggestion-index="' + index + '" aria-label="Select ' + escapeHtml(label) + '"><span class="og-delivery__suggestion-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 21s6-5.3 6-11a6 6 0 1 0-12 0c0 5.7 6 11 6 11Z" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="10" r="2.15" stroke="currentColor" stroke-width="1.65"/></svg></span><span class="og-delivery__suggestion-title">' + escapeHtml(label) + "</span></button>";
            }).join("");
            els.suggestions && (els.suggestions.innerHTML = html, els.suggestions.hidden = !!mobileLocation.open), 
            renderMobileLocationSuggestions(activeSuggestions);
        }
        function isMobileLocationModalEnabled() {
            var value = config.mobileLocationModal;
            if ("boolean" == typeof value && !value) return !1;
            var normalized = normalize(value);
            if (normalized && -1 !== [ "false", "no", "off", "0" ].indexOf(normalized)) return !1;
            return !(!window.matchMedia || !window.matchMedia("(max-width: 749px)").matches);
        }
        function ensureReferenceMobileDeliveryStyle() {
            /* Styles are provided by og-delivery-widget-clean.css */
        }
        function ensureMobileLocationSheet() {
            ensureReferenceMobileDeliveryStyle();
            if (mobileLocation.sheet) return mobileLocation.sheet;
            var sheet = document.createElement("div");
            return sheet.id = "ogMobileLocationSheet", sheet.className = "og-mobile-location-sheet", 
            sheet.hidden = !0, sheet.innerHTML = '<div class="og-mobile-location-sheet__overlay" data-og-mobile-location-close="true"></div><div class="og-mobile-location-sheet__dialog" role="dialog" aria-modal="true" aria-labelledby="ogMobileLocationTitle"><div class="og-mobile-location-sheet__head"><div class="og-mobile-location-sheet__title" id="ogMobileLocationTitle">Delivery Location</div><button type="button" class="og-mobile-location-sheet__close" data-og-mobile-location-close="true" aria-label="Close delivery location">×</button></div><div class="og-mobile-location-sheet__body"><div class="og-mobile-location-sheet__country"><span class="og-mobile-location-sheet__flag">🇮🇳</span><span>India</span><span aria-hidden="true">⌄</span></div><div class="og-mobile-location-sheet__input-wrap"><input id="ogMobileLocationInput" class="og-mobile-location-sheet__input" type="text" inputmode="search" autocomplete="off" placeholder="Enter pincode, locality, etc" aria-label="Enter delivery pincode or locality"><button type="button" id="ogMobileLocationClear" class="og-mobile-location-sheet__clear" aria-label="Clear delivery location">×</button></div><div id="ogMobileLocationMessage" class="og-mobile-location-sheet__message" aria-live="polite"></div><div id="ogMobileLocationSuggestions" class="og-mobile-location-sheet__suggestions"></div><div id="ogMobileDeliveryFlowMount" class="og-mobile-location-sheet__flow"></div></div><div class="og-mobile-location-sheet__foot"><button type="button" id="ogMobileLocationLater" class="og-mobile-location-sheet__later" hidden>Later</button><button type="button" id="ogMobileLocationConfirm" class="og-mobile-location-sheet__confirm" disabled>Confirm</button></div></div>', 
            document.body.appendChild(sheet), mobileLocation.sheet = sheet, mobileLocation.dialog = sheet.querySelector(".og-mobile-location-sheet__dialog"), 
            mobileLocation.body = sheet.querySelector(".og-mobile-location-sheet__body"), mobileLocation.input = sheet.querySelector("#ogMobileLocationInput"), 
            mobileLocation.clear = sheet.querySelector("#ogMobileLocationClear"), mobileLocation.suggestions = sheet.querySelector("#ogMobileLocationSuggestions"), 
            mobileLocation.message = sheet.querySelector("#ogMobileLocationMessage"), mobileLocation.confirm = sheet.querySelector("#ogMobileLocationConfirm"), 
            mobileLocation.later = sheet.querySelector("#ogMobileLocationLater"), mobileLocation.foot = sheet.querySelector(".og-mobile-location-sheet__foot"), 
            mobileLocation.flowMount = sheet.querySelector("#ogMobileDeliveryFlowMount"), sheet.addEventListener("click", function(event) {
                event.target && "true" === event.target.getAttribute("data-og-mobile-location-close") && closeMobileLocationSheet(!0);
            }), mobileLocation.input && (mobileLocation.input.addEventListener("input", function(event) {
                var value = mobileLocation.input.value || "";
                beginLocationEdit(), locationResolving && event && !0 === event.isTrusted && (locationSelectionToken++, 
                cancelFallbackLookup(), setLocationResolving(!1)), restoredSelectionLocked && !isEditingDeliverySelection && (restoredSelectionLocked = !1, 
                root.removeAttribute("data-og-restored-lock"), isEditingDeliverySelection = !0), 
                els.input && (els.input.value = value, els.input.dispatchEvent(new Event("input", {
                    bubbles: !0
                }))), syncMobileSheetState();
            }), mobileLocation.input.addEventListener("keydown", function(event) {
                "Enter" === event.key && (event.preventDefault(), confirmMobileLocationInput());
            })), mobileLocation.clear && mobileLocation.clear.addEventListener("click", function(event) {
                if (event.preventDefault(), resetAll(), isEditingDeliverySelection = !0, restoredSelectionLocked = !1, 
                root.removeAttribute("data-og-restored-lock"), activeSuggestions = [], mobileLocation.input) {
                    mobileLocation.input.value = "";
                    try {
                        mobileLocation.input.focus();
                    } catch (ignore) {}
                }
                els.input && (els.input.value = ""), renderMobileLocationSuggestions([]), setMobileLocationMessage("", ""), 
                renderAll(), syncMobileSheetState();
            }), mobileLocation.suggestions && mobileLocation.suggestions.addEventListener("click", function(event) {
                var btn = event.target.closest("[data-og-mobile-suggestion-index]");
                if (btn) {
                    var item = activeSuggestions[Number(btn.getAttribute("data-og-mobile-suggestion-index"))];
                    item && handleSuggestionItemSelection(item);
                }
            }), mobileLocation.later && mobileLocation.later.addEventListener("click", function() {
                if (!isReady()) return focusFirstMissingDeliveryStep(), void syncMobileSheetState();
                calculateCharges(), applyProperties(), saveSelection(), isEditingDeliverySelection = !1, closeMobileLocationSheet(!1, !0);
            }), mobileLocation.confirm && mobileLocation.confirm.addEventListener("click", confirmMobileLocationInput), 
sheet;
        }
        function attachMobileDeliveryFlow() {
            mobileLocation.open && mobileLocation.flowMount && els.flow && (!mobileLocation.flowPlaceholder && els.flow.parentNode && (mobileLocation.flowPlaceholder = document.createComment("og-mobile-flow-placeholder"), 
            els.flow.parentNode.insertBefore(mobileLocation.flowPlaceholder, els.flow)), els.flow.parentNode !== mobileLocation.flowMount && mobileLocation.flowMount.appendChild(els.flow));
        }
        function scrollMobileLocationBodyToTop() {
            if (mobileLocation.body) try {
                mobileLocation.body.scrollTop = 0;
            } catch (e) {}
            if (mobileLocation.dialog) try {
                mobileLocation.dialog.scrollTop = 0;
            } catch (e) {}
        }
        function syncMobileSheetState() {
            if (!mobileLocation.sheet) return;
            if (mobileLocation.input && state.matchedLocation) {
                var selectedLabel = getLocationLabel();
                selectedLabel && mobileLocation.input.value !== selectedLabel && (mobileLocation.input.value = selectedLabel);
                if (mobileLocation.message && !activeSuggestions.length) {
                    isJsonMatchedLocation() ? setMobileLocationMessage("Location found! Choose delivery date and option.", "success") : !isServiceabilityValidationEnabled() ? setMobileLocationMessage("Location found!", "success") : isCurrentLocationNonServiceable() ? setMobileUnavailableMsg(state.matchedLocation.pincode) : setMobileLocationMessage("Location found!", "success");
                }
            }
            attachMobileDeliveryFlow();
            var ready = isReady(), hasSuggestions = !(!activeSuggestions || !activeSuggestions.length), typeSection = getDeliverySection(els.typeOptions), showSummaryOnly = !1;
            mobileLocation.sheet.classList.toggle("has-suggestions", hasSuggestions);
            mobileLocation.sheet.classList.toggle("has-location", !!state.matchedLocation);
            mobileLocation.sheet.classList.toggle("is-ready", ready);
            mobileLocation.sheet.classList.toggle("is-editing", !!isEditingDeliverySelection);
            mobileLocation.sheet.classList.toggle("is-summary-only", showSummaryOnly);
            if (typeSection) {
                typeSection.classList.toggle("og-mobile-summary-hide", showSummaryOnly);
                typeSection.hidden = !isJsonMatchedLocation() || !state.selectedDate;
            }
            mobileLocation.open && syncDeliveryFlowVisibility();
            if (mobileLocation.message && !activeSuggestions.length && !state.matchedLocation && !locationResolving) setMobileLocationMessage("", "");
            if (mobileLocation.later && mobileLocation.foot) {
                var showLater = !!state.matchedLocation && isJsonMatchedLocation();
                mobileLocation.later.hidden = !showLater, mobileLocation.later.disabled = !ready, mobileLocation.foot.classList.toggle("has-later-action", showLater);
            }
            if (mobileLocation.open && mobileLocation.flowMount) {
                var cards = mobileLocation.flowMount.querySelectorAll(".og-date-card");
                Array.prototype.forEach.call(cards, function(card) {
                    var meta = card.querySelector(".og-date-card__meta");
                    meta && meta.removeAttribute("aria-hidden");
                });
            }
            if (mobileLocation.clear) {
                var clearValue = mobileLocation.input ? String(mobileLocation.input.value || "").trim() : "";
                mobileLocation.clear.hidden = !clearValue;
            }
            updateMobileConfirmState();
        }
        function openMobileLocationSheet(forceFocus) {
            return !!isMobileLocationModalEnabled() && (ensureMobileLocationSheet(), mobileLocation.open = !0, 
            mobileLocation.sheet.hidden = !1, document.documentElement.classList.add("og-mobile-location-open"), 
            document.body.classList.add("og-mobile-location-open"), function() {
                if (mobileLocation.open && !mobileObstructionStyles.length) {
                    var nodes = [];
                    try {
                        nodes = Array.prototype.slice.call(document.querySelectorAll("#og-sameday-bar,.og-sameday-bar,.og-same-day-bar,[data-og-sameday],[data-og-timer],#og-checkout-timer,.og-checkout-timer,[id*=countdown],[class*=countdown],[id*=timer],[class*=timer]"));
                    } catch (e) {
                        nodes = [];
                    }
                    nodes.forEach(function(node) {
                        !node || node.closest("#ogMobileLocationSheet") || node.closest("#ogCalendarPanel") || "true" !== node.getAttribute("data-og-mobile-hidden-timer") && (mobileObstructionStyles.push({
                            node: node,
                            display: node.style.display || "",
                            visibility: node.style.visibility || ""
                        }), node.setAttribute("data-og-mobile-hidden-timer", "true"), node.style.setProperty("display", "none", "important"), 
                        node.style.setProperty("visibility", "hidden", "important"));
                    });
                }
            }(), mobileLocation.input && (mobileLocation.input.value = state.matchedLocation ? getLocationLabel() : els.input && els.input.value || ""), 
            isReady() || (isEditingDeliverySelection = !0), attachMobileDeliveryFlow(), mobileLocation.input && state.matchedLocation && (mobileLocation.input.value = getLocationLabel()), 
            renderAll(), renderMobileLocationSuggestions(activeSuggestions), syncMobileSheetState(), 
            state.matchedLocation && scrollMobileLocationBodyToTop(), !1 !== forceFocus && mobileLocation.input && !state.matchedLocation && setTimeout(function() {
                try {
                    mobileLocation.input.focus();
                } catch (e) {}
            }, 60), !0);
        }
        function closeMobileLocationSheet(clearProductLocation, deferRender) {
            if (mobileLocation.sheet) {
                clearProductLocation && resetAll({
                    silentExternalClear: !0
                });
                closeCalendar(), clearSuggestionState();
                var typeSection = getDeliverySection(els.typeOptions);
                if (typeSection && typeSection.classList.remove("og-mobile-summary-hide"), mobileLocation.sheet.classList.remove("is-ready", "is-editing", "is-summary-only", "has-suggestions"), 
                mobileLocation.open = !1, els.flow && mobileLocation.flowPlaceholder && mobileLocation.flowPlaceholder.parentNode && mobileLocation.flowMount && els.flow.parentNode === mobileLocation.flowMount && mobileLocation.flowPlaceholder.parentNode.insertBefore(els.flow, mobileLocation.flowPlaceholder.nextSibling), 
                mobileLocation.sheet.hidden = !0, document.documentElement.classList.remove("og-mobile-location-open"), 
                document.body.classList.remove("og-mobile-location-open"), mobileObstructionStyles.forEach(function(item) {
                    item && item.node && item.node.isConnected && (item.node.style.display = item.display, 
                    item.node.style.visibility = item.visibility, item.node.removeAttribute("data-og-mobile-hidden-timer"));
                }), mobileObstructionStyles = [], state.matchedLocation) {
                    var confirmedLabel = getLocationLabel();
                    mobileLocation.input && (mobileLocation.input.value = confirmedLabel), els.input && (els.input.value = confirmedLabel);
                } else mobileLocation.input && (mobileLocation.input.value = ""), els.input && (els.input.value = "");
                isReady() && (isEditingDeliverySelection = !1, root.classList.add("is-summary-mode")), 
                deferRender ? requestAnimationFrame(function() { renderAll(); }) : renderAll();
            }
        }
        function setMobileLocationMessage(text, type) {
            if (mobileLocation.message) {
                var message = String(text || ""), pincodeNotFound = /^pincode not found\./i.test(message), notFound = /^location not found\./i.test(message) || pincodeNotFound;
                mobileLocation.message.className = "og-mobile-location-sheet__message" + (type ? " is-" + type : "") + (notFound ? " is-location-not-found" : ""), 
                notFound ? mobileLocation.message.innerHTML = pincodeNotFound ? "Pincode not found. Please type your <strong>city or area</strong>." : "Location not found. Try city, area or exact <strong>6-digit pincode</strong>." : mobileLocation.message.textContent = message;
            }
        }
        function updateMobileConfirmState() {
            if (mobileLocation.confirm) {
                if (locationResolving) return mobileLocation.confirm.textContent = "Finding pincode...", 
                void (mobileLocation.confirm.disabled = !0);
                var value = mobileLocation.input ? String(mobileLocation.input.value || "").trim() : "";
                if (canProceedWithoutDeliverySelection()) return mobileLocation.confirm.textContent = "Continue", 
                void (mobileLocation.confirm.disabled = !1);
                if (isCurrentLocationNonServiceable()) return isServiceabilityValidationEnabled() ? (mobileLocation.confirm.textContent = "Unavailable", 
                void (mobileLocation.confirm.disabled = !0)) : (mobileLocation.confirm.textContent = "Continue", 
                void (mobileLocation.confirm.disabled = !1));
                isReady() ? (mobileLocation.confirm.textContent = "Continue", mobileLocation.confirm.disabled = !1) : state.matchedLocation ? (mobileLocation.confirm.textContent = "Continue", 
                mobileLocation.confirm.disabled = !1) : (mobileLocation.confirm.textContent = "Confirm", 
                mobileLocation.confirm.disabled = value.length < 3);
            }
        }
        function renderMobileLocationSuggestions(items) {
            if (mobileLocation.open && mobileLocation.suggestions) {
                var list = state.matchedLocation ? [] : items || [];
                if (!list.length) return mobileLocation.suggestions.innerHTML = "", void syncMobileSheetState();
                var currentInput = mobileLocation.input ? String(mobileLocation.input.value || "").trim() : els.input ? String(els.input.value || "").trim() : "";
                mobileLocation.suggestions.innerHTML = list.slice(0, 6).map(function(item, index) {
                    var label = getSuggestionDropdownLabel(item, currentInput);
                    return '<button type="button" class="og-mobile-location-sheet__suggestion" data-og-mobile-suggestion-index="' + index + '" aria-label="Select ' + escapeHtml(label) + '"><span class="og-mobile-location-sheet__suggestion-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 21s6-5.3 6-11a6 6 0 1 0-12 0c0 5.7 6 11 6 11Z" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="10" r="2.15" stroke="currentColor" stroke-width="1.65"/></svg></span><span class="og-mobile-location-sheet__suggestion-title">' + escapeHtml(label) + "</span></button>";
                }).join(""), syncMobileSheetState();
            }
        }
        function setLocationResolving(active) {
            locationResolving = !!active, mobileLocation.resolving = !!active, mobileLocation.sheet && mobileLocation.sheet.classList.toggle("is-resolving-location", !!active), 
            mobileLocation.confirm && (active ? (mobileLocation.confirm.disabled = !0, mobileLocation.confirm.textContent = "Finding pincode...") : updateMobileConfirmState());
        }
        function isCurrentLocationSelection(token) {
            return token === locationSelectionToken;
        }
        function endLocationSelection(token) {
            return !(token && !isCurrentLocationSelection(token)) && (setLocationResolving(!1), 
            !0);
        }
        function shakeMobileLocationInput() {
            ensureMobileLocationSheet(), mobileLocation.input && (mobileLocation.input.classList.remove("is-shake"), 
            mobileLocation.input.offsetWidth, mobileLocation.input.classList.add("is-shake"), 
            setTimeout(function() {
                mobileLocation.input && mobileLocation.input.classList.remove("is-shake");
            }, 900));
        }
        function confirmMobileLocationInput() {
            if (!locationResolving) {
                var value = mobileLocation.input ? String(mobileLocation.input.value || "").trim() : "";
                if (els.input && value !== els.input.value && (els.input.value = value), canProceedWithoutDeliverySelection()) return setMsg("Location found!", "success"), 
                setMobileLocationMessage("Location found!", "success"), applyProperties(), saveDraftLocation(), closeMobileLocationSheet(!1, !0), 
                void triggerAddonNextStep();
                if (isCurrentLocationNonServiceable()) return isServiceabilityValidationEnabled() ? (setMobileUnavailableMsg(state.matchedLocation && state.matchedLocation.pincode || extractPincode(value)), 
                void syncMobileSheetState()) : void closeMobileLocationSheet(!1);
                if (state.matchedLocation) {
                    if (!isReady()) return focusFirstMissingDeliveryStep(), void syncMobileSheetState();
                    calculateCharges(), applyProperties(), saveSelection(), scheduleNativeFeeSync(1500), closeMobileLocationSheet(!1, !0);
                    return void triggerAddonNextStep();
                } else {
                    if (!value || value.length < 3) return setMsg("Please enter receiver city / area / 6 digit pincode to continue.", "error"), 
                    setMobileLocationMessage("Please enter receiver city / area / 6 digit pincode to continue.", "error"), 
                    void shakeMobileLocationInput();
                    if (!isServiceabilityValidationEnabled()) return clearSuggestionState(), 
                    chooseMatchedLocation(buildExternalLocationRow(extractPincode(value) || "", null, value), value, extractPincode(value) || ""), 
                    setMsg("Location found!", "success"), setMobileLocationMessage("Location found!", "success"), 
                    void syncMobileSheetState();
                    if (activeSuggestions && 1 === activeSuggestions.length) return void handleSuggestionItemSelection(activeSuggestions[0]);
                    var pin = extractPincode(value);
                    /^\d{6}$/.test(pin) ? handleRawInputLookup() : (setMsg("Please select a location from suggestions.", "error"), 
                    setMobileLocationMessage("Please select a location from suggestions.", "error"), 
                    shakeMobileLocationInput());
                }
            }
        }
        function photonFeatureScore(properties, input) {
            var p = properties || {}, q = String(input || "").trim(), pin = extractPincode(p.postcode || p.postalcode || p.postal_code || "");
            if (isPincodePrefixQuery(q)) return pin && 0 === pin.indexOf(q) ? 1e4 + 100 * q.length : -1;
            var score = -1;
            return [ {
                value: p.name,
                weight: 6e3
            }, {
                value: p.suburb,
                weight: 5600
            }, {
                value: p.locality,
                weight: 5500
            }, {
                value: p.street,
                weight: 5e3
            }, {
                value: p.city,
                weight: 4300
            }, {
                value: p.district,
                weight: 3900
            }, {
                value: p.county,
                weight: 3600
            }, {
                value: p.state,
                weight: 2500
            } ].forEach(function(field) {
                var value, query, baseWeight;
                score = Math.max(score, (value = field.value, query = q, baseWeight = field.weight, 
                strictLocationFieldScore(value, query, baseWeight)));
            }), score;
        }
        function googleStatusOk(status, serviceType) {
            return "OK" === status || !(!window.google || !google.maps) && (!("places" !== serviceType || !google.maps.places || !google.maps.places.PlacesServiceStatus || status !== google.maps.places.PlacesServiceStatus.OK) || !("geocoder" !== serviceType || !google.maps.GeocoderStatus || status !== google.maps.GeocoderStatus.OK));
        }
        function initGoogleServices() {
            if (!window.google || !window.google.maps) return !1;
            try {
                if (window.google.maps.places) {
                    if (googleAutocompleteService = googleAutocompleteService || new google.maps.places.AutocompleteService, 
                    !googlePlacesService && google.maps.places.PlacesService) {
                        var div = document.createElement("div");
                        googlePlacesService = new google.maps.places.PlacesService(div);
                    }
                    !googleSessionToken && google.maps.places.AutocompleteSessionToken && (googleSessionToken = new google.maps.places.AutocompleteSessionToken);
                }
                return !googleGeocoder && google.maps.Geocoder && (googleGeocoder = new google.maps.Geocoder), 
                !(!googleAutocompleteService && !googleGeocoder);
            } catch (e) {
                return !1;
            }
        }
        function googleComponent(components, wantedTypes) {
            var found = "";
            return (components || []).some(function(component) {
                var types = component.types || [];
                return !!wantedTypes.some(function(type) {
                    return types.indexOf(type) > -1;
                }) && (found = String(component.long_name || component.short_name || "").trim(), 
                !0);
            }), found;
        }
        function parseGoogleAddressParts(place, fallbackLabel) {
            var components = (place = place || {}).address_components || [], formatted = String(place.formatted_address || place.name || fallbackLabel || "").trim(), pin = googleComponent(components, [ "postal_code" ]);
            pin = /^\d{6}$/.test(pin) ? pin : extractPincode(formatted);
            var locality = googleComponent(components, [ "sublocality_level_1", "sublocality", "neighborhood", "premise", "route" ]), city = googleComponent(components, [ "locality", "postal_town", "administrative_area_level_3", "administrative_area_level_2" ]), stateName = googleComponent(components, [ "administrative_area_level_1" ]), country = googleComponent(components, [ "country" ]) || "India";
            if (!locality || !city || !stateName) {
                var parts = splitAddressParts(formatted).filter(function(part) {
                    return !/^\d{6}$/.test(part) && !isIndiaCountry(part);
                });
                if (!stateName) for (var i = parts.length - 1; i >= 0; i--) if (isIndianState(parts[i])) {
                    stateName = parts[i];
                    break;
                }
                if (!locality && parts.length && (locality = parts[0]), !city) for (var j = 0; j < parts.length; j++) {
                    var p = parts[j];
                    if (normalize(p) !== normalize(locality) && !isIndianState(p)) {
                        city = p;
                        break;
                    }
                }
            }
            return locality = cleanAddressPart(locality), city = cleanAddressPart(city), stateName = cleanAddressPart(stateName), 
            isIndiaCountry(country), country = "India", locality && city && normalize(locality) === normalize(city) && (locality = ""), 
            city && stateName && normalize(city) === normalize(stateName) && (city = ""), {
                pincode: /^\d{6}$/.test(pin) ? pin : "",
                locality: locality,
                city: city,
                state: stateName,
                country: country,
                label: formatted
            };
        }
        function getGoogleLocationSuggestions(input, done) {
            var rawInput = String(input || "").trim(), requestToken = ++googleRequestToken;
            if (rawInput && !(rawInput.length < 3) && initGoogleServices() && googleAutocompleteService) {
                var googleAutocompleteTimeoutMs = Math.max(1200, Number(config.googleAutocompleteTimeoutMs || 2400)), finished = !1, timeout = setTimeout(function() {
                    finished || requestToken !== googleRequestToken || (finished = !0, done([]));
                }, googleAutocompleteTimeoutMs);
                try {
                    googleAutocompleteService.getPlacePredictions({
                        input: rawInput,
                        componentRestrictions: {
                            country: config.googleCountry || "in"
                        },
                        types: [ "geocode" ],
                        sessionToken: googleSessionToken || void 0
                    }, function(predictions, status) {
                        if (!finished && requestToken === googleRequestToken) if (finished = !0, clearTimeout(timeout), 
                        googleStatusOk(status, "places") && predictions && predictions.length) {
                            var pinQuery = isPincodePrefixQuery(rawInput), items = [], seen = {};
                            predictions.slice(0, 8).forEach(function(prediction) {
                                var parsed = function(prediction, input) {
                                    for (var formatting = prediction && prediction.structured_formatting || {}, title = String(formatting.main_text || prediction.description || input || "").trim(), meta = String(formatting.secondary_text || "").trim(), description = String(prediction.description || buildReadableLocation([ title, meta ])).trim(), metaParts = splitAddressParts(meta || description).filter(function(part) {
                                        return !/^\d{6}$/.test(part) && !isIndiaCountry(part);
                                    }), stateName = "", i = metaParts.length - 1; i >= 0; i--) if (isIndianState(metaParts[i])) {
                                        stateName = metaParts[i];
                                        break;
                                    }
                                    for (var city = "", j = 0; j < metaParts.length; j++) if (!isIndianState(metaParts[j]) && normalize(metaParts[j]) !== normalize(title)) {
                                        city = metaParts[j];
                                        break;
                                    }
                                    return {
                                        locality: cleanAddressPart(title),
                                        city: cleanAddressPart(city),
                                        state: cleanAddressPart(stateName),
                                        country: "India",
                                        label: description
                                    };
                                }(prediction, rawInput), pin = extractPincode(prediction.description || "");
                                if (!pinQuery || !pin || 0 === pin.indexOf(rawInput)) {
                                    var dropdownLabel = pinQuery && pin ? buildPincodeDropdownLabel(pin, parsed.city, parsed.state) : buildTextLocationDropdownLabel(parsed.locality, parsed.city, parsed.state, parsed.country, rawInput);
                                    if (dropdownLabel) {
                                        var key = normalize(dropdownLabel);
                                        key && !seen[key] && (seen[key] = !0, items.push({
                                            source: "google",
                                            title: dropdownLabel,
                                            displayLabel: dropdownLabel,
                                            dropdownLabel: dropdownLabel,
                                            selectedLabel: parsed.label || dropdownLabel,
                                            meta: "",
                                            pincode: /^\d{6}$/.test(pin) ? pin : "",
                                            placeId: prediction.place_id,
                                            locality: parsed.locality,
                                            city: parsed.city,
                                            state: parsed.state,
                                            country: parsed.country,
                                            googleLabel: parsed.label
                                        }));
                                    }
                                }
                            }), done(items);
                        } else done([]);
                    });
                } catch (e) {
                    clearTimeout(timeout), done([]);
                }
            } else done([]);
        }
        function bestGoogleResultWithPincode(results, fallbackLabel) {
            for (var list = Array.isArray(results) ? results : [], firstParsed = null, i = 0; i < list.length; i++) {
                var parsed = parseGoogleAddressParts(list[i], fallbackLabel);
                if (firstParsed || (firstParsed = parsed), /^\d{6}$/.test(String(parsed.pincode || "").trim())) return {
                    pin: String(parsed.pincode).trim(),
                    parsed: parsed,
                    result: list[i]
                };
            }
            return {
                pin: "",
                parsed: firstParsed,
                result: list[0] || null
            };
        }
        function geocodeGoogleAddress(address, done) {
            if (address && initGoogleServices() && googleGeocoder) try {
                googleGeocoder.geocode({
                    address: address,
                    componentRestrictions: {
                        country: "IN"
                    }
                }, function(results, status) {
                    if (googleStatusOk(status, "geocoder") && results && results.length) {
                        var best = bestGoogleResultWithPincode(results, address);
                        done(best.pin, best.parsed, best.result);
                    } else done("", null, null);
                });
            } catch (e) {
                done("", null, null);
            } else done("", null, null);
        }
        function resolveGoogleLocation(item, done) {
            item = item || {};
            var baseLabel = String(item.googleLabel || item.selectedLabel || item.displayLabel || item.title || "").trim(), directPin = String(item.pincode || "").trim();
            if (/^\d{6}$/.test(directPin)) done(directPin, item, baseLabel); else {
                var token = ++googleDetailsToken, finished = !1, timeout = setTimeout(function() {
                    finished || token !== googleDetailsToken || (finished = !0, done("", item, baseLabel));
                }, 2400);
                if (initGoogleServices()) if (item.placeId && googlePlacesService) try {
                    googlePlacesService.getDetails({
                        placeId: item.placeId,
                        fields: [ "address_components", "formatted_address", "name", "geometry" ],
                        sessionToken: googleSessionToken || void 0
                    }, function(place, status) {
                        if (googleSessionToken = null, googleStatusOk(status, "places") && place) {
                            var parsed = parseGoogleAddressParts(place, baseLabel), label = parsed.label || baseLabel;
                            if (/^\d{6}$/.test(String(parsed.pincode || "").trim())) finish(parsed.pincode, parsed, label); else {
                                if (place.geometry && place.geometry.location) {
                                    var location = place.geometry.location, lat = "function" == typeof location.lat ? Number(location.lat()) : Number(location.lat), lng = "function" == typeof location.lng ? Number(location.lng()) : Number(location.lng), parsedWithCoordinates = Object.assign({}, parsed);
                                    return Number.isFinite(lat) && Number.isFinite(lng) && (parsedWithCoordinates.latitude = lat, 
                                    parsedWithCoordinates.longitude = lng), void function(location, fallbackLabel, done) {
                                        if (location && initGoogleServices() && googleGeocoder) try {
                                            googleGeocoder.geocode({
                                                location: location
                                            }, function(results, status) {
                                                if (googleStatusOk(status, "geocoder") && results && results.length) {
                                                    var best = bestGoogleResultWithPincode(results, fallbackLabel);
                                                    done(best.pin, best.parsed);
                                                } else done("", null);
                                            });
                                        } catch (e) {
                                            done("", null);
                                        } else done("", null);
                                    }(location, label, function(pin, reverseParsed) {
                                        var reverseWithCoordinates = Object.assign({}, parsedWithCoordinates, reverseParsed || {});
                                        /^\d{6}$/.test(String(pin || "").trim()) ? finish(pin, reverseWithCoordinates, label) : Number.isFinite(lat) && Number.isFinite(lng) ? resolvePhotonPincode({
                                            latitude: lat,
                                            longitude: lng
                                        }, function(photonPin) {
                                            /^\d{6}$/.test(String(photonPin || "").trim()) ? finish(photonPin, reverseWithCoordinates, label) : resolveNominatimPincode(Object.assign({}, reverseWithCoordinates, {
                                                latitude: lat,
                                                longitude: lng
                                            }), label, function(nominatimPin, nominatimParsed) {
                                                /^\d{6}$/.test(String(nominatimPin || "").trim()) ? finish(nominatimPin, nominatimParsed || reverseWithCoordinates, label) : tryForward(reverseWithCoordinates, label);
                                            });
                                        }) : tryForward(reverseWithCoordinates, label);
                                    });
                                }
                                tryForward(parsed, label);
                            }
                        } else tryForward(item, baseLabel);
                    });
                } catch (e) {
                    tryForward(item, baseLabel);
                } else tryForward(item, baseLabel); else finish("", item, baseLabel);
            }
            function finish(pin, parsed, label) {
                finished || token !== googleDetailsToken || (finished = !0, clearTimeout(timeout), 
                parsed = parsed || item || {}, done(/^\d{6}$/.test(String(pin || "").trim()) ? String(pin).trim() : "", parsed, label || parsed.label || baseLabel));
            }
            function tryForward(parsed, label, allowPostalPhrase) {
                parsed = parsed || item || {}, label = String(label || parsed.label || baseLabel || "").trim(), 
                /^\d{6}$/.test(String(parsed.pincode || "").trim()) ? finish(parsed.pincode, parsed, label) : geocodeGoogleAddress(label, function(pin, geoParsed) {
                    /^\d{6}$/.test(String(pin || "").trim()) ? finish(pin, geoParsed || parsed, label) : finish("", geoParsed || parsed, label);
                });
            }
        }
        function postalField(record, names) {
            record = record || {};
            var fields = {};
            Object.keys(record).forEach(function(key) {
                fields[keyNorm(key)] = record[key];
            });
            for (var i = 0; i < names.length; i++) {
                var value = fields[keyNorm(names[i])];
                if (null != value && String(value).trim()) return String(value).trim();
            }
            return "";
        }
        function postalRecordScore(record, item, query) {
            item = item || {};
            var office = postalField(record = record || {}, [ "office_name", "name" ]), district = postalField(record, [ "district" ]), stateName = postalField(record, [ "state" ]), score = strictLocationFieldScore(office, query, 7e3), locality = String(item.locality || item.area || "").trim(), city = String(item.city || item.district || "").trim();
            return locality && (score = Math.max(score, strictLocationFieldScore(office, locality, 7200))), 
            city && normalize(district) === normalize(city) && (score += 250), item.state && normalize(stateName) === normalize(item.state) && (score += 150), 
            score;
        }
        function resolveNominatimPincode(item, label, done) {
            item = item || {}, label = String(label || item.selectedLabel || item.displayLabel || item.title || "").trim();
            var latitude = Number(item.latitude), longitude = Number(item.longitude), hasCoordinates = Number.isFinite(latitude) && Number.isFinite(longitude);
            if (label || hasCoordinates) {
                var cacheKey = normalize([ label, item.locality || item.area || "", item.city || item.district || "", item.state || "", hasCoordinates ? latitude.toFixed(5) + "," + longitude.toFixed(5) : "" ].join("|"));
                if (Object.prototype.hasOwnProperty.call(nominatimPincodeCache, cacheKey)) {
                    var cached = nominatimPincodeCache[cacheKey] || {};
                    done(cached.pin || "", cached.parsed || null);
                } else {
                    var queries = [], locality = item.locality || item.area || "", city = item.city || item.district || "", stateName = item.state || "";
                    addQuery(label), addQuery(buildReadableLocation([ locality, city, stateName, "India" ])), 
                    addQuery(buildReadableLocation([ splitAddressParts(label)[0] || locality, city, stateName, "India" ])), 
                    addQuery(buildReadableLocation([ city, stateName, "India" ])), queries = queries.slice(0, 4);
                    var requestUrls = hasCoordinates ? [ "https://nominatim.openstreetmap.org/reverse?format=jsonv2&addressdetails=1&zoom=18&lat=" + encodeURIComponent(latitude) + "&lon=" + encodeURIComponent(longitude) ] : queries.map(makeSearchUrl);
                    requestUrls.length ? Promise.all(requestUrls.map(function(url) {
                        return fetchJson(url, {
                            mode: "cors",
                            cache: "force-cache",
                            headers: {
                                Accept: "application/json",
                                "Accept-Language": "en-IN,en;q=0.8"
                            }
                        }).catch(function() {
                            return [];
                        });
                    })).then(function(resultLists) {
                        var best = rankResults(resultLists);
                        !best && hasCoordinates && queries.length ? Promise.all(queries.map(function(query) {
                            return fetchJson(makeSearchUrl(query), {
                                mode: "cors",
                                cache: "force-cache",
                                headers: {
                                    Accept: "application/json",
                                    "Accept-Language": "en-IN,en;q=0.8"
                                }
                            }).catch(function() {
                                return [];
                            });
                        })).then(function(searchResults) {
                            finish(rankResults(searchResults));
                        }) : finish(best);
                    }).catch(function() {
                        finish(null);
                    }) : finish(null);
                }
            } else done("", null);
            function addQuery(value) {
                if (!((value = String(value || "").replace(/\s+/g, " ").trim()).length < 3)) {
                    var key = normalize(value);
                    queries.every(function(query) {
                        return normalize(query) !== key;
                    }) && queries.push(value);
                }
            }
            function makeSearchUrl(query) {
                return "https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&limit=8&countrycodes=in&q=" + encodeURIComponent(query);
            }
            function rankResults(resultLists) {
                var localityTarget = normalize(locality), cityTarget = normalize(city), stateTarget = normalize(stateName), labelTokens = normalize(label).split(/[^a-z0-9]+/).filter(Boolean), all = [];
                return (resultLists || []).forEach(function(list, listIndex) {
                    var results;
                    (results = list, Array.isArray(results) ? results : results && results.address ? [ results ] : []).forEach(function(result, resultIndex) {
                        var address = result && result.address ? result.address : {}, countryCode = normalize(address.country_code || ""), display = String(result && result.display_name || ""), localityName = String(address.neighbourhood || address.suburb || address.locality || address.village || address.quarter || "").trim(), cityName = String(address.city || address.town || address.municipality || address.county || address.district || "").trim(), resultState = String(address.state || "").trim(), postcode = extractPincode(address.postcode || display || "");
                        if (/^\d{6}$/.test(postcode)) {
                            var haystack = normalize([ display, localityName, cityName, resultState, postcode ].join(" "));
                            if (!countryCode || "in" === countryCode || -1 !== haystack.indexOf("india")) {
                                var score = hasCoordinates ? 1e4 : 0;
                                localityTarget && haystack.indexOf(localityTarget) > -1 && (score += 8e3), cityTarget && haystack.indexOf(cityTarget) > -1 && (score += 1200), 
                                stateTarget && haystack.indexOf(stateTarget) > -1 && (score += 500), labelTokens.length && labelTokens.every(function(token) {
                                    return haystack.indexOf(token) > -1;
                                }) && (score += 250), all.push({
                                    result: result,
                                    index: 100 * listIndex + resultIndex,
                                    score: score,
                                    pin: postcode,
                                    locality: localityName,
                                    city: cityName,
                                    state: resultState
                                });
                            }
                        }
                    });
                }), all.sort(function(a, b) {
                    return b.score !== a.score ? b.score - a.score : a.index - b.index;
                }), all[0] || null;
            }
            function finish(best) {
                if (!best) return nominatimPincodeCache[cacheKey] = {
                    pin: "",
                    parsed: null
                }, void done("", null);
                var parsed = {
                    pincode: best.pin,
                    locality: cleanAddressPart(best.locality || locality),
                    city: cleanAddressPart(best.city || city),
                    state: cleanAddressPart(best.state || stateName),
                    country: "India",
                    label: label
                };
                nominatimPincodeCache[cacheKey] = {
                    pin: best.pin,
                    parsed: parsed
                }, done(best.pin, parsed);
            }
        }
        function resolveNearestJsonPincode(item, label, done) {
            function coordinatesFromLocation(location) {
                if (!location) return null;
                var lat = "function" == typeof location.lat ? Number(location.lat()) : Number(location.lat), lng = "function" == typeof location.lng ? Number(location.lng()) : Number(location.lng);
                return Number.isFinite(lat) && Number.isFinite(lng) ? {
                    latitude: lat,
                    longitude: lng
                } : null;
            }
            function coordinatesFromResult(result) {
                return result && result.geometry ? coordinatesFromLocation(result.geometry.location) : null;
            }
            item = item || {}, label = String(label || item.selectedLabel || item.displayLabel || item.title || "").trim(), 
            initGoogleServices() && googleGeocoder ? function(next) {
                var direct = coordinatesFromLocation(item.geometry && item.geometry.location) || coordinatesFromLocation(item.location);
                if (!direct) {
                    var directLat = Number(item.latitude), directLng = Number(item.longitude);
                    Number.isFinite(directLat) && Number.isFinite(directLng) && (direct = {
                        latitude: directLat,
                        longitude: directLng
                    });
                }
                direct ? next(direct) : geocodeGoogleAddress(label, function(pin, parsed, result) {
                    /^\d{6}$/.test(String(pin || "").trim()) ? next(null, pin, parsed) : next(coordinatesFromResult(result));
                });
            }(function(target, directPin, directParsed) {
                if (/^\d{6}$/.test(String(directPin || "").trim())) done(String(directPin).trim(), directParsed || null); else if (target) {
                    var targetCity = normalize(item.city || item.district || ""), targetState = normalize(item.state || ""), rows = sheetRows.filter(function(row) {
                        return /^\d{6}$/.test(String(row && row.pincode || "").trim());
                    }), scopedRows = rows.filter(function(row) {
                        var rowCity = normalize(row.city || row.district || ""), rowState = normalize(row.state || ""), cityOk = !targetCity || !rowCity || rowCity === targetCity || rowCity.indexOf(targetCity) > -1 || targetCity.indexOf(rowCity) > -1, stateOk = !targetState || !rowState || rowState === targetState || rowState.indexOf(targetState) > -1 || targetState.indexOf(rowState) > -1;
                        return cityOk && stateOk;
                    });
                    scopedRows.length || (scopedRows = rows);
                    var targetTokens = queryTokens(label).filter(function(token) {
                        return token.length > 3 && "india" !== token;
                    });
                    scopedRows = scopedRows.map(function(row, index) {
                        var rowText = searchableText(row);
                        return {
                            row: row,
                            index: index,
                            score: targetTokens.reduce(function(score, token) {
                                return score + (rowText.indexOf(token) > -1 ? 100 : 0);
                            }, 0)
                        };
                    }).sort(function(a, b) {
                        return b.score !== a.score ? b.score - a.score : a.index - b.index;
                    }).map(function(entry) {
                        return entry.row;
                    });
                    var seenPins = {}, candidates = scopedRows.filter(function(row) {
                        var pin = String(row.pincode || "").trim();
                        return !seenPins[pin] && (seenPins[pin] = !0, !0);
                    }).slice(0, 12);
                    if (candidates.length) {
                        var best = null, pending = candidates.length, finished = !1, timer = setTimeout(function() {
                            finished || (finished = !0, best && best.distance <= 15 ? done(best.pin, best.parsed) : done("", null));
                        }, 1800);
                        candidates.forEach(function(row) {
                            var pin = String(row.pincode || "").trim();
                            geocodeGoogleAddress(buildCanonicalRowLabel(row, pin) || row.rawLocation || pin, function(resolvedPin, parsed, result) {
                                if (!finished) {
                                    var a, b, rad, dLat, dLng, x, point = coordinatesFromResult(result);
                                    if (point) {
                                        var distance = (a = target, b = point, rad = Math.PI / 180, dLat = (b.latitude - a.latitude) * rad, 
                                        dLng = (b.longitude - a.longitude) * rad, x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.latitude * rad) * Math.cos(b.latitude * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2), 
                                        12742 * Math.atan2(Math.sqrt(x), Math.sqrt(Math.max(0, 1 - x))));
                                        (!best || distance < best.distance) && (best = {
                                            pin: pin,
                                            distance: distance,
                                            parsed: Object.assign({}, parsed || {}, row, {
                                                pincode: pin,
                                                label: label
                                            })
                                        });
                                    }
                                    --pending || finished || (finished = !0, clearTimeout(timer), best && best.distance <= 15 ? done(best.pin, best.parsed) : done("", null));
                                }
                            });
                        });
                    } else done("", null);
                } else done("", null);
            }) : done("", null);
        }
        function resolvePostalDirectoryPincode(item, label, done) {
            item = item || {}, label = String(label || item.selectedLabel || item.displayLabel || item.title || "").trim();
            var locality = cleanAddressPart(item.locality || item.area || ""), city = cleanAddressPart(item.city || item.district || ""), stateName = cleanAddressPart(item.state || ""), queries = [];
            function addQuery(value) {
                if (!((value = cleanAddressPart(value)).length < 3)) {
                    var key = normalize(value);
                    queries.every(function(query) {
                        return normalize(query) !== key;
                    }) && queries.push(value);
                }
            }
            if (locality && city && stateName && addQuery(locality + " " + city + " " + stateName), 
            locality && city && addQuery(locality + " " + city), addQuery(function(item, label) {
                var locality = cleanAddressPart((item = item || {}).locality || item.area || ""), city = cleanAddressPart(item.city || item.district || "");
                if (locality && normalize(locality) !== normalize(city)) return locality;
                var parts = splitAddressParts(label || "");
                return parts.length && normalize(parts[0]) !== normalize(city) ? parts[0] : city;
            }(item, label)), !locality && city && stateName && addQuery(city + " " + stateName), 
            locality || addQuery(city), queries.length) {
                var cacheKey = normalize(queries.join("|") + "|" + (item.state || ""));
                if (Object.prototype.hasOwnProperty.call(postalSearchCache, cacheKey)) {
                    var cached = postalSearchCache[cacheKey] || {};
                    done(cached.pin || "", cached.parsed || null);
                } else {
                    var token = ++postalSearchToken;
                    if (postalSearchAbortController) try {
                        postalSearchAbortController.abort();
                    } catch (e) {}
                    postalSearchAbortController = "undefined" != typeof AbortController ? new AbortController : null;
                    var finished = !1, timer = setTimeout(function() {
                        if (!finished && token === postalSearchToken) {
                            if (finished = !0, postalSearchAbortController) try {
                                postalSearchAbortController.abort();
                            } catch (e) {}
                            done("", null);
                        }
                    }, 1800), queryIndex = 0;
                    !function nextQuery() {
                        var query, next, url, options;
                        token === postalSearchToken && (queryIndex >= queries.length ? finish("", null) : (query = queries[queryIndex++], 
                        next = nextQuery, url = "https://api.postalpincode.in/postoffice/" + encodeURIComponent(query), 
                        options = {
                            mode: "cors",
                            cache: "force-cache",
                            headers: {
                                Accept: "application/json"
                            }
                        }, postalSearchAbortController && (options.signal = postalSearchAbortController.signal), 
                        fetchJson(url, options).then(function(json) {
                            tryRows(parseRows(Array.isArray(json) ? json[0] || {} : json), query, function() {
                                tryLegacyApi(query, next);
                            });
                        }).catch(function() {
                            tryLegacyApi(query, next);
                        })));
                    }();
                }
            } else done("", null);
            function finish(pin, parsed) {
                finished || token !== postalSearchToken || (finished = !0, clearTimeout(timer), 
                pin = /^\d{6}$/.test(String(pin || "").trim()) ? String(pin).trim() : "", postalSearchCache[cacheKey] = {
                    pin: pin,
                    parsed: parsed || null
                }, done(pin, parsed || null));
            }
            function parseRows(json) {
                var data = json && json.data ? json.data : {};
                return Array.isArray(json && json.PostOffice) ? json.PostOffice : Array.isArray(json && json.post_offices) ? json.post_offices : Array.isArray(data.post_offices) ? data.post_offices : [];
            }
            function tryRows(rows, query, next) {
                if (token === postalSearchToken) {
                    var ranked = (rows || []).map(function(record, index) {
                        return {
                            record: record,
                            index: index,
                            score: postalRecordScore(record, item, query)
                        };
                    }).filter(function(entry) {
                        return /^\d{6}$/.test(extractPincode(postalField(entry.record, [ "pincode", "pin code", "postal code" ])));
                    }).sort(function(a, b) {
                        return b.score !== a.score ? b.score - a.score : a.index - b.index;
                    });
                    if (!ranked.length || ranked[0].score < 0) next(); else {
                        var record = ranked[0].record || {}, recordPin = extractPincode(postalField(record, [ "pincode", "pin code", "postal code" ]));
                        finish(recordPin, {
                            pincode: recordPin,
                            locality: cleanAddressPart(item.locality || item.area || postalField(record, [ "office_name", "name" ])),
                            city: cleanAddressPart(item.city || item.district || postalField(record, [ "district" ])),
                            state: cleanAddressPart(item.state || postalField(record, [ "state" ])),
                            country: "India",
                            label: label
                        });
                    }
                }
            }
            function tryLegacyApi(query, next) {
                var url = "https://api.pincodeapi.in/api/v1/search?q=" + encodeURIComponent(query) + "&limit=20&offset=0", options = {
                    mode: "cors",
                    cache: "force-cache",
                    headers: {
                        Accept: "application/json"
                    }
                };
                postalSearchAbortController && (options.signal = postalSearchAbortController.signal), 
                fetchJson(url, options).then(function(json) {
                    tryRows(parseRows(json), query, next);
                }).catch(function() {
                    next();
                });
            }
        }
        function resolveGoogleAndPostal(item, label, done) {
            item = item || {}, label = String(label || item.selectedLabel || item.displayLabel || item.title || "").trim();
            var pending = 3, settled = !1, fallbackPin = "", fallbackParsed = item, fallbackLabel = label;
            function complete() {
                if (!settled) if (settled = !0, clearTimeout(settleTimer), fallbackPin) done(fallbackPin, fallbackParsed, fallbackLabel); else try {
                    resolveNearestJsonPincode(Object.assign({}, item, fallbackParsed || {}), fallbackLabel, function(pin, parsed) {
                        done(/^\d{6}$/.test(String(pin || "").trim()) ? String(pin).trim() : "", parsed || fallbackParsed, fallbackLabel);
                    });
                } catch (e) {
                    done("", fallbackParsed, fallbackLabel);
                }
            }
            var settleTimer = setTimeout(function() {
                complete();
            }, 2600);
            function receive(pin, parsed, resolvedLabel) {
                if (!settled) {
                    if (pin = String(pin || "").trim(), parsed && (fallbackParsed = parsed), resolvedLabel && (fallbackLabel = resolvedLabel), 
                    /^\d{6}$/.test(pin)) {
                        if (findByPincode(pin)) return clearTimeout(settleTimer), settled = !0, void done(pin, parsed || item, resolvedLabel || label);
                        fallbackPin || (fallbackPin = pin);
                    }
                    --pending || complete();
                }
            }
            try {
                resolveGoogleLocation(item, function(pin, parsed, resolvedLabel) {
                    receive(pin, parsed, resolvedLabel);
                });
            } catch (e) {
                receive("", item, label);
            }
            if (!settled) try {
                resolvePostalDirectoryPincode(item, label, function(pin, parsed) {
                    receive(pin, parsed, label);
                });
            } catch (e) {
                receive("", item, label);
            }
            if (!settled) try {
                resolveNominatimPincode(item, label, function(pin, parsed) {
                    receive(pin, parsed, label);
                });
            } catch (e) {
                receive("", item, label);
            }
        }
        function getFallbackLocationSuggestions(input, done) {
            var rawInput = String(input || "").trim(), pinQuery = isPincodePrefixQuery(rawInput), requestToken = ++fallbackRequestToken;
            if (fallbackAbortController) try {
                fallbackAbortController.abort();
            } catch (e) {}
            fallbackAbortController = "undefined" != typeof AbortController ? new AbortController : null;
            var url = "https://photon.komoot.io/api/?q=" + encodeURIComponent(rawInput) + "&limit=12&lang=en&bbox=68,6,97,37", fetchOptions = {
                mode: "cors",
                cache: "no-store",
                headers: {
                    Accept: "application/json"
                }
            };
            fallbackAbortController && (fetchOptions.signal = fallbackAbortController.signal), 
            fetchJson(url, fetchOptions).then(function(json) {
                if (requestToken === fallbackRequestToken) {
                    var features = json && Array.isArray(json.features) ? json.features : [], ranked = [], seen = {};
                    features.forEach(function(feature, featureIndex) {
                        var p = feature && feature.properties ? feature.properties : {}, relevance = photonFeatureScore(p, rawInput);
                        if (!(relevance < 0)) {
                            var pin = extractPincode(p.postcode || p.postalcode || p.postal_code || ""), city = cleanAddressPart(p.city || p.county || p.district || ""), stateName = cleanAddressPart(p.state || ""), country = String(p.country || "India").trim() || "India";
                            isIndiaCountry(country) || (country = "India");
                            var localityCandidates = [ p.name, p.suburb, p.locality, p.street ], locality = "", localityScore = -1;
                            if (localityCandidates.forEach(function(candidate) {
                                if ((candidate = cleanAddressPart(candidate || "")) && normalize(candidate) !== normalize(city)) {
                                    var score = strictLocationFieldScore(candidate, rawInput, 1e3);
                                    score > localityScore && (localityScore = score, locality = candidate);
                                }
                            }), locality || (locality = cleanAddressPart(p.name || p.suburb || p.locality || "")), 
                            !pinQuery || /^\d{6}$/.test(pin) && 0 === pin.indexOf(rawInput)) {
                                var dropdownLabel = pinQuery ? buildPincodeDropdownLabel(pin, city, stateName) : buildTextLocationDropdownLabel(locality, city, stateName, country, rawInput);
                                if (dropdownLabel) {
                                    var selectedLabel = buildReadableLocation([ /^\d{6}$/.test(pin) ? pin : "", locality, city, stateName, country ]), coords = feature && feature.geometry && Array.isArray(feature.geometry.coordinates) ? feature.geometry.coordinates : [], lon = Number(coords[0]), lat = Number(coords[1]), key = normalize(dropdownLabel);
                                    seen[key] || (seen[key] = !0, ranked.push({
                                        source: "photon",
                                        score: relevance,
                                        featureIndex: featureIndex,
                                        title: dropdownLabel,
                                        displayLabel: dropdownLabel,
                                        dropdownLabel: dropdownLabel,
                                        selectedLabel: selectedLabel || dropdownLabel,
                                        meta: "",
                                        pincode: /^\d{6}$/.test(pin) ? pin : "",
                                        locality: locality,
                                        city: city,
                                        state: stateName,
                                        country: country,
                                        longitude: Number.isFinite(lon) ? lon : null,
                                        latitude: Number.isFinite(lat) ? lat : null,
                                        sheetMatch: null
                                    }));
                                }
                            }
                        }
                    }), ranked.sort(function(a, b) {
                        if (b.score !== a.score) return b.score - a.score;
                        if (pinQuery) {
                            var aPin = /^\d{6}$/.test(String(a.pincode || "")) ? Number(a.pincode) : 999999, bPin = /^\d{6}$/.test(String(b.pincode || "")) ? Number(b.pincode) : 999999;
                            if (aPin !== bPin) return aPin - bPin;
                        }
                        return a.featureIndex - b.featureIndex;
                    }), done(ranked.slice(0, 8).map(function(item) {
                        return delete item.score, delete item.featureIndex, item;
                    }));
                }
            }).catch(function(err) {
                requestToken === fallbackRequestToken && (err && "AbortError" === err.name || done([]));
            });
        }
        function resolvePhotonPincode(item, done) {
            item = item || {};
            var directPin = String(item.pincode || "").trim();
            if (/^\d{6}$/.test(directPin)) done(directPin); else {
                var lon = Number(item.longitude), lat = Number(item.latitude);
                if (Number.isFinite(lon) && Number.isFinite(lat)) {
                    var cacheKey = lat.toFixed(5) + "," + lon.toFixed(5);
                    if (Object.prototype.hasOwnProperty.call(photonReversePinCache, cacheKey)) done(photonReversePinCache[cacheKey] || ""); else {
                        var token = ++fallbackResolveToken;
                        fetchJson("https://photon.komoot.io/reverse?lon=" + encodeURIComponent(String(lon)) + "&lat=" + encodeURIComponent(String(lat)) + "&lang=en", {
                            mode: "cors",
                            cache: "no-store",
                            headers: {
                                Accept: "application/json"
                            }
                        }).then(function(json) {
                            if (token === fallbackResolveToken) {
                                for (var features = json && Array.isArray(json.features) ? json.features : [], pin = "", i = 0; i < features.length; i++) {
                                    var p = features[i] && features[i].properties ? features[i].properties : {}, candidate = extractPincode(p.postcode || p.postalcode || p.postal_code || "");
                                    if (/^\d{6}$/.test(candidate)) {
                                        pin = candidate;
                                        break;
                                    }
                                }
                                photonReversePinCache[cacheKey] = pin, done(pin);
                            }
                        }).catch(function() {
                            token === fallbackResolveToken && (photonReversePinCache[cacheKey] = "", done(""));
                        });
                    }
                } else done("");
            }
        }
        function mergeSuggestions(primaryItems, fallbackItems) {
            var out = [], seen = {}, primary = (primaryItems || []).slice(0, 4), fallback = (fallbackItems || []).slice(0, 4);
            return primary.concat(fallback).concat((primaryItems || []).slice(4), (fallbackItems || []).slice(4)).forEach(function(item) {
                if (item) {
                    var key = normalize(cleanSuggestionLabel(item));
                    key && !seen[key] && (seen[key] = !0, out.push(item));
                }
            }), out.slice(0, 8);
        }
        function writeLocationSuggestionCache(key, items) {
            if (!(items && items.length)) return;
            if (key = normalize(key)) for (locationSuggestionCache[key] || locationSuggestionCacheOrder.push(key), 
            locationSuggestionCache[key] = {
                createdAt: Date.now(),
                items: (items || []).slice(0, 8)
            }; locationSuggestionCacheOrder.length > 40; ) {
                var oldest = locationSuggestionCacheOrder.shift();
                oldest && delete locationSuggestionCache[oldest];
            }
        }
        function cancelFallbackLookup() {
            if (googleRequestToken++, googleDetailsToken++, fallbackRequestToken++, fallbackResolveToken++, 
            postalSearchToken++, fallbackAbortController) {
                try {
                    fallbackAbortController.abort();
                } catch (e) {}
                fallbackAbortController = null;
            }
            if (postalSearchAbortController) {
                try {
                    postalSearchAbortController.abort();
                } catch (e) {}
                postalSearchAbortController = null;
            }
        }
        function clearSuggestionState() {
            clearTimeout(suggestionTimer), suggestionTimer = null, suggestionRequestId++, cancelFallbackLookup(), 
            activeSuggestions = [], els.suggestions && (els.suggestions.hidden = !0, els.suggestions.innerHTML = ""), 
            mobileLocation.suggestions && (mobileLocation.suggestions.innerHTML = "");
        }
        function showCombinedSuggestions(input) {
            var value = String(input || "").trim();
            if (value.length < 3) return cancelFallbackLookup(), void renderSuggestions([]);
            var requestId = ++suggestionRequestId;
            cancelFallbackLookup();
            var key, entry, cacheKey = normalize(value), localItems = getSheetSuggestions(value), cachedItems = (entry = (key = normalize(key = cacheKey)) ? locationSuggestionCache[key] : null) ? Date.now() - entry.createdAt > 3e5 ? (delete locationSuggestionCache[key], 
            locationSuggestionCacheOrder = locationSuggestionCacheOrder.filter(function(item) {
                return item !== key;
            }), null) : entry.items.slice() : null;
            if (null !== cachedItems) {
                var cachedMerged = mergeSuggestions(localItems, cachedItems);
                return renderSuggestions(cachedMerged), void setMsg(cachedMerged.length ? "Select a delivery location." : isServiceabilityValidationEnabled() ? "Location not found. Try city, area or exact 6-digit pincode." : "Enter your city or area and continue.", "");
            }
            if (/^\d{6}$/.test(value.replace(/\s+/g, "")) && !localItems.some(function(item) {
                return String(item.pincode || "").trim() === value.replace(/\s+/g, "");
            })) {
                var directPin = value.replace(/\s+/g, "");
                if (!isServiceabilityValidationEnabled()) return cancelFallbackLookup(), renderSuggestions([]), 
                void chooseMatchedLocation(buildExternalLocationRow(directPin, null, value), value, directPin);
                return cancelFallbackLookup(), renderSuggestions([]), setUnavailableMsg(directPin), 
                void syncDeliveryFlowVisibility();
            }
            var googleItemsResult = [], fallbackItemsResult = [], googleFinished = !1, fallbackFinished = !1;
            function stillCurrent() {
                return !!(els.input && els.input.value.trim() === value && requestId === suggestionRequestId);
            }
            function updateSuggestions() {
                if (!stillCurrent()) return;
                var externalItems = mergeSuggestions(googleItemsResult, fallbackItemsResult), merged = mergeSuggestions(localItems, externalItems);
                merged.length ? (renderSuggestions(merged), setMsg("Select a delivery location.", "")) : googleFinished && fallbackFinished ? (renderSuggestions([]), 
                setMsg(isServiceabilityValidationEnabled() ? "Location not found. Try city, area or exact 6-digit pincode." : "Enter your city or area and continue.", "")) : setMsg("Searching delivery locations...", "");
                (googleFinished && fallbackFinished || merged.length && (googleFinished || fallbackFinished)) && writeLocationSuggestionCache(cacheKey, merged);
            }
            localItems.length ? (renderSuggestions(localItems), setMsg("Select a delivery location.", "")) : (renderSuggestions([]), 
            setMsg("Searching delivery locations...", ""));
            getGoogleLocationSuggestions(value, function(googleItems) {
                if (!stillCurrent()) return;
                googleItemsResult = Array.isArray(googleItems) ? googleItems : [], googleFinished = !0, updateSuggestions();
            });
            getFallbackLocationSuggestions(value, function(fallbackItems) {
                if (!stillCurrent()) return;
                fallbackItemsResult = Array.isArray(fallbackItems) ? fallbackItems : [], fallbackFinished = !0, updateSuggestions();
            });
        }
        function chooseMatchedLocation(match, inputLabel, resolvedPin) {
            if (restoredSelectionLocked && !isEditingDeliverySelection) return els.input && (els.input.value = getLocationLabel()), 
            renderSummary(), root.classList.add("is-summary-mode"), void (els.summary && (els.summary.hidden = !1));
            var inputPin = String(resolvedPin || extractPincode(inputLabel) || "").trim(), inputText = String(inputLabel || "").trim();
            !match && !isServiceabilityValidationEnabled() && inputText && (match = buildExternalLocationRow(/^\d{6}$/.test(inputPin) ? inputPin : "", null, inputText));
            if (!match && /^\d{6}$/.test(inputPin) && (match = buildExternalLocationRow(inputPin, null, inputLabel)), 
            !match) {
                if (restoredSelectionLocked && !isEditingDeliverySelection) return els.input && (els.input.value = getLocationLabel()), 
                renderSummary(), root.classList.add("is-summary-mode"), els.summary && (els.summary.hidden = !1), 
                applyProperties(), void toggleReset();
                beginLocationEdit(), state.matchedLocation = null, state.selectedDate = "", state.selectedDateLabel = "", 
                state.selectedType = "", state.selectedSlot = null, state.finalCharge = 0, state.finalChargeLabel = "";
                var unavailablePin = String(resolvedPin || extractPincode(inputLabel) || "").trim();
                return els.input && (els.input.value = unavailablePin ? buildResolvedLocationLabel(unavailablePin, inputLabel || els.input.value || "", "") : inputLabel || els.input.value || ""), 
                els.suggestions && (els.suggestions.hidden = !0, els.suggestions.innerHTML = ""), 
                els.flow && (els.flow.hidden = !0), els.summary && (els.summary.hidden = !0), applyProperties(), 
                toggleReset(), isEditingDeliverySelection && clearSelectionCache(), setUnavailableMsg(unavailablePin), 
                void syncDeliveryFlowVisibility();
            }
            var resolvedDisplayLabel, resolvedPinValue = String(resolvedPin || match.pincode || "").trim(), candidateLabel = String(inputLabel || "").trim(), candidateWithoutPin = candidateLabel.replace(/\b\d{6}\b/g, "").trim();
            candidateLabel && /[a-z]/i.test(candidateWithoutPin) && candidateLabel.indexOf(",") > -1 ? (resolvedDisplayLabel = buildResolvedLocationLabel(resolvedPinValue, candidateLabel, match.city || "")) && !/(^|,\s*)india$/i.test(resolvedDisplayLabel) && (resolvedDisplayLabel += ", India") : resolvedDisplayLabel = buildCanonicalRowLabel(match, resolvedPinValue), 
            state.matchedLocation = Object.assign({}, match, {
                selectedDisplayLabel: resolvedDisplayLabel
            });
            if (!isServiceabilityValidationEnabled() && !isJsonMatchedLocation()) return state.selectedDate = "", state.selectedDateLabel = "", 
            state.selectedType = "", state.selectedSlot = null, state.finalCharge = 0, state.finalChargeLabel = "", 
            els.input && (els.input.value = getLocationLabel()), els.suggestions && (els.suggestions.hidden = !0, 
            els.suggestions.innerHTML = ""), els.summary && (els.summary.hidden = !0), root.classList.remove("is-summary-mode"), 
            isEditingDeliverySelection && clearSelectionCache(), setMsg("Location found!", "success"), applyProperties(), 
            toggleReset(), syncDeliveryFlowVisibility(), renderDateOptions(), saveDraftLocation(), mobileLocation.input && (mobileLocation.input.value = getLocationLabel()), 
            mobileLocation.suggestions && (mobileLocation.suggestions.innerHTML = ""), setMobileLocationMessage("Location found!", "success"), 
            syncMobileSheetState(), void notifyProductLocationSelected();
            var min = getMinSelectableDate(match = state.matchedLocation);
            state.selectedDate = "", state.selectedDateLabel = "", 
            state.selectedType = "", state.selectedSlot = null;
            var options = availableTypesForLocation(match, state.selectedDate);
            if (1 === options.length && (state.selectedType = options[0].key), els.input && (els.input.value = getLocationLabel()), 
            els.suggestions && (els.suggestions.hidden = !0, els.suggestions.innerHTML = ""), 
            !1 === match.isJsonServiceable) return state.selectedDate = "", state.selectedDateLabel = "", 
            state.selectedType = "", state.selectedSlot = null, state.finalCharge = 0, state.finalChargeLabel = "", 
            els.flow && (els.flow.hidden = !0), els.summary && (els.summary.hidden = !0), root.classList.remove("is-summary-mode"), 
            isEditingDeliverySelection && clearSelectionCache(), applyProperties(), toggleReset(), 
            setUnavailableMsg(resolvedPinValue), syncDeliveryFlowVisibility(), mobileLocation.input && (mobileLocation.input.value = getLocationLabel()), 
            mobileLocation.suggestions && (mobileLocation.suggestions.innerHTML = ""), syncMobileSheetState(), 
            void notifyProductLocationSelected();
            setMsg("Location found! We deliver to this area.", "success"), renderAll(), saveSelection(), 
            mobileLocation.open && (mobileLocation.input && (mobileLocation.input.value = getLocationLabel() || els.input && els.input.value || ""), 
            mobileLocation.suggestions && (mobileLocation.suggestions.innerHTML = ""), isCurrentLocationNonServiceable() ? setMobileUnavailableMsg(state.matchedLocation && state.matchedLocation.pincode) : setMobileLocationMessage("Location found! Choose delivery date and option.", "success"), 
            attachMobileDeliveryFlow(), syncMobileSheetState(), setTimeout(function() {
                els.dateOptions && mobileLocation.dialog && mobileLocation.dialog.contains(els.dateOptions) && els.dateOptions.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest"
                });
            }, 80)), notifyProductLocationSelected();
        }
        function applyExternalPincode(pin) {
            if (pin = extractPincode(pin), !/^\d{6}$/.test(pin)) return !1;
            if (String(state.matchedLocation && state.matchedLocation.pincode || "").trim() === pin) {
                if (isEditingDeliverySelection) return els.input && (els.input.value = getLocationLabel()), 
                mobileLocation.input && (mobileLocation.input.value = getLocationLabel()), !0;
                if (isReady()) {
                    var currentExpiry = getSelectionExpiry(state.selectedDate, state.selectedSlot);
                    if (currentExpiry && Date.now() < currentExpiry) return restoredSelectionLocked = !0, 
                    root.setAttribute("data-og-restored-lock", "true"), root.classList.add("is-summary-mode"), 
                    els.input && (els.input.value = getLocationLabel()), mobileLocation.input && (mobileLocation.input.value = getLocationLabel()), 
                    renderAll(), applyProperties(), toggleReset(), !0;
                }
            }
            var cached = readSelectionCache(), cachedPin = String(cached && cached.matchedLocation && cached.matchedLocation.pincode || "").trim();
            if (!isEditingDeliverySelection && cachedPin === pin && isSavedSelectionValid(cached)) return restoreSelection(), 
            !0;
            var token = ++externalPinApplyToken, row = findByPincode(pin) || buildExternalLocationRow(pin, null, pin);
            if (clearSuggestionState(), clearSelectionCache(), restoredSelectionLocked = !1, 
            isEditingDeliverySelection = !1, root.removeAttribute("data-og-restored-lock"), 
            root.classList.remove("is-summary-mode"), state.matchedLocation = null, clearSelectedSlotOnly(), 
            token !== externalPinApplyToken) return els.input && (els.input.value = pin), mobileLocation.input && (mobileLocation.input.value = pin), 
            renderAll(), !1;
            state.matchedLocation = Object.assign({}, row, {
                pincode: pin,
                selectedDisplayLabel: buildCanonicalRowLabel(row, pin)
            });
            if (!isServiceabilityValidationEnabled() && !isJsonMatchedLocation()) return clearSelectedSlotOnly(), els.input && (els.input.value = getLocationLabel()), 
            mobileLocation.input && (mobileLocation.input.value = getLocationLabel()), isEditingDeliverySelection = !0, 
            renderAll(), applyProperties(), saveDraftLocation(), toggleReset(), setMsg("Location found!", "success"), 
            syncMobileSheetState(), !0;
            var firstDate = getMinSelectableDate(state.matchedLocation), replacement = getReplacementDeliveryCandidate(state.matchedLocation, ymd(firstDate));
            if (!replacement) return state.selectedDate = ymd(firstDate), state.selectedDateLabel = formatSelectedDateLabel(firstDate), 
            els.input && (els.input.value = getLocationLabel()), mobileLocation.input && (mobileLocation.input.value = getLocationLabel()), 
            isEditingDeliverySelection = !0, renderAll(), !1 === state.matchedLocation.isJsonServiceable ? setUnavailableMsg(pin) : setMsg("Location found! Please choose an available delivery option.", "success"), 
            syncDeliveryFlowVisibility(), !0;
            state.selectedDate = replacement.dateKey;
            var selectedDateObj = makeDateFromKey(replacement.dateKey);
            return state.selectedDateLabel = selectedDateObj ? formatSelectedDateLabel(selectedDateObj) : replacement.dateKey, 
            state.selectedType = replacement.typeKey, state.selectedSlot = replacement.slot, 
            calculateCharges(), restoredSelectionLocked = !0, isEditingDeliverySelection = !1, 
            root.setAttribute("data-og-restored-lock", "true"), root.classList.add("is-summary-mode"), 
            els.input && (els.input.value = getLocationLabel()), mobileLocation.input && (mobileLocation.input.value = getLocationLabel()), 
            renderAll(), saveSelection(), applyProperties(), toggleReset(), setMsg("Location found! Nearest available delivery slot selected.", "success"), 
            !0;
        }
        function clearExternalPincode() {
            return resetAll({
                silentExternalClear: !0
            }), !0;
        }
        function askForExactPincode(inputLabel) {
            if (!isServiceabilityValidationEnabled() && String(inputLabel || "").trim()) return void chooseMatchedLocation(buildExternalLocationRow("", null, inputLabel), inputLabel, "");
            if (restoredSelectionLocked && !isEditingDeliverySelection) return els.input && (els.input.value = getLocationLabel()), 
            renderSummary(), root.classList.add("is-summary-mode"), void (els.summary && (els.summary.hidden = !1));
            state.matchedLocation = null, state.selectedDate = "", state.selectedDateLabel = "", 
            state.selectedType = "", state.selectedSlot = null, state.finalCharge = 0, state.finalChargeLabel = "", 
            els.input && (els.input.value = inputLabel || els.input.value || ""), els.suggestions && (els.suggestions.hidden = !0, 
            els.suggestions.innerHTML = ""), els.summary && (els.summary.hidden = !0), applyProperties(), 
            toggleReset(), isEditingDeliverySelection && clearSelectionCache(), setMsg("Location not found. Try city, area or exact 6-digit pincode.", "error"), 
            syncDeliveryFlowVisibility(), renderDateOptions();
        }
        function resolveFallbackLocation(item, selectionToken) {
            item = item || {}, selectionToken = selectionToken || locationSelectionToken;
            var baseLabel = String(item.selectedLabel || item.displayLabel || item.title || item.meta || item.googleLabel || "").trim();
            function askExact(parsed, label) {
                if (!isCurrentLocationSelection(selectionToken)) return;
                parsed = parsed || item || {};
                var locationLabel = buildTextLocationDropdownLabel(parsed.locality || item.locality || item.area || "", parsed.city || item.city || "", parsed.state || item.state || "", parsed.country || item.country || "India", els.input ? els.input.value : "") || label || baseLabel;
                if (!isServiceabilityValidationEnabled() && String(locationLabel || "").trim()) return endLocationSelection(selectionToken), 
                void chooseMatchedLocation(buildExternalLocationRow("", Object.assign({}, item, parsed), locationLabel), locationLabel, "");
                endLocationSelection(selectionToken), askForExactPincode(locationLabel), mobileLocation.open && shakeMobileLocationInput();
            }
            function finishWithPin(pin, parsed, label) {
                if (isCurrentLocationSelection(selectionToken)) if (pin = String(pin || "").trim(), 
                parsed = parsed || item || {}, label = String(label || parsed.label || baseLabel || "").trim(), 
                /^\d{6}$/.test(pin)) {
                    var exactRow = findByPincode(pin) || buildExternalLocationRow(pin, parsed, label), selectedFullLabel = buildReadableLocation([ pin, parsed.locality || item.locality || item.area || "", parsed.city || item.city || "", parsed.state || item.state || "", parsed.country || item.country || "India" ]) || buildResolvedLocationLabel(pin, label, parsed.city || item.city || "");
                    endLocationSelection(selectionToken) && chooseMatchedLocation(exactRow, selectedFullLabel, pin);
                } else askExact(parsed, label);
            }
            function tryPhoton(parsed, label) {
                if (isCurrentLocationSelection(selectionToken)) {
                    parsed = parsed || item || {}, label = label || baseLabel;
                    var directPhotonItem = "photon" === item.source ? item : null;
                    directPhotonItem ? resolvePhotonPincode(directPhotonItem, function(pin) {
                        isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(pin || "").trim()) ? finishWithPin(pin, parsed, label) : askExact(parsed, label));
                    }) : getFallbackLocationSuggestions(label, function(fallbackItems) {
                        if (isCurrentLocationSelection(selectionToken)) {
                            var best = (fallbackItems || [])[0];
                            if (best) {
                                var direct = String(best.pincode || "").trim();
                                /^\d{6}$/.test(direct) ? finishWithPin(direct, Object.assign({}, parsed, best), best.selectedLabel || label) : resolvePhotonPincode(best, function(pin) {
                                    isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(pin || "").trim()) ? finishWithPin(pin, Object.assign({}, parsed, best), best.selectedLabel || label) : resolveNominatimPincode(Object.assign({}, parsed, best), best.selectedLabel || label, function(nominatimPin, nominatimParsed) {
                                        isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(nominatimPin || "").trim()) ? finishWithPin(nominatimPin, Object.assign({}, parsed, best, nominatimParsed || {}), best.selectedLabel || label) : askExact(parsed, label));
                                    }));
                                });
                            } else askExact(parsed, label);
                        }
                    });
                }
            }
            var overridePin = getLocationPinOverride(baseLabel, item);
            if (/^\d{6}$/.test(overridePin)) finishWithPin(overridePin, item, baseLabel); else {
                var directPin = String(item.pincode || "").trim();
                /^\d{6}$/.test(directPin) || (directPin = extractPincode(baseLabel)), /^\d{6}$/.test(directPin) ? finishWithPin(directPin, item, baseLabel) : "google" !== item.source ? "photon" !== item.source ? resolveGoogleAndPostal(Object.assign({}, item, {
                    source: "google",
                    googleLabel: baseLabel,
                    selectedLabel: baseLabel,
                    displayLabel: baseLabel,
                    title: baseLabel
                }), baseLabel, function(pin, parsed, label) {
                    isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(pin || "").trim()) ? finishWithPin(pin, parsed, label || baseLabel) : tryPhoton(parsed || item, label || baseLabel));
                }) : resolveNominatimPincode(item, baseLabel, function(nominatimPin, nominatimParsed) {
                    isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(nominatimPin || "").trim()) ? finishWithPin(nominatimPin, Object.assign({}, item, nominatimParsed || {}), baseLabel) : resolvePhotonPincode(item, function(pin) {
                        var parsed, label;
                        isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(pin || "").trim()) ? finishWithPin(pin, item, baseLabel) : (parsed = item, 
                        label = baseLabel, isCurrentLocationSelection(selectionToken) && (parsed = parsed || item || {}, 
                        label = label || baseLabel, resolvePostalDirectoryPincode(Object.assign({}, item, parsed), label, function(pin, postalParsed) {
                            isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(pin || "").trim()) ? finishWithPin(pin, Object.assign({}, parsed, postalParsed || {}), label) : tryPhoton(parsed, label));
                        }))));
                    }));
                }) : resolveGoogleAndPostal(item, baseLabel, function(pin, parsed, label) {
                    isCurrentLocationSelection(selectionToken) && (/^\d{6}$/.test(String(pin || "").trim()) ? finishWithPin(pin, parsed, label || baseLabel) : tryPhoton(parsed || item, label || baseLabel));
                });
            }
        }
        function finishExternalVerifiedLocation(item, pin, parsed, label, selectionToken) {
            if (isCurrentLocationSelection(selectionToken = selectionToken || locationSelectionToken)) {
                if (pin = String(pin || "").trim(), parsed = parsed || item || {}, label = String(label || parsed.label || item.selectedLabel || item.displayLabel || item.title || "").trim(), 
                !/^\d{6}$/.test(pin)) {
                    var noPinLabel = buildTextLocationDropdownLabel(parsed.locality || item.locality || item.area || "", parsed.city || item.city || "", parsed.state || item.state || "", parsed.country || item.country || "India", els.input ? els.input.value : "") || label;
                    if (!isServiceabilityValidationEnabled() && String(noPinLabel || "").trim()) return endLocationSelection(selectionToken), 
                    void chooseMatchedLocation(buildExternalLocationRow("", Object.assign({}, item, parsed), noPinLabel), noPinLabel, "");
                    return endLocationSelection(selectionToken), askForExactPincode(noPinLabel), void (mobileLocation.open && shakeMobileLocationInput());
                }
                var exactRow = findByPincode(pin) || buildExternalLocationRow(pin, parsed, label), selectedFullLabel = buildReadableLocation([ pin, parsed.locality || item.locality || item.area || "", parsed.city || item.city || "", parsed.state || item.state || "", parsed.country || item.country || "India" ]) || buildResolvedLocationLabel(pin, label, parsed.city || item.city || "");
                endLocationSelection(selectionToken) && chooseMatchedLocation(exactRow, selectedFullLabel, pin);
            }
        }
        function verifyAreaSelectionWithGoogleThenPhoton(item, selectionToken) {
            item = item || {}, selectionToken = selectionToken || locationSelectionToken;
            var label = String(item.dropdownLabel || item.displayLabel || item.selectedLabel || item.title || "").trim();
            if (!label) return endLocationSelection(selectionToken), askForExactPincode(""), 
            void (mobileLocation.open && shakeMobileLocationInput());
            var sheetFallbackPin = String(item.pincode || item.row && item.row.pincode || "").trim();
            /^\d{6}$/.test(sheetFallbackPin) || (sheetFallbackPin = "");
            var overridePin = getLocationPinOverride(label, item);
            function finishWithSheetFallback(parsed, finalLabel) {
                isCurrentLocationSelection(selectionToken) && finishExternalVerifiedLocation(item, sheetFallbackPin || "", parsed || item, finalLabel || label, selectionToken);
            }
            function resolveGoogleCandidate(candidate) {
                isCurrentLocationSelection(selectionToken) && resolveGoogleAndPostal(candidate || {
                    source: "google",
                    selectedLabel: label,
                    displayLabel: label,
                    title: label,
                    googleLabel: label,
                    locality: item.locality || item.area || "",
                    city: item.city || "",
                    state: item.state || "",
                    country: item.country || "India",
                    pincode: ""
                }, label, function(pin, parsed, googleLabel) {
                    isCurrentLocationSelection(selectionToken) && (pin = String(pin || "").trim(), /^\d{6}$/.test(pin) ? finishExternalVerifiedLocation(item, pin, parsed, googleLabel || label, selectionToken) : function(parsed, finalLabel) {
                        isCurrentLocationSelection(selectionToken) && getFallbackLocationSuggestions(finalLabel || label, function(fallbackItems) {
                            if (isCurrentLocationSelection(selectionToken)) {
                                var best = (fallbackItems || [])[0];
                                if (best) {
                                    var directPin = String(best.pincode || "").trim();
                                    /^\d{6}$/.test(directPin) ? finishExternalVerifiedLocation(best, directPin, Object.assign({}, parsed || {}, best), best.selectedLabel || best.displayLabel || finalLabel || label, selectionToken) : resolvePhotonPincode(best, function(photonPin) {
                                        isCurrentLocationSelection(selectionToken) && (photonPin = String(photonPin || "").trim(), 
                                        /^\d{6}$/.test(photonPin) ? finishExternalVerifiedLocation(best, photonPin, Object.assign({}, parsed || {}, best), best.selectedLabel || best.displayLabel || finalLabel || label, selectionToken) : resolveNominatimPincode(Object.assign({}, parsed || {}, best), best.selectedLabel || best.displayLabel || finalLabel || label, function(nominatimPin, nominatimParsed) {
                                            isCurrentLocationSelection(selectionToken) && (nominatimPin = String(nominatimPin || "").trim(), 
                                            /^\d{6}$/.test(nominatimPin) ? finishExternalVerifiedLocation(best, nominatimPin, Object.assign({}, parsed || {}, best, nominatimParsed || {}), best.selectedLabel || best.displayLabel || finalLabel || label, selectionToken) : finishWithSheetFallback(parsed, finalLabel));
                                        }));
                                    });
                                } else finishWithSheetFallback(parsed, finalLabel);
                            }
                        });
                    }(parsed || item, googleLabel || label));
                });
            }
            /^\d{6}$/.test(overridePin) ? finishExternalVerifiedLocation(item, overridePin, item, label, selectionToken) : getGoogleLocationSuggestions(label, function(googleItems) {
                isCurrentLocationSelection(selectionToken) && resolveGoogleCandidate((googleItems || [])[0] || null);
            });
        }
        function handleSuggestionItemSelection(item) {
            if (item) {
                clearSuggestionState();
                var typedValue = els.input ? els.input.value.trim() : "", typedExactPin = typedValue.replace(/\s+/g, "");
                if (/^\d{6}$/.test(typedExactPin)) {
                    var typedRow = findByPincode(typedExactPin);
                    return typedRow ? void chooseMatchedLocation(typedRow, buildCanonicalRowLabel(typedRow, typedExactPin) || typedValue, typedExactPin) : void chooseMatchedLocation(buildExternalLocationRow(typedExactPin, null, typedValue), typedValue, typedExactPin);
                }
                var selectionToken = function(item) {
                    var token = ++locationSelectionToken;
                    clearTimeout(suggestionTimer), suggestionTimer = null, suggestionRequestId++, cancelFallbackLookup(), 
                    activeSuggestions = [], els.suggestions && (els.suggestions.hidden = !0, els.suggestions.innerHTML = ""), 
                    mobileLocation.suggestions && (mobileLocation.suggestions.innerHTML = "");
                    var label = cleanSuggestionLabel(item) || String(item && (item.selectedLabel || item.displayLabel || item.title) || "").trim();
                    return mobileLocation.input && label && (mobileLocation.input.value = label), setLocationResolving(!0), 
                    setMsg("Finding exact pincode...", ""), setMobileLocationMessage("Finding exact pincode...", ""), 
                    syncMobileSheetState(), token;
                }(item);
                if ("sheet" !== item.source) resolveFallbackLocation(item, selectionToken); else {
                    var match = item.row || (item.pincode ? findByPincode(item.pincode) : null);
                    match && !/^\d{6}$/.test(String(match.pincode || "").trim()) && (match = null);
                    var pin = String(item.pincode || match && match.pincode || "").trim(), locality = String(item.locality || item.area || "").trim(), city = String(item.city || "").trim(), specificArea = !(!/^\d{6}$/.test(pin) || !locality || normalize(locality) === normalize(city));
                    if (item.isPincodeQuery || specificArea) {
                        if (!endLocationSelection(selectionToken)) return;
                        return void chooseMatchedLocation(match, item.selectedLabel || item.displayLabel || item.title, pin);
                    }
                    verifyAreaSelectionWithGoogleThenPhoton(item, selectionToken);
                }
            }
        }
        function handleRawInputLookup() {
            if (restoredSelectionLocked && !isEditingDeliverySelection) return els.input && (els.input.value = getLocationLabel()), 
            renderSummary(), root.classList.add("is-summary-mode"), void (els.summary && (els.summary.hidden = !1));
            var value = els.input ? els.input.value.trim() : "";
            if (value) {
                var pin = extractPincode(value);
                if (pin) {
                    clearSuggestionState();
                    var match = findByPincode(pin);
                    match ? chooseMatchedLocation(match, buildCanonicalRowLabel(match, pin) || value, pin) : chooseMatchedLocation(buildExternalLocationRow(pin, null, value), value, pin);
                } else if (!isServiceabilityValidationEnabled() && value.length >= 3) clearSuggestionState(), 
                chooseMatchedLocation(buildExternalLocationRow("", null, value), value, ""); else setMsg("Select a location suggestion or enter an exact 6-digit pincode.", "");
            }
        }
        function handleSubmit(e) {
            if (canProceedWithoutDeliverySelection()) return applyProperties(), saveDraftLocation(), !0;
            if (isCurrentLocationNonServiceable()) {
                if (!isServiceabilityValidationEnabled()) return applyProperties(), !0;
                return e && (e.preventDefault(), e.stopPropagation(), "function" == typeof e.stopImmediatePropagation && e.stopImmediatePropagation()), 
                setUnavailableMsg(state.matchedLocation && state.matchedLocation.pincode || extractPincode(els.input && els.input.value || "")), 
                syncDeliveryFlowVisibility(), !1;
            }
            return isReady() ? (calculateCharges(), applyProperties(), saveSelection(), scheduleNativeFeeSync(1500), 
            !0) : (e && (e.preventDefault(), e.stopPropagation(), "function" == typeof e.stopImmediatePropagation && e.stopImmediatePropagation()), 
            focusFirstMissingDeliveryStep(), !1);
        }
        function bindEvents() {
            var backButton = document.getElementById('ogCalendarBack');
            backButton && backButton.addEventListener('click', function() {
                renderCalendar(); setCalendarStep('calendar');
                var selected = els.calendarDays.querySelector('.is-selected:not(:disabled)') || els.calendarDays.querySelector('[data-og-calendar-date]:not(:disabled)');
                if (selected) selected.focus({preventScroll:true});
            });
            els.calendarPanel && els.calendarPanel.addEventListener('cancel', function(event) { event.preventDefault(); closeCalendar(); });
            els.calendarPanel && els.calendarPanel.addEventListener('keydown', function(event) {
                if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); closeCalendar(); return; }
                if (event.key !== 'Tab') return;
                var nodes = Array.from(els.calendarPanel.querySelectorAll('button:not([disabled]):not([tabindex="-1"])')).filter(function(n){return n.getClientRects().length;});
                var first = nodes[0], last = nodes[nodes.length - 1];
                if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last.focus();}
                else if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first.focus();}
            });
            els.input && (els.input.addEventListener("input", function(e) {
                clearDeliveryValidation(), locationResolving && e && !0 === e.isTrusted && (locationSelectionToken++, 
                cancelFallbackLookup(), setLocationResolving(!1));
                var value = els.input.value.trim();
                return !value && state.matchedLocation && e && !1 === e.isTrusted ? (els.input.value = getLocationLabel(), 
                void toggleReset()) : !restoredSelectionLocked || isEditingDeliverySelection || mobileLocation.open ? (beginLocationEdit(), toggleReset(), 
                state.matchedLocation = null, state.selectedDate = "", state.selectedDateLabel = "", 
                state.selectedType = "", state.selectedSlot = null, els.summary && (els.summary.hidden = !0), 
                syncDeliveryFlowVisibility(), renderDateOptions(), applyProperties(), clearTimeout(suggestionTimer), 
                suggestionTimer = null, suggestionRequestId++, cancelFallbackLookup(), value.length < 3 ? (renderSuggestions([]), 
                els.typeOptions && (els.typeOptions.innerHTML = ""), els.slotOptions && (els.slotOptions.innerHTML = ""), 
                els.slotTitle && (els.slotTitle.textContent = ""), void setMsg("", "")) : (setMsg("Searching delivery locations...", ""), 
                void (suggestionTimer = setTimeout(function() {
                    showCombinedSuggestions(value);
                }, Math.max(180, Number(config.locationSuggestionDebounceMs || 280)))))) : (clearTimeout(suggestionTimer), activeSuggestions = [], els.suggestions && (els.suggestions.hidden = !0, 
                els.suggestions.innerHTML = ""), els.input && (els.input.value = getLocationLabel()), 
                setMsg("Location found! We deliver to this area.", "success"), renderSummary(), 
                applyProperties(), toggleReset(), root.setAttribute("data-og-restored-lock", "true"), 
                root.classList.add("is-summary-mode"), void (els.summary && (els.summary.hidden = !1)));
            }), els.input.addEventListener("keydown", function(e) {
                "Enter" === e.key && (e.preventDefault(), activeSuggestions && activeSuggestions.length ? handleSuggestionItemSelection(activeSuggestions[0]) : handleRawInputLookup());
            }), els.input.addEventListener("blur", function() {
                setTimeout(function() {
                    els.suggestions && (els.suggestions.hidden = !0);
                }, 180);
            }), els.input.addEventListener("focus", function(e) {
                if (isMobileLocationModalEnabled()) {
                    if (!e || !0 !== e.isTrusted) return;
                    openMobileLocationSheet(!0);
                } else activeSuggestions.length && els.suggestions && (els.suggestions.hidden = !1);
            }), els.input.addEventListener("click", function(e) {
                if (isMobileLocationModalEnabled()) {
                    if (!e || !0 !== e.isTrusted) return;
                    openMobileLocationSheet(!0);
                }
            })), els.suggestions && (els.suggestions.addEventListener("mousedown", function(e) {
                e.preventDefault();
            }), els.suggestions.addEventListener("click", function(e) {
                var btn = e.target.closest("[data-og-suggestion-index]");
                if (btn) {
                    var item = activeSuggestions[Number(btn.getAttribute("data-og-suggestion-index"))];
                    item && handleSuggestionItemSelection(item);
                }
            })), els.reset && els.reset.addEventListener("click", function(e) {
                e && !0 === e.isTrusted && resetAll();
            }), els.dateOptions && els.dateOptions.addEventListener("click", function(e) {
                if (e && !0 === e.isTrusted) {
                    var btn = e.target.closest("[data-og-date]");
                    btn && !btn.disabled && (restoredSelectionLocked = !1, root.removeAttribute("data-og-restored-lock"), 
                    isEditingDeliverySelection = !0, selectDateValue(btn.getAttribute("data-og-date")));
                }
            }), els.typeOptions && els.typeOptions.addEventListener("click", function(e) {
                if (e && !0 === e.isTrusted) {
                    var slotBtn = e.target.closest("[data-og-inline-slot-index]");
                    if (slotBtn) {
                        var slotType = slotBtn.getAttribute("data-og-inline-slot-type");
                        if (!slotType) return;
                        var inlineSlot = getFilteredSlotsForType(slotType, state.selectedDate)[Number(slotBtn.getAttribute("data-og-inline-slot-index"))];
                        if (!inlineSlot) return;
                        return state.selectedType = slotType, state.selectedSlot = inlineSlot, isEditingDeliverySelection = !1, 
                        renderAll(), saveSelection(), void closeCalendar();
                    }
                    var btn = e.target.closest("[data-og-type]");
                    if (btn) {
                        var typeKey = btn.getAttribute("data-og-type"), slots = getFilteredSlotsForType(typeKey, state.selectedDate);
                        if (slots.length) {
                            if (1 === slots.length) return state.selectedType === typeKey && !state.selectedSlot ? (state.selectedType = "", state.selectedSlot = null, void renderAll()) : (state.selectedType = typeKey, state.selectedSlot = null, isEditingDeliverySelection = !0, void renderAll());
                            if (state.selectedType === typeKey) return state.selectedType = "", state.selectedSlot = null, 
                            void renderAll();
                            state.selectedType = typeKey, state.selectedSlot = null, isEditingDeliverySelection = !0, 
                            renderAll();
                        }
                    }
                }
            }), els.slotOptions && els.slotOptions.addEventListener("click", function(e) {
                if (e && !0 === e.isTrusted) {
                    var btn = e.target.closest("[data-og-slot-index]");
                    if (btn && state.selectedType) {
                        var slot = getFilteredSlotsForType(state.selectedType, state.selectedDate)[Number(btn.getAttribute("data-og-slot-index"))];
                        slot && (state.selectedSlot = slot, isEditingDeliverySelection = !1, renderAll(), 
                        saveSelection(), closeCalendar());
                    }
                }
            }), els.modify && els.modify.addEventListener("click", function(e) {
                if (e && !0 === e.isTrusted) {
                    selectDateValue('calendar');
                }
            }), els.calendarOverlay && els.calendarOverlay.addEventListener("click", closeCalendar), 
            els.calendarClose && els.calendarClose.addEventListener("click", closeCalendar), 
            els.calendarPrev && els.calendarPrev.addEventListener("click", function() {
                state.calendarMonth && (state.calendarMonth = new Date(state.calendarMonth.getFullYear(), state.calendarMonth.getMonth() - 1, 1), 
                renderCalendar());
            }), els.calendarNext && els.calendarNext.addEventListener("click", function() {
                state.calendarMonth && (state.calendarMonth = new Date(state.calendarMonth.getFullYear(), state.calendarMonth.getMonth() + 1, 1), 
                renderCalendar());
            }), els.calendarDays && els.calendarDays.addEventListener("click", function(e) {
                var btn = e.target.closest("[data-og-calendar-date]");
                btn && !btn.disabled && selectDateValue(btn.getAttribute("data-og-calendar-date"));
            }), document.addEventListener("click", function(e) {
                if (els.calendarPanel) {
                    if (e.target.closest("#ogCalendarClose, #ogCalendarOverlay, .og-calendar__close, .og-calendar__overlay")) return e.preventDefault(), 
                    void closeCalendar();
                }
            }, !0), productForm && productForm.addEventListener("submit", handleSubmit, !0), 
            document.addEventListener("submit", function(e) {
                var form = e.target;
                form && form.matches && form.matches('form[action*="/cart/add"]') && root && document.body.contains(root) && handleSubmit(e);
            }, !0), document.addEventListener("click", function(e) {
                var purchaseControl = function(target) {
                    if (!target || !target.closest) return null;
                    var explicit = target.closest('.shopify-payment-button__button,[data-buy-now],[data-add-to-cart],[data-og-buy-now],button[name="add"],input[name="add"],.buy-now,.buy-now-button,.add-to-cart,.add-to-cart-button,[class*="buy-now"],[class*="buy_now"],[class*="add-to-cart"],[id*="buy-now"],[id*="buy_now"],[id*="add-to-cart"]');
                    if (explicit) return explicit;
                    var control = target.closest('button,input[type="submit"],a,[role="button"]');
                    if (!control) return null;
                    var label = normalize(control.value || control.textContent || control.getAttribute("aria-label") || "");
                    return /^(buy now|buy it now|add to cart|add to bag|proceed to buy)$/.test(label) ? control : null;
                }(e.target);
                if (purchaseControl && root && document.body.contains(root)) {
                    if (addonNextStepTriggering) return;
                    var purchaseLabel = normalize(purchaseControl.value || purchaseControl.textContent || purchaseControl.getAttribute("aria-label") || ""), isBuyNowControl = /\bbuy\s*(now|it\s*now)\b/.test(purchaseLabel) || !!(purchaseControl.matches && purchaseControl.matches('.shopify-payment-button__button,[data-buy-now],[data-og-buy-now],.buy-now,.buy-now-button,[class*="buy-now"],[class*="buy_now"],[id*="buy-now"],[id*="buy_now"]'));
                    if (canProceedWithoutDeliverySelection()) {
                        applyProperties(), saveDraftLocation();
                        if (isBuyNowControl) return e.preventDefault(), e.stopPropagation(), "function" == typeof e.stopImmediatePropagation && e.stopImmediatePropagation(), void triggerAddonNextStep();
                        return;
                    }
                    if (isCurrentLocationNonServiceable()) {
                        if (!isServiceabilityValidationEnabled()) return void applyProperties();
                        return e.preventDefault(), e.stopPropagation(), "function" == typeof e.stopImmediatePropagation && e.stopImmediatePropagation(), 
                        setUnavailableMsg(state.matchedLocation && state.matchedLocation.pincode || extractPincode(els.input && els.input.value || "")), 
                        syncDeliveryFlowVisibility(), !1;
                    }
                    if (!isReady()) return e.preventDefault(), e.stopPropagation(), "function" == typeof e.stopImmediatePropagation && e.stopImmediatePropagation(), 
                    focusFirstMissingDeliveryStep(), !1;
                    calculateCharges(), applyProperties(), saveSelection(), scheduleNativeFeeSync(1500);
                    if (isBuyNowControl) return e.preventDefault(), e.stopPropagation(), "function" == typeof e.stopImmediatePropagation && e.stopImmediatePropagation(), void triggerAddonNextStep();
                }
            }, !0), document.addEventListener("visibilitychange", function() {
                document.hidden || (markFeeLinesInDom(), refreshActiveDeliverySelection(), !isEditingDeliverySelection && readSelectionCache() ? restoreSelection() : renderAll());
            });
        }
    }
    window.__initOgDeliveryCore = initOgDelivery, "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", initOgDelivery) : initOgDelivery(), 
    window.addEventListener("pageshow", initOgDelivery);
}(), function() {
    "use strict";
    var checkoutInProgress = !1, savedMessageHtml = null, savedMessageClass = null, messageWasSuppressed = !1;
    function normalizeText(value) {
        return String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
    }
    function isProductFormButton(element) {
        return !(!element || !element.closest) && !!element.closest('form[action*="/cart/add"]');
    }
    function isInsideDeliveryWidget(element) {
        return !(!element || !element.closest) && !!element.closest("#og-delivery-widget");
    }
    function getCheckoutButton(target) {
        if (!target || !target.closest) return null;
        var checkoutButton = target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"],[name="checkout"],.cart__checkout-button,.cart-drawer__checkout,.checkout-button,.cart-checkout,[data-cart-checkout],[data-checkout-button],[data-testid="Checkout-button"]');
        if (checkoutButton) return isProductFormButton(checkoutButton) || isInsideDeliveryWidget(checkoutButton) ? null : checkoutButton;
        var genericButton = function(target) {
            return target && target.closest ? target.closest('button,a,input[type="submit"],input[type="button"]') : null;
        }(target);
        if (!genericButton) return null;
        if (isProductFormButton(genericButton)) return null;
        if (isInsideDeliveryWidget(genericButton)) return null;
        var text = normalizeText(genericButton.textContent || genericButton.value || ""), href = normalizeText(genericButton.getAttribute("href") || ""), name = normalizeText(genericButton.getAttribute("name") || ""), ariaLabel = normalizeText(genericButton.getAttribute("aria-label") || ""), title = normalizeText(genericButton.getAttribute("title") || "");
        return href.indexOf("/checkout") > -1 || "checkout" === name || "checkout" === text || "check out" === text || text.indexOf("checkout") > -1 || text.indexOf("check out") > -1 || ariaLabel.indexOf("checkout") > -1 || ariaLabel.indexOf("check out") > -1 || title.indexOf("checkout") > -1 || title.indexOf("check out") > -1 ? genericButton : null;
    }
    function suppressUnavailableMessage() {
        var message = document.getElementById("ogInlineMessage");
        if (message) {
            var text = normalizeText(message.textContent || "");
            -1 === text.indexOf("delivery is not available") && -1 === text.indexOf("this product cannot be delivered") || (messageWasSuppressed || (savedMessageHtml = message.innerHTML, 
            savedMessageClass = message.className), messageWasSuppressed = !0, message.innerHTML = '<span data-og-checkout-temp-message="true">Proceeding to checkout...</span>', 
            message.className = "og-delivery__inline-message");
        }
    }
    function restoreUnavailableMessage() {
        if (messageWasSuppressed) {
            var message = document.getElementById("ogInlineMessage");
            message && (null !== savedMessageHtml && (message.innerHTML = savedMessageHtml), 
            null !== savedMessageClass && (message.className = savedMessageClass)), savedMessageHtml = null, 
            savedMessageClass = null, messageWasSuppressed = !1;
        }
    }
    function showCheckoutLoading(button) {
        button && (button.hasAttribute("data-og-checkout-old-html") || button.setAttribute("data-og-checkout-old-html", button.innerHTML || ""), 
        button.hasAttribute("data-og-checkout-old-value") || button.setAttribute("data-og-checkout-old-value", button.value || ""), 
        "INPUT" === button.tagName ? button.value = "Redirecting..." : button.innerHTML = "⏳ Redirecting...", 
        button.style.pointerEvents = "none", button.style.opacity = "0.75", button.setAttribute("aria-disabled", "true"));
    }
    function restoreCheckoutButton(button) {
        if (button) {
            var oldHtml = button.getAttribute("data-og-checkout-old-html"), oldValue = button.getAttribute("data-og-checkout-old-value");
            "INPUT" === button.tagName && null !== oldValue ? button.value = oldValue : null !== oldHtml && (button.innerHTML = oldHtml), 
            button.style.pointerEvents = "", button.style.opacity = "", button.removeAttribute("aria-disabled"), 
            button.removeAttribute("data-og-checkout-old-html"), button.removeAttribute("data-og-checkout-old-value");
        }
    }
    window.addEventListener("pointerdown", function(event) {
        getCheckoutButton(event.target) && suppressUnavailableMessage();
    }, !0), window.addEventListener("click", function(event) {
        var checkoutButton = getCheckoutButton(event.target);
        if (checkoutButton) return event.preventDefault(), event.stopPropagation(), "function" == typeof event.stopImmediatePropagation && event.stopImmediatePropagation(), 
        checkoutInProgress || (checkoutInProgress = !0, suppressUnavailableMessage(), showCheckoutLoading(checkoutButton), 
        window.location.replace("/checkout"), setTimeout(function() {
            checkoutInProgress = !1, restoreCheckoutButton(checkoutButton), restoreUnavailableMessage();
        }, 4e3)), !1;
    }, !0), window.addEventListener("keydown", function(event) {
        "Enter" !== event.key && " " !== event.key || getCheckoutButton(event.target) && suppressUnavailableMessage();
    }, !0), window.addEventListener("submit", function(event) {
        var form = event.target;
        if (form && form.matches && !form.matches('form[action*="/cart/add"]')) {
            var submitter = event.submitter || null, checkoutButton = submitter ? getCheckoutButton(submitter) : null, action = normalizeText(form.getAttribute("action") || "");
            if (!!checkoutButton || action.indexOf("/checkout") > -1) return event.preventDefault(), 
            event.stopPropagation(), "function" == typeof event.stopImmediatePropagation && event.stopImmediatePropagation(), 
            checkoutInProgress || (checkoutInProgress = !0, suppressUnavailableMessage(), submitter && showCheckoutLoading(submitter), 
            window.location.replace("/checkout")), !1;
        }
    }, !0), window.addEventListener("pageshow", function() {
        checkoutInProgress = !1, restoreUnavailableMessage(), document.querySelectorAll("[data-og-checkout-old-html],[data-og-checkout-old-value]").forEach(function(button) {
            restoreCheckoutButton(button);
        });
    });
}(), function() {
    "use strict";
    var CUSTOM_ID = "ogRakhiUnavailableDeliveryMessage";
    function normalizeOgText(value) {
        return String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
    }
    function removeCustomMessage() {
        var custom = document.getElementById(CUSTOM_ID);
        custom && custom.parentNode && custom.parentNode.removeChild(custom);
    }
    function restoreOriginalMessage(message) {
        message && "true" === message.getAttribute("data-og-rakhi-unavailable-hidden") && (message.style.removeProperty("display"), 
        message.removeAttribute("data-og-rakhi-unavailable-hidden"));
    }
    function syncRakhiMessage() {
        var message = document.getElementById("ogInlineMessage");
        if (message) {
            if (!function() {
                var productTitle = "", titleNode = document.querySelector("h1.product__title, h1.product-title, [data-product-title], .product-title h1");
                titleNode && (productTitle = titleNode.textContent || "");
                var source = [ window.location.pathname || "", window.location.href || "", document.title || "", productTitle ].join(" ");
                return /rakhi/i.test(source);
            }()) return removeCustomMessage(), void restoreOriginalMessage(message);
            if (function(message) {
                if (!message) return !1;
                var text = normalizeOgText(message.textContent);
                return text.indexOf("this product cannot be delivered") > -1 || text.indexOf("delivery is not available") > -1;
            }(message)) return message.style.setProperty("display", "none", "important"), message.setAttribute("data-og-rakhi-unavailable-hidden", "true"), 
            void ("yes" === normalizeOgText("no") ? function(message) {
                var custom = document.getElementById(CUSTOM_ID);
                custom || ((custom = document.createElement("div")).id = CUSTOM_ID, custom.className = "og-delivery__inline-message", 
                custom.innerHTML = "Delivery available · <strong>3–5 working days</strong>", custom.style.fontSize = "15px", 
                custom.style.lineHeight = "1.5", message.parentNode.insertBefore(custom, message.nextSibling)), 
                custom.innerHTML = "Delivery available · <strong>3–5 working days</strong>", custom.style.fontSize = "15px", 
                custom.style.lineHeight = "1.5", custom.style.removeProperty("display");
            }(message) : removeCustomMessage());
            removeCustomMessage(), restoreOriginalMessage(message);
        } else removeCustomMessage();
    }
    var observedMessage = null, messageObserver = null;
    function observeMessage() {
        var message = document.getElementById("ogInlineMessage");
        message && (message !== observedMessage ? (messageObserver && messageObserver.disconnect(), 
        observedMessage = message, (messageObserver = new MutationObserver(function() {
            setTimeout(syncRakhiMessage, 0);
        })).observe(message, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0,
            attributeFilter: [ "class" ]
        }), syncRakhiMessage()) : syncRakhiMessage());
    }
    function init() {
        observeMessage(), document.body && new MutationObserver(function() {
            var current = document.getElementById("ogInlineMessage");
            current && current !== observedMessage && observeMessage();
        }).observe(document.body, {
            childList: !0,
            subtree: !0
        });
    }
    "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", init, {
        once: !0
    }) : init();
}();